import React from 'react';
import moment from 'moment';
import FilterVM from '../FilterVM/FilterVM.jsx';
import ChangeTicketType from 'components/ChangeTicketType/ChangeTicketType.jsx';
import FilterChassis from '../FilterChassis/FilterChassis';
import { createBrowserHistory } from "history";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import bootbox from 'bootbox';
import '../../css/ticket.css';
import 'jquery-validation/dist/jquery.validate.min.js';
import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/themes/base/all.css";
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css';
import 'select2/dist/css/select2.min.css';
import 'select2/dist/js/select2.min.js';
import TicketTableFirebird from 'components/Tabelle/TicketTableFirebird.jsx';
const env = require("../../config.js").default;
const common = require('../common/common.jsx');
var tus = require("tus-js-client");
const multibrand = require('../common/multibrand.js');

class PageTicketFirebird extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.keyComments = -1;
    this.state.editTicket = false;
    this.state.userInfo = {};
    this.state.batchingAdvanced = false;
    this.state.newTypeData = null;
    this.state.changeType = false
    this.state.adminLoaded = false
    this.state.isTable = false
    this.state.selectedCausale= ""
    this.state.isChanged = false
    this.state.userInfo.roles = [];
    this.state.selectedStates = ["closed", "incomplete", "pending", "published"]
    this.uploadPercentages = {};
    this.state.isTicketVehicle = false; //AGGIUNGERE METODO DINAMICO PER INDIVIDUARE TICKET-TICKET_VEHICLE
    this.state.newTicket = this.props.newTicket != undefined ? this.props.newTicket : false;
    this.state.pageTitle = this.props.pageTitle;
    this.state.userInfo.userInfo = {};
    this.dataFromModal = this.dataFromModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderModal = this.renderFormTicket.bind(this);
    this.populateModal = this.populateForm.bind(this)
    this.state.pageContent = structuredClone(this.props.pageContent); //deepCopy della props perche javascript fa schifo
    this.state.Lock = this.props.Lock;
    this.state.subType = null
    this.state.pagina = {
      pagina_attuale: 1,
      tipo_ordinamento: 'modified', //Capire tipo ordinamento iniziale
      verso_ordinamento: -1, // Idem come sopra
      filtra_risultati: true,
      batchingAdvanced: false,
      testo_cercato: '',
    };
    try {
      this.state.pageContent.BDOCU = JSON.parse(this.props.pageContent.BDOCU);
    } catch (e) {
      this.state.pageContent.BDOCU = {};
    }
    this.state.pathname = this.props.pathname;
    this.state.tipologie_ticket_attive = this.props.tipologie_ticket_attive;
    this.state.tagliando = {};
    this.state.checkVinVehicle = false;
    this.state.autoCompleteForm = false;
    this.state.googleCloudBucketPath = (window.cc.frontendCustomization.bucket_google + 'support-tools/ticket/');
    this.state.uploadAttempts = {}
    this.state.mySwanSelectedUrls = [];
    this.state.mySwanImages = [];
    this.state.myswanfilter = '';
    this.state.mySwanDeleteAfterSave = false;
    this.state.mySwanLoading = false;
    if (!this.state.newTicket) {
      var tipologia = this.state.pageContent["CCAUS"];
      this.state.subType = this.state.pageContent["CSCAU"];
    } else {
      var tipologia = ""
    }
    this.state.tipoTicket = tipologia

    common.getUserInfo().then(userInfo => {
      this.setState({ userInfo: userInfo });
    })

    var brand = this.props.marche_attive[0].ZFORN;

    this.state.marcaDefault = brand

    if (common.get_localStorage("sisterCompany") !== undefined && common.get_localStorage("sisterCompany") !== null)
       window.cc.sisterCompany = JSON.parse(common.get_localStorage("sisterCompany"));

    if (window.cc.sisterCompany !== undefined && window.cc.sisterCompany.length > 0 && !this.state.newTicket) {
       var csoft_sister = this.state.pageContent.CSOFT;
       var numSisterCompany = common.object_value_in_array(window.cc.sisterCompany, 'CSOFT', csoft_sister);
       var csoftGroup = window.cc.sisterCompany[numSisterCompany].CSOFT + ' - ' + window.cc.sisterCompany[numSisterCompany].RSOCI;

       this.state.csoftGroup = csoftGroup
     }

    this.arrayStatiDiagnosi = {
      "05": {
          "name": common.getTrad("Seriale in attesa di elaborazione"),
          "description": common.getTrad("Seriale in attesa di elaborazione"),
          "image": "fa-sync",
          "color": "black"
      },
      "11": {
          "name": common.getTrad("Seriale da correggere"),
          "description": common.getTrad("Seriale da correggere"),
          "image": "fa-exclamation-triangle",
          "color": "orange"
      },
      "60": {
          "name": common.getTrad("Seriale cancellato"),
          "description": common.getTrad("Seriale Cancellato"),
          "image": "fa-times",
          "color": "red"
      },
      "90": {
          "name": common.getTrad("Seriale attivato"),
          "description": common.getTrad("Seriale attivato"),
          "image": "fa-check",
          "color": "green"
      },
    };
  }


  renderTestataDocumento() {
    var numMarca = 0
    if (window.cc.marche_attive !== undefined && window.cc.marche_attive !== null)
      numMarca = common.object_value_in_array(window.cc.marche_attive, 'ZFORN', this.state.marcaDefault)
    return (
      <>
        <div className="row">
          {window.cc.marche_attive !== undefined && window.cc.marche_attive.length > 1 ?
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <b>{common.getTrad("Marca")}:</b>&nbsp;{window.cc.marche_attive[common.object_value_in_array(window.cc.marche_attive, 'ZFORN', this.state.pageContent.ZFORN)].DFORN}
              </div>
            </div>
            :
            <></>
          }
          {this.state.userInfo !== undefined && this.state.userInfo.userInfo.GTSFINI.PORTALE_SISTER_COMPANY && !this.state.userInfo.is_admin_ticket_group ?
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <b>{common.getTrad("Sister Company")}:</b>&nbsp;{this.state.csoftGroup}
              </div>
            </div>
            :
            <></>
          }
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="form-group">
              <b>{common.getTrad("ID Ticket")}:</b>&nbsp;
              {this.state.pageContent?.ID}
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="form-group">
              <b>{common.getTrad("Pubblicato da")}:</b>&nbsp;{this.state.pageContent?.RUSER}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="form-group">
              <b>{common.getTrad("Tipo")}:</b>&nbsp;
              {this.state.newTypeData ? this.state.tipologie_ticket_attive[this.state.newTypeData.tipo].titolo : this.state.tipologie_ticket_attive[this.state.pageContent.CCAUS].titolo}
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="form-group">
              <b>{common.getTrad("Ultima modifica")}:</b>&nbsp;<span>{moment(this.state.pageContent?.ULUPD).format('LLL')}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <div className="form-group">
              <b>{common.getTrad("Stato")}:</b>&nbsp; <span dangerouslySetInnerHTML={{ __html: this.statoTicket() + this.bannerChiusura()}} />
                <span>
                  <div className="modal fade" id="modalErrors" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title">{common.getTrad('Errori da correggere')}</h5>
                        </div>
                        <div className="modal-body">
                        <table className='errorTable'>
                          <tr>
                            <th>{common.getTrad('Nome campo')}</th>
                            <th>{common.getTrad('Tipo errore')} </th>
                          </tr>
                          {this.missingFieldsMsg()}
                        </table>
                        </div>
                        <div className="modal-footer">
                          <button type="submit" class="btn btn-default btn-default pull-left" data-dismiss="modal">  {common.getTrad('Chiudi')}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="form-group">
              <b>{common.getTrad("Data pubblicazione")}:</b>&nbsp;<span>{moment(this.state.pageContent?.UTRAS ? this.state.pageContent?.UTRAS : this.state.pageContent?.UINSR).format('LLL')}</span>
            </div>
          </div>
        </div>
        <div className="row">
          {this.state.userInfo.is_admin_ticket ?
          <div className="col-xs-12 col-md-6">
            <div className="form-group">
              <b>{common.getTrad("Data presa in carico")}:</b>&nbsp;<span>{this.state.pageContent?.UFSPC ? moment(this.state.pageContent?.UFSPC).format('LLL') : ''}</span>
            </div>
          </div>

          :
          <></>
          }
          {this.state.userInfo.is_admin_ticket ?
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <b>{common.getTrad("Data Richiesta")}:</b>&nbsp;<span>{this.state.pageContent?.URICH ? moment(this.state.pageContent?.URICH).format('LLL') : ''}</span>
              </div>
            </div>

            :
            <></>
          }
        </div>
        <div className="row" style={{ paddingBottom: '30px' }}>
          {this.state.pageContent?.UCLOS ?
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <b>{common.getTrad("Data Chiusura")}:</b>&nbsp;<span>{this.state.pageContent?.UCLOS ? moment(this.state.pageContent?.UCLOS).format('LLL') : ''}</span>
              </div>
            </div>

            :
            <></>
          }
        </div>
      </>
    )
  }

  
  getTableRimappature() {
    const $ = window.$;
    
    const arrayStati = {
      "00": {
        "name": common.getTrad('Incompleto'),
      },
      "03": {
        "name": common.getTrad('Pronto da chiudere'),
      },
      "10": {
        "name": common.getTrad('Chiuso'),
      },
    };
  
    const ctColPosition = [
      "ctZMAVE",
      "ctNDOCU",
      "ctUDOCU",
      "ctCARTI",
      "ctDRIGA",
      "ctNKMPE",
      "ctCVEIC",
      "ctDVEIC",
      "ctNTELA",
      "ctNTARG",
      "ctUTRAS",
      "ctNDRIF",
      "ctDAGG1",
      "ctCAVGA"
    ];

    if ($.fn.dataTable.isDataTable("#RMtable"))
      return false;

    var login, headers = {};

    login = common.getLocalLoginToken();
    if (login === false) {
      return false;
    }

    headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': common.getLanguage(true),
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
    };

    headers.authorization = "Bearer " + login;
    var apStr, apDim, apNum;
    const ZERI_NUMERO_DOCUMENTO = "00000"
    $("#RMtable").DataTable({
      //"order": [[ctColPosition.indexOf("cwUDOCU"), "desc"]],
      "deferRender": true,
      "scroller":     true,
      "serverSide": true,
      "scrollY": "40vh",
      "bAutoWidth": false,
      "paging": false,
      "searching": false,
      "info": false,
      "pageLength": env.TABLE_PAGE_LENGTH,
      "bScrollCollapse": false,
      "processing": true,
      "language": {
        "url": env.STATIC + "lib/datatables/i18n/" + common.getLanguage() + ".lang"
      },
          "ajax": {
            url: env.BACKEND + "@sw-get-history-RM",
            dataType: 'json',
            headers: headers,
            dataSrc: "",
            data: (data) => {
              data.FSTAT = '';
              data.TCONS = 'CRUS';
              data.TVIEW = 'CRUS';
              data.NTELA = this.state.pageContent.NTELA;
              var order = "";
              var orderSettings = $('#RMtable').DataTable().order();
              for (var i=0; i<orderSettings.length; i++){
                if(order !== "")
                  order = order + ",";
                var orderColumn = $('#RMtable').DataTable().column(orderSettings[i][0]).dataSrc();
                order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
              }
              data.OrderPage = order;
            }
          },
          "columns": [
            {
              "title": common.getTrad("Marca"),
              "data": "ZMAVE",
              "visible": multibrand.is_multibrand_portal(),
              "targets": ctColPosition.indexOf("ctZMAVE"),
              "render": function ( data, type, row ) {
                var brand = row.ZMAVE
                if (brand === undefined || brand.length === null)
                  brand = this.state.marcaDefault;

                if (type !== "display")
                  return brand;

                var indexBrand = common.object_value_in_array(window.cc.marche_portale, 'ZFORN', brand);
                if (window.cc.marche_portale !== undefined && window.cc.marche_portale[indexBrand] !== undefined) {
                  let text = window.cc.marche_portale[indexBrand].DFORN
                  return '<img class="tableBrandImg" title="' + text + '" alt="' + text + '" src="' + env.SWAN + 'static/images/loghi/' + brand.toLowerCase() + '.png"/>';
                }
                else
                  return brand;
              }
            },
            {
              "title": common.getTrad("N. Documento"),
              "data": "NDOCU",
              "targets": ctColPosition.indexOf("ctNDOCU"),
              "width": "100px",
              "orderable": true,
              "visible": true,
              "render": function ( data, type, row ) {
                apStr = row.NDOCU + "";
                apDim = apStr.length;
                apNum = (ZERI_NUMERO_DOCUMENTO + row.NDOCU)
                apNum = apNum.slice(apDim, apDim + ZERI_NUMERO_DOCUMENTO.length);
                return row.TNDOC + apNum;
              }
            },
            {
              "title": common.getTrad("Data Documento"),
              "data": "UDOCU",
              "targets": ctColPosition.indexOf("ctUDOCU"),
              "searchable": true,
              "orderable": true,
              "render": function (data, type, row) {
                if (data !== null) {
                  return moment(data).format('L')
                } else {
                  return ""
                }
              }
            },
            {
              "title": common.getTrad("Cod. Operazione"),
              "data": "CARTI",
              "targets": ctColPosition.indexOf("ctCARTI"),
              "searchable": true,
              "orderable": true,
              "width":"150px"
            },
            {
              "title": common.getTrad("Tipo Operazione"),
              "data": "DRIGA",
              "targets": ctColPosition.indexOf("ctDRIGA"),
              "searchable": true,
              "orderable": true,
            },
            {
              "title": common.getTrad("KM"),
              "data": "NKMPE",
              "targets": ctColPosition.indexOf("ctNKMPE"),
              "searchable": true,
              "orderable": true,
            },
            {
              "title": common.getTrad("Cod. Modello"),
              "data": "CVEIC",
              "targets": ctColPosition.indexOf("ctCVEIC"),
              "searchable": true,
              "orderable": true,
            },
            {
              "title": common.getTrad("Veicolo"),
              "data": "DVEIC",
              "targets": ctColPosition.indexOf("ctDVEIC"),
              "orderable": true,
            },
            {
              "title": common.getTrad("Telaio"),
              "data": "NTELA",
              "targets": ctColPosition.indexOf("ctNTELA"),
              "searchable": true,
              "orderable": true,
              "class": 'vin_vehicle sorting',
              "render": (data, type, row) => {
                if (row.NTELA !== undefined && row.NTELA !== null && row.NTELA)
                  return row.NTELA;
                else
                  return "";
              },
            },
            {
              "title": common.getTrad("Targa"),
              "data": "NTARG",
              "targets": ctColPosition.indexOf("ctNTARG"),
              "orderable": true,
            },
            {
              "title": common.getTrad("Data Trasm."),
              "data": "UTRAS",
              "targets": ctColPosition.indexOf("ctUTRAS"),
              "searchable": true,
              "orderable": true,
              "render": function (data, type, row) {
                if (data !== null) {
                  return moment(data).format('L')
                } else {
                  return ""
                }
              }
            },
            {
              //ID Texa
              "title": common.getTrad("ID Texa"),
              "data": "NDRIF",
              "targets": ctColPosition.indexOf("ctNDRIF"),
              "searchable": true,
              "orderable": true,
            },
            {
              "title": common.getTrad("Token Texa"),
              "data": "DAGG1",
              "targets": ctColPosition.indexOf("ctDAGG1"),
              "orderable": true,
            },
            {
              "title": common.getTrad("Stato"),
              "data": "CAVGA",
              "targets": ctColPosition.indexOf("ctCAVGA"),
              "orderable": true,
              "visible": true,
              "render": function ( data, type, row ) {
                if(arrayStati[data] !== undefined && arrayStati[data] !== null && typeof arrayStati[data] === 'object'){
                  return arrayStati[data]["name"]
                }else
                  return data;
                },
            },
          ],
    });
    this.adjustColumns('RMtable');
  }


  getTableWarranty() {
    const $ = window.$;
    const cwColPosition = [
      "cwCAVGA",
      "cwUDOCU",
      "cwCCAUS",
      "cwNPESO",
      "cwNGARA",
      "cwUTRAS"
    ];

    if ($.fn.dataTable.isDataTable("#table_warranty"))
      return false;

    var login, headers = {};

    login = common.getLocalLoginToken();
    if (login === false) {
      return false;
    }

    headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': common.getLanguage(true),
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
    };

    headers.authorization = "Bearer " + login;

    var apStr, apDim, apNum;
    if (this.state.userInfo.userInfo.GTSFINI.OFFICINA_ZERI_NUMERO_DOCUMENTO){
      var ZERI_NUMERO_DOCUMENTO = this.state.userInfo.userInfo.GTSFINI.OFFICINA_ZERI_NUMERO_DOCUMENTO
    }else{
      var ZERI_NUMERO_DOCUMENTO = '00000'
    }
    $('#table_warranty').DataTable({
      "order": [[cwColPosition.indexOf("cwUDOCU"), "desc"]],
      "deferRender": true,
      "scroller": true,
      "serverSide": true,
      "scrollY": '40vh',
      "bAutoWidth": false,
      "paging": false,
      "searching": false,
      "info": false,
      "pageLength": env.TABLE_PAGE_LENGTH,
      "bScrollCollapse": false,
      "processing": true,
      "language": {
        "url": env.STATIC + "lib/datatables/i18n/" + common.getLanguage() + ".lang"
      },
      "ajax": {
        url: env.BACKEND + "@sw-get-history-vehicle-warranty",
        dataType: 'json',
        headers: headers,
        dataSrc: "",
        data: (data) => {
          data.NTELA = this.state.pageContent.NTELA;
          var order = "";
          var orderSettings = $('#table_warranty').DataTable().order();
          for (var i = 0; i < orderSettings.length; i++) {
            if (order !== "")
              order = order + ",";
            var orderColumn = $('#table_warranty').DataTable().column(orderSettings[i][0]).dataSrc();
            order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
          }
          data.OrderPage = order;
        }
      },
      "columns": [
        {
          "title": common.getTrad("Stato"),
          "targets": cwColPosition.indexOf("cwCAVGA"),
          "data": "CAVGA",
          "width": "40%",
          "orderable": true,
          "render": function (data, type, row) {
            if (data === "00") {
              return common.getTrad("Garanzia incompleta");
            } else if (data === "03") {
              return common.getTrad("Garanzia pronta per trasmissione");
            } else if (data === "06") {
              return common.getTrad("Garanzia da terminare");
            } else if (data === "05" || data === "10") {
              return common.getTrad("Garanzia trasmessa");
            } else if (data >= "11" && data <= "59") {
              return common.getTrad("Garanzia da correggere");
            } else if (data >= "60" && data <= "69") {
              return common.getTrad("Garanzia rifiutata dalla casa");
            } else if (data === "70") {
              return common.getTrad("Garanzia ricevuta in attesa di elaborazione");
            } else if (data >= "71" && data <= "89") {
              if (row.CREPA >= 10 && row.CREPA <= 19) {
                return common.getTrad("Garanzia accettata dalla casa e richiesto invio pezzi");
              } else if (row.CREPA >= 20 && row.CREPA <= 29) {
                return common.getTrad("Garanzia accettata dalla casa e pezzi inviati");
              } else {
                return common.getTrad("Garanzia accettata dalla casa");
              }
            } else if (data >= "90" && data <= "99") {
              if (row.CREPA >= 10 && row.CREPA <= 19) {
                return common.getTrad("Garanzia rimborsata dalla casa e richiesto invio pezzi");
              } else if (row.CREPA >= 20 && row.CREPA <= 29) {
                return common.getTrad("Garanzia rimborsata dalla casa e pezzi inviati");
              } else {
                return common.getTrad("Garanzia rimborsata dalla casa");
              }
            } else {
              return data;
            }
          }
        },
        {
          "title": common.getTrad("Data Garanzia"),
          "targets": cwColPosition.indexOf("cwUDOCU"),
          "data": "UDOCU",
          "type": "date",
          "orderable": true,
          "render": function (data, type, row) {
            if (data !== null) {
              return moment(data).format('L')
            } else {
              return ""
            }
          }
        },
        {
          "title": common.getTrad("N. Garanzia"),
          "targets": cwColPosition.indexOf("cwNGARA"),
          "data": "NGARA",
          "orderable": true,
          "type": "num",
          "render": function (data, type, row) {
            apStr = row.NDOCU + ""
            apDim = apStr.length
            apNum = ZERI_NUMERO_DOCUMENTO + row.NDOCU
            apNum = apNum.slice(apDim, apDim + ZERI_NUMERO_DOCUMENTO.length);
            return row.TNDOC + apNum;
          }
        },
        {
          "title": common.getTrad("Causale"),
          "targets": cwColPosition.indexOf("cwCCAUS"),
          "data": "CCAUS",
          "orderable": true,
        },
        {
          "title": common.getTrad("Q.tà Manodopera"),
          "targets": cwColPosition.indexOf("cwNPESO"),
          "data": "NPESO",
          "orderable": true,
          "render": function (data, type, row) {
            if (data !== null) {
              return data
            } else {
              return 0
            }
          }
        },
        {
          "title": common.getTrad("Data Trasm."),
          "targets": cwColPosition.indexOf("cwUTRAS"),
          "data": "UTRAS",
          "type": "date",
          "orderable": true,
          "render": function (data, type, row) {
            if (data !== null) {
              return moment(data).format('L')
            } else {
              return ""
            }
          }
        },
      ],
    })
    this.adjustColumns('table_warranty');
  }

  hideFilterMultibrand() {
    const $ = window.$;
    if (this.state.pageContent.is_folderish && multibrand.is_multibrand_portal()) {
      if (this.state.checkVinVehicle || this.state.checkVinVehicleRequired)
        $('select').prop('disabled', 'disabled');
      $(".content_filtro_testata").hide();
    }
  }

  getTableService() {
    const $ = window.$;
    const ctColPosition = [
      "ctNSCHE",
      "ctUDOCU",
      "ctDCAUS",
      "ctNKMPE",
      "ctNTAGL",
      "ctCRIVE",
      "ctDRIVE",
      "ctDDOCU",
    ];

    var login, headers = {};

    login = common.getLocalLoginToken();
    if (login === false) {
      return false;
    }

    headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': common.getLanguage(true),
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
    };

    headers.authorization = "Bearer " + login;

    if ($.fn.dataTable.isDataTable("#table_service"))
      return false;


    var apStr, apDim, apNum;
    const ZERI_NUMERO_DOCUMENTO = "000000";
    $('#table_service').DataTable({
      "order": [[ctColPosition.indexOf("ctUDOCU"), "desc"]],
      "deferRender": true,
      "scroller": true,
      "serverSide": true,
      "scrollY": '40vh',
      "bAutoWidth": false,
      "paging": false,
      "searching": false,
      "info": false,
      "pageLength": env.TABLE_PAGE_LENGTH,
      "bScrollCollapse": false,
      "processing": true,
      "language": {
        "url": env.STATIC + "lib/datatables/i18n/" + common.getLanguage() + ".lang"
      },
      "ajax": {
        url: env.BACKEND + "@sw-get-history-vehicle-service",
        dataType: 'json',
        headers: headers,
        dataSrc: "",
        data: (data) => {
          data.NTELA = this.state.pageContent.NTELA;
          var order = "";
          var orderSettings = $('#table_service').DataTable().order();
          for (var i = 0; i < orderSettings.length; i++) {
            if (order !== "")
              order = order + ",";
            var orderColumn = $('#table_service').DataTable().column(orderSettings[i][0]).dataSrc();
            order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
          }
          data.OrderPage = order;
        },
      },
      "columns": [
        {
          "title": common.getTrad("Rif.Doc."),
          "data": "TNDOC",
          "targets": ctColPosition.indexOf("ctNSCHE"),
          "orderable": true,
          "width": "80px",
          "render": function (data, type, row) {
            apStr = row.NDOCU + "";
            apDim = apStr.length;
            apNum = (ZERI_NUMERO_DOCUMENTO + row.NDOCU)
            apNum = apNum.substr(apDim, ZERI_NUMERO_DOCUMENTO.length);
            return row.TNDOC + apNum;
          }
        },
        {
          "title": common.getTrad("Data Interv."),
          "targets": ctColPosition.indexOf("ctUDOCU"),
          "data": "UDOCU",
          "orderable": true,
          "width": "50px",
          "type": "date",
          "render": function (data, type, row) {
            if (data === null)
              return data
            else
              return moment(data).format('L');
          },
        },
        {
          "title": common.getTrad("Causale"),
          "data": "DCAUS",
          "targets": ctColPosition.indexOf("ctDCAUS"),
          "orderable": true,
          "width": "100px",
        },
        {
          "title": common.getTrad("Km"),
          "data": "NKMPE",
          "targets": ctColPosition.indexOf("ctNKMPE"),
          "orderable": true,
          "width": "80px",
          "class": "col-align-right",
          "type": "num",
        },
        {
          "title": common.getTrad("N.Tagl."),
          "data": "NTAGL",
          "targets": ctColPosition.indexOf("ctNTAGL"),
          "orderable": true,
          "width": "30px",
          "class": "col-align-right",
          "type": "num"
        },
        {
          "title": common.getTrad("Dealer"),
          "data": "DRIVE",
          "targets": ctColPosition.indexOf("ctDRIVE"),
          "width": "120px",
          "render": function (data, type, row) {
            let ret = ""
            if (row["CCORR"] !== undefined && row["CCORR"] !== null && row["CCORR"].length > 0)
              ret += "(" + row["CCORR"] + ")";
            ret += " <small>" + data + "</small>";
            return ret;
          }
        },
        {
          "title": common.getTrad("Note"),
          "targets": ctColPosition.indexOf("ctDDOCU"),
          "data": "DDOCU",
          "width": "120px",
        },
      ],
    })
    this.adjustColumns('table_service');
  }

  getTableActivation() {
    const $ = window.$;
    const caColPosition = [
      "caUIMMA",
      "caUMOVI",
      "caNPRTR",
      "caRACQU",
      "caNTARG",
      "caTRITI",
      "caUTRAS",
      "caCAVVE"
    ];


    if ($.fn.dataTable.isDataTable("#table_activation"))
      return false;

    var login, headers = {};

    login = common.getLocalLoginToken();
    if (login === false) {
      return false;
    }

    headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': common.getLanguage(true),
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
    };

    headers.authorization = "Bearer " + login;

    var apStr, apDim, apNum;
    const NPRVE_app = "000000";
    const NPRTR_app = "00"
    $('#table_activation').DataTable({
      "order": [[caColPosition.indexOf("caUIMMA"), "desc"]],
      "deferRender": true,
      "scroller": true,
      "serverSide": true,
      "scrollY": '40vh',
      "bAutoWidth": false,
      "paging": false,
      "searching": false,
      "info": false,
      "pageLength": env.TABLE_PAGE_LENGTH,
      "bScrollCollapse": false,
      "processing": true,
      "language": {
        "url": env.STATIC + "lib/datatables/i18n/" + common.getLanguage() + ".lang"
      },
      "ajax": {
        url: env.BACKEND + "@sw-get-history-vehicle-activation",
        dataType: 'json',
        headers: headers,
        dataSrc: "",
        data: (data) => {
          data.NTELA = this.state.pageContent.NTELA;
          var order = "";
          var orderSettings = $('#table_activation').DataTable().order();
          for (var i = 0; i < orderSettings.length; i++) {
            if (order !== "")
              order = order + ",";
            var orderColumn = $('#table_activation').DataTable().column(orderSettings[i][0]).dataSrc();
            order = order + "{{" + orderColumn + "}} " + orderSettings[i][1].toUpperCase();
          }
          data.OrderPage = order;
        },
      },
      "columns": [
        {
          "title": common.getTrad("Data Imm."),
          "targets": caColPosition.indexOf("caUIMMA"),
          "data": "UIMMA",
          "type": "date",
          "orderable": true,
          "render": function (data, type, row) {
            if (data !== null) {
              return moment(data).format('L')
            } else {
              return ""
            }
          }
        },
        {
          "title": common.getTrad("Data cambio proprietà"),
          "data": "UMOVI",
          "targets": caColPosition.indexOf("caUMOVI"),
          "orderable": true,
          "type": "date",
          "render": function (data, type, row) {
            if (data !== null) {
              return moment(data).format('L')
            } else {
              return ""
            }
          }
        },
        {
          "title": common.getTrad("N. Documento"),
          "targets": caColPosition.indexOf("caNPRTR"),
          "data": "NPRTR",
          "type": "num",
          "orderable": true,
          "render": function (data, type, row) {
            apStr = row.NPRVE + "";
            apDim = apStr.length;
            apNum = (NPRVE_app + apStr);
            var ret = apNum.substr(apDim, NPRVE_app.length);

            apStr = data + "";
            apDim = apStr.length;
            apNum = (NPRTR_app + apStr);
            var nrBetanet = ret + apNum.substr(apDim, NPRTR_app.length);

            return nrBetanet;
          }
        },
        {
          "title": common.getTrad("Proprietario"),
          "targets": caColPosition.indexOf("caRACQU"),
          "orderable": true,
          "data": "RACQU"
        },
        {
          "title": common.getTrad("Targa"),
          "targets": caColPosition.indexOf("caNTARG"),
          "orderable": true,
          "data": "NTARG"
        },
        {
          "title": common.getTrad("Tipo"),
          "targets": caColPosition.indexOf("caTRITI"),
          "orderable": true,
          "data": "TRITI",
          "render": function (data, type, row) {
            if (data === "A") {
              return common.getTrad("Nuova");
            } else if (data === "C") {
              return common.getTrad("Cambio Prop.");
            } else if (data === "E") {
              return common.getTrad("Estensione");
            } else if (data === "R") {
              return common.getTrad("Rottamazione");
            } else {
              return data;
            }
          }
        },
        {
          "title": common.getTrad("Stato"),
          "targets": caColPosition.indexOf("caCAVVE"),
          "orderable": true,
          "data": "CAVVE",
          "render": function (data, type, row) {
            if (data === "00") {
              return common.getTrad("Attivazione incompleta");
            } else if (data === "03" || data === "04") {
              return common.getTrad("Attivazione pronta per trasmissione");
            } else if (data === "05" || data === "10") {
              return common.getTrad("Attivazione trasmessa");
            } else if (data >= "11" && data <= "69") {
              return common.getTrad("Attivazione da correggere");
            } else if (data >= "70" && data <= "89") {
              return common.getTrad("Attivazione accettata dalla casa");
            } else {
              return data;
            }
          }
        },
        {
          "title": common.getTrad("Data Trasm."),
          "targets": caColPosition.indexOf("caUTRAS"),
          "orderable": true,
          "data": "UTRAS",
          "type": "date",
          "render": function (data, type, row) {
            if (data !== null) {
              return moment(data).format('L')
            } else {
              return ""
            }
          }
        },
      ],
    })
    this.adjustColumns('table_activation');
  }

  showLegendDiagnosiTexa(e) {
    e.preventDefault();
    e.stopPropagation();

    const arrayStati = this.arrayStatiDiagnosi;

    var rows = "<div class='container-fluid'>";
    var toPrint = [];
    for (let key in arrayStati) toPrint.push(parseInt(key));
    toPrint.sort((a, b) => a - b);

    for (let i in toPrint) {
      let key = toPrint[i].toString().padStart(2, '0');
      rows += `<div class="form-group row">
        <div class="col-sm-2">
          <i class="fa CAVDIico ${arrayStati[key]["image"]}" style="color:${arrayStati[key]["color"]}"></i>
        </div>
        <div class="col-sm-10">
          <label class="styled-label">${arrayStati[key]["description"]}</label>
        </div>
      </div>`;
    }
    rows += "</div>";

    bootbox.dialog({
      title: common.getTrad("Legenda dispositivi di diagnosi"),
      message: rows,
      onEscape: true,
    });
  }

  getTableDiagnosiTexa() {
    const $ = window.$;
    const arrayStati = this.arrayStatiDiagnosi;
    window.showLegend = (e) => this.showLegendDiagnosiTexa(e);

    function truncateOnWord(str, limit) {
      if(str.length <= limit)
        return str;
      var trimmable = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u2028\u2029\u3000\uFEFF';
      var reg = new RegExp('(?=[' + trimmable + '])');
      var words = str.split(reg);
      var count = 0;
      var out = words.filter(function (word) {
        count += word.length;
        return count <= limit;
      }).join('') + "...";
      
      if(out == '...')
        return str.substring(0, limit) + "...";
      
      return out;
    }

    function bindDragScroll($container, $scroller) {
      const $ = window.$;
      var $window = $(window);

      var x = 0;
      var y = 0;

      var x2 = 0;
      var y2 = 0;
      var t = 0;
      
      $container.on("mousedown", down);
      $container.on("click", preventDefault);
      $scroller.on("mousewheel", horizontalMouseWheel); // prevent macbook trigger prev/next page while scrolling

      function down(evt) {
        if (evt.button === 0) {

          t = Date.now();
          x = x2 = evt.pageX;
          y = y2 = evt.pageY;

          $container.addClass("down");
          $window.on("mousemove", move);
          $window.on("mouseup", up);

          evt.preventDefault();

        }

      }

      function move(evt) {
        if ($container.hasClass("down")) {
          var _x = evt.pageX;
          var _y = evt.pageY;
          var deltaX = _x - x;
          var deltaY = _y - y;

          if ((!$container.hasClass("dragging")) && (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10))
            $container.addClass("dragging");

          $scroller[0].scrollLeft -= deltaX;

          x = _x;
          y = _y;

        }

      }

      function up(evt) {
        $window.off("mousemove", move);
        $window.off("mouseup", up);

        var deltaT = Date.now() - t;
        var deltaX = evt.pageX - x2;
        var deltaY = evt.pageY - y2;
        if (deltaT <= 300) {
          $scroller.stop().animate({
            //scrollTop: "-=" + deltaY * 3,
            scrollLeft: "-=" + deltaX * 3
          }, 500, function (x, t, b, c, d) {
            // easeOutCirc function from http://gsgd.co.uk/sandbox/jquery/easing/
            return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
          });
        }

        t = 0;

        $container.removeClass("down");
        if ($container.hasClass("dragging")) {
          $container.removeClass("dragging");
          $container.addClass("dragged");
        }

      }

      function preventDefault(evt) {
        if (x2 !== evt.pageX || y2 !== evt.pageY) {
          evt.preventDefault();
          return false;
        }
      }

      function horizontalMouseWheel(evt) {
        evt = evt.originalEvent;
        var x = $scroller.scrollLeft();
        var max = $scroller[0].scrollWidth - $scroller[0].offsetWidth;
        var dir = (evt.deltaX || evt.wheelDeltaX);
        var stop = dir > 0 ? x >= max : x <= 0;
        if (stop && dir) {
          evt.preventDefault();
        }
      }

    }

    if ($.fn.DataTable.isDataTable('#table_diagnosi_texa')) {
      return false;
      // $('#table_diagnosi_texa').DataTable().destroy();
    }

    var login, headers = {};
    const { pageContent, isConsole, viewType } = this.state;
    var tableColsToHide = [
      "ctTAG",
      "ctZUSER",
      "ctDRIVE",
      "ctTDIAG",
    ];

    login = common.getLocalLoginToken();
    if (login === false) {
      return false;
    }

    headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': common.getLanguage(true),
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
    };

    headers.authorization = "Bearer " + login;

    var cclie = this.props.pageContent.CCLIE ?? 0;

    let ct = 0;
    const table = $("#table_diagnosi_texa").DataTable({
      "language": {
        "url": env.STATIC + "lib/datatables/i18n/" + common.getLanguage() + ".lang"
      },
      "paging": false,
      "bLengthChange": false,
      "bAutoWidth": true,
      "bScrollCollapse": false,
      "deferRender": true,
      "processing": true,
      "serverSide": true,
      "searching": false,

      "scroller": true,
      "info": false,
      "pageLength": env.TABLE_PAGE_LENGTH,
      "drawCallback": function(settings) {
        var $container = $("#tagliandi-table").parent().parent();
        var $scroller  = $("#tagliandi-table").parent();
        bindDragScroll($container, $scroller);
      },
      "ajax": {
        url: env.BACKEND + "@sw-get-history-diagnostic",
        dataType: 'json',
        headers: headers,
        dataSrc: "",
        data: (data) => {
          data.FSTAT = window.activeView;
          data.TCONS = viewType;
          data.DRIVE = $('#f_driveDX:visible').val();
          data.ANNO  = $('#cbx_anno:visible').val();
          data.MESE  = $('#cbx_mese:visible').val();
          data.CCLIE = cclie;

          let order = "";
          const orderSettings = table.order();
          for (let i = 0; i < orderSettings.length; i++) {
            if (order !== "") order += ",";
            const orderColumn = table.column(orderSettings[i][0]).dataSrc();
            order += `{{${orderColumn}}} ${orderSettings[i][1].toUpperCase()}`;
          }
          data.OrderPage = order;
        }
      },
      "initComplete": (settings, json) => {
        let count = 0;
        if (json) {
          count = json.data?.length ?? json.length ?? json.recordsTotal ?? 0;
        }
        // TODO
        // setNotifyCounter('#counterDispositiviTexa', count);
      },
      "columnDefs": [
        {
          "title": common.getTrad("Tag"),
          "data": "",
          "targets": window.ctTAG = ct++,
          "orderable": false,
          "visible": !isConsole
            ? tableColsToHide.indexOf("ctTAG") <= -1
            : false,
          "render": (data, type, row, meta) => {
            if (isConsole) return "";
            if (row['FBLOC'] === "S") {
              return `<i class="editColumnIco fa fa-square-o" style="margin-right: 15px;"></i>
                      <i onclick="saveDocument(true,${row['ID']},'${row['NTELA']}','N',${meta.row})"
                          class="editColumnIco fa fa-undo" aria-hidden="true"
                          title="${common.getTrad('Riattiva')}"></i>`;
            } else if (row['CAVDI'] >= 11 && row['CAVDI'] <= 59) {
              return `<i class="editColumnIco fa fa-square-o" style="margin-right: 15px;"></i>
                      <i onclick="newDiagnosi(${row['ID']},'${row['NTELA']}',${meta.row})"
                          class="editColumnIco fa fa-pencil" aria-hidden="true"
                          title="${common.getTrad('Modifica')}"></i>`;
            } else {
              return `<i class="editColumnIco fa fa-square-o"></i>`;
            }
          }
        },
        {
          "title": common.getTrad("Seriale Dispositivo"),
          "data": "NTELA",
          "targets": window.ctNTELA = ct++,
          "visible": tableColsToHide.indexOf("ctNTELA") <= -1,
          "searchable": true,
          "orderable": true,
          "render": (data) => data ?? ''
        },
        {
          "title": common.getTrad("Nota interna"),
          "data": "DNOTA",
          "class": "SW_TAG_DDOCU",
          "targets": window.ctDNOTA = ct++,
          "visible": tableColsToHide.indexOf("ctDNOTA") <= -1,
          "searchable": true,
          "orderable": true,
          "render": (data) => {
            if (data !== null && data !== '' && data !== undefined)
              return truncateOnWord(data, 75);
            return '';
          },
          "createdCell": (td, cellData) => {
            $(td).attr('data-toggle', 'tooltip');
            $(td).attr('data-html', 'true');
            $(td).attr('title', cellData);
            $(td).tooltip({
              container: "body",
              placement: "auto",
              template: '<div class="tooltip tooltip-nota" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
            });
          }
        },
        {
          "title": common.getTrad("Concessionario"),
          "data": "DRIVE",
          "targets": window.ctDRIVE = ct++,
          "orderable": true,
          "visible": tableColsToHide.indexOf("ctDRIVE") <= -1,
          "render": (data, type, row) => {
            if (!data) return '';
            return row["CCLIE"] ? `${row["CCLIE"]} - ${data}` : data;
          }
        },
        {
          "title": common.getTrad("Data inserimento"),
          "data": "UINSR",
          "targets": window.ctUINSR = ct++,
          "visible": tableColsToHide.indexOf("ctUINSR") <= -1,
          "searchable": true,
          "orderable": true,
          "type": window.LANGUAGE_CODE !== 'en' ? "date-eu" : "date",
          "render": (data) => data == null ? data : moment(data).format('L')
        },
        {
          "title": common.getTrad("Data trasmissione"),
          "data": "UTRAS",
          "targets": window.ctUTRAS = ct++,
          "visible": tableColsToHide.indexOf("ctUTRAS") <= -1,
          "searchable": true,
          "orderable": true,
          "type": window.LANGUAGE_CODE !== 'en' ? "date-eu" : "date",
          "render": (data) => data == null ? data : moment(data).format('L')
        },
        {
          "title": common.getTrad("Tipo diagnostica"),
          "data": "TDIAG",
          "targets": window.ctTDIAG = ct++,
          "orderable": false,
          "visible": tableColsToHide.indexOf("ctTDIAG") <= -1,
          "render": (data) => data ?? ''
        },
        {
          "title": `${common.getTrad("Stato")} <span id="LegendaCAVDI" onclick="showLegend(event)" class="fa fa-question-circle"></span>`,
          "data": "CAVDI",
          "targets": window.ctCAVDI = ct++,
          "visible": tableColsToHide.indexOf("ctCAVDI") <= -1,
          "orderable": true,
          "width": "10px",
          "render": (data, type, row) => {
            if (row["FBLOC"] === "S") {
              return `<i class='fa CAVDIico ${arrayStati["60"]["image"]}' title='${arrayStati["60"]["name"]}' style='color:${arrayStati["60"]["color"]}'></i>`;
            }
            let key = data;
            if (parseInt(data) >= 11 && parseInt(data) <= 59)   key = "11";
            else if (parseInt(data) >= 70 && parseInt(data) <= 99) key = "90";
            else if (data === "10" || data === "05")            key = "05";

            if (arrayStati[key] !== undefined && arrayStati[key] !== null && typeof arrayStati[key] === 'object') {
              return `<i class='fa CAVDIico ${arrayStati[key]["image"]}' title='${arrayStati[key]["name"]}' style='color:${arrayStati[key]["color"]}'></i>`;
            }
            return data;
          }
        },
        {
          "title": common.getTrad("Note"),
          "data": "DRISP",
          "class": "SW_TAG_DDOCU",
          "targets": window.ctDRISP = ct++,
          "orderable": false,
          "visible": false,
          "render": (data) => {
            if (data !== null && data !== '' && data !== undefined)
              return truncateOnWord(data, 75);
            return '';
          },
          "createdCell": (td, cellData) => {
            $(td).attr('data-toggle', 'tooltip');
            $(td).attr('data-html', 'true');
            $(td).attr('title', cellData);
            $(td).tooltip({
              container: "body",
              placement: "auto",
              template: '<div class="tooltip tooltip-nota" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
            });
          }
        },
        {
          "title": common.getTrad("Utente"),
          "data": "ZUSER",
          "targets": window.ctZUSER = ct++,
          "orderable": false,
          "visible": tableColsToHide.indexOf("ctZUSER") <= -1,
          "render": (data) => data ?? ''
        },
        {
          "data": "ID",
          "targets": window.ctID = ct++,
          "orderable": false,
          "visible": false,
          "render": (data) => data ?? ''
        },
      ],
      "order": [[window.ctCAVDI, "asc"], [window.ctUTRAS, "desc"]],
      "fnRowCallback": (nRow, aData) => {
        if ((parseInt(aData.CAVDI) >= 11 && parseInt(aData.CAVDI) <= 59) || aData.FBLOC === "S") {
          $(nRow).attr("style", "color:rgb(173, 19, 15)");
        }
      }
    });
    this.adjustColumns('table_diagnosi_texa');
  }

  async getTicketsAutocomplete() {
    let apiUrl;
    if (this.state.pageTitle === 'Delivery Claims' && this.state.newTicket) {
      apiUrl = common.getTicketBackendUrl(this.state.pathname) + "/dealer_tickets";
      } 
    else if (this.state.tipoTicket === 'ticketClaim' && !this.state.newTicket) {
      apiUrl = common.getTicketBackendUrl('/it/dealer/support-tools/ticket') + "/dealer_tickets";
    }
    return common.apiCall(apiUrl, "GET", {}, true, false, "json").then(
      data => data["data"]);
    }


  getLinkPartsFinder() {
    sessionStorage.setItem('FILTRO_NTELA', this.state.pageContent.NTELA)
    let epc_link = env.FRONTEND + "swan/cruscotto/epc/?ZM=" + window.cc.marche_attive[common.object_value_in_array(window.cc.marche_attive, 'ZFORN', this.state.pageContent.ZFORN)].ZFORN + "&NT=" + this.state.pageContent.NTELA
    epc_link = epc_link.replace('/service', '')
    return window.open(epc_link, '_blank')
  }

  generateVinVehicleUrl() {
    const $ = window.$;
    let url = ""
    let campagne = ""

    if (window.cc.csoft == 850030 || (window.cc.csoft >= 850400 && window.cc.csoft <= 850499) || (window.cc.csoft >= 850100 && window.cc.csoft <= 850199)) {
      campagne = "campagne=True&"
    }

    if (multibrand.is_multibrand_portal()) {
      url = env.BACKEND + "@get-veicolo?"+ campagne + "marca=" + $("#select_vm").val();
    } else {
      url = env.BACKEND + "@get-veicolo?"+ campagne + "telaio=";
    }
    return url
  }

  getTableTicket(statoPaginaNext) {
    const data = {
      fullobjects: 1,
      swhistory: 1,
      portal_type: "swticket_vehicle",
      vin_vehicle: this.state.pageContent.vin_vehicle,
    }

    var pageStart = env.TABLE_PAGE_LENGTH * (statoPaginaNext.pagina_attuale - 1);
    if (pageStart === 1)
      pageStart--;

    data.b_size = env.TABLE_PAGE_LENGTH;
    data.b_start = pageStart;
    data.sort_on = statoPaginaNext.tipo_ordinamento;
    data.sort_order = statoPaginaNext.verso_ordinamento === -1 ? "reverse" : "ascending";
    data.SearchableText = statoPaginaNext.testo_cercato !== undefined && statoPaginaNext.testo_cercato.length > 0 ? "*" + statoPaginaNext.testo_cercato + "*" : "";
    var apiUrl = common.getTicketBackendUrl('/it/dealer/ticket/ticket')
    common.apiCall(apiUrl, "GET", data, true, false, "json")
      .then(ticketsByVinVehicle => {
        this.setState({ ticketsByVinVehicle: ticketsByVinVehicle })
      });
  }

  componentDidMount() {
    const $ = window.$;
    document.getElementById('content_page').style.setProperty("transform", "none")
    window.scrollTo(0, 0)

    document.addEventListener('keydown', (e) => {
      if (!e.ctrlKey || e.key !== 'Enter' || e.repeat) return;
      const activeTextarea = document.activeElement;
      if (!activeTextarea || activeTextarea.tagName !== 'TEXTAREA') return;

      const value = activeTextarea.value?.trim();
      if (!value) return;
      const form = activeTextarea.closest('form');
      const submitBtn = form?.querySelector('button[id^="saveComment"]');
      submitBtn?.click();
    });

    if (this.state.newTicket === false) {
      this.changeReviewStateRead(this.state.pageContent?.CAVTL)
    }


    window.convertedFiles = [];
    window.uploadedFiles = [];

    document.getElementById('body').className += ' content_ticket';
    if (this.state.newTicket) {

      // modifica form per stato/Tipologia
      $('.single_ticket').hide();
      $('#ticket_0.single_ticket').show();
      this.declareSelectTipologie();
    }
    if (this.state.newTicket && this.state.tipoTicket) {
      this.declareSelectProdotto()
    } else if (!this.state.newTicket && this.state.tipoTicket && Object.keys(this.state.tipologie_ticket_attive).length > 0) {
      this.declareSelectProdotto()
      $('#tipo_prodotto_new').val(this.state.subType).trigger("change");
    }

    document.title = document.title = window.cc.companyInfo.service + " Service";
    // check lingue attive dove caricare il contenuto

    // upload file custom javascript
    ; (function (document, window, index) {
      var inputs = document.querySelectorAll('.inputfile');
      Array.prototype.forEach.call(inputs, function (input) {
        var label = input.nextElementSibling,
          labelVal = label.innerHTML;
        $(label).css('margin-bottom', 0)
        input.addEventListener('change', function (e) {
          $("label[for='file_multiple'] .span_label_file").html(common.getTrad("File selezionati ({{numero}})", { numero: window.convertedFiles.length }))

          var fileName = '';
          fileName = e.target.value.split('\\').pop();

          if (fileName)
            label.querySelector('span').innerHTML = fileName;
          else
            label.innerHTML = labelVal;
        });

        // Firefox bug fix
        input.addEventListener('focus', function () { input.classList.add('has-focus'); });
        input.addEventListener('blur', function () { input.classList.remove('has-focus'); });
      });
    }(document, window, 0));
    if (!this.state.newTicket && this.state.pageContent.NTELA && common.object_value_in_array(this.state.pageContent?.BDOCU, "id", "veicolo") === -1){
      common.apiCall(env.BACKEND + "@get-veicolo?telaio=" + this.state.pageContent.NTELA + "&marca=" + this.state.pageContent.ZFORN, "GET", {}, true)
      .then(response => {
          var bdocu = this.state.pageContent.BDOCU
          var pagecontent = this.state.pageContent
          var veicolo = {
            'id' : 'veicolo',
            'value': response['veicolo']
          } 
          bdocu.push(veicolo)
          pagecontent.BDOCU = bdocu
          this.setState({pageContent : pagecontent})
        })
    }

    var url_string = window.location.href;
    var url = new URL(url_string);
    const params = url.searchParams;
    if ([...params].length > 0) {
      const paramObject = {};
      for (const [key, value] of params.entries()) {
        paramObject[key] = value;
      }
      if ((Object.keys(paramObject)).includes('ZM')){
        let zm = paramObject['ZM']
        $("#select_vm").val(zm).trigger("change")
      }
    }
  }

  populateForm(is_modal = false) {
    let fieldPrefix = "modal_old_";
    const $ = window.$;
    if (!this.state.newTicket && Object.keys(this.state.tipologie_ticket_attive).length > 0) {
      var isEdit = this.state.editTicket;
      if (this.state.changeType) {
        var campiTicket = this.state.tipologie_ticket_attive[this.state.newTypeData.tipo];
        var description = this.state.newTypeData.description;
        var oldType = this.state.pageContent.DCAUS
        const idsDescription = new Set(description.map(d => d.id));
        var campi = campiTicket.campi.filter(c => idsDescription.has(c.id));
      } else {
        var campiTicket = this.state.tipologie_ticket_attive[this.state.pageContent?.CCAUS];
        var description = this.state.pageContent?.BDOCU;
        const idsDescription = new Set(description.map(d => d.id));
        var campi = campiTicket.campi.filter(c => idsDescription.has(c.id));
      }
      campi.map((index, key) => {
        if (this.state.changeType) {
          if (description[key] !== undefined) {
            if (description[key].id !== 'file' && description[key].id !== 'file_multiple' && description[key].id !== 'mandatory_attachments' && description[key].id !== 'mandatory_attachments_2') {
              if (description[key].id === 'tipo_prodotto_new' && !oldType.includes('Old')){
                this.state.subType = description[key].value
              }
              let value = description[key].value;
              $('#' + description[key].id).val(value);
            }
            if (isEdit === false)
              $('#' + description[key].id).attr('disabled', 'true')
          }
        } else {
          if ((description !== undefined && description[key] !== undefined)) {
            if (description[key].id !== 'file' && description[key].id !== 'file_multiple') {
              let value = description[key].value;
              if (index.html.indexOf("date_input") > -1)
                value = (moment(description[key].value).isValid() ? moment(description[key].value).format('L') : '');
              if (is_modal === true) {
                if (index.html.indexOf("select2") > -1) {
                  $('#' + fieldPrefix + description[key].id).val(value);
                  $('#' + fieldPrefix + description[key].id).attr('disabled', 'true');
                  $('#' + fieldPrefix + description[key].id).parent("div").addClass("colorcharGray");
                } else {
                  $('#' + fieldPrefix + description[key].id).val(value);
                  $('#' + fieldPrefix + description[key].id).attr('readonly', 'true');
                  $('#' + fieldPrefix + description[key].id).css("color", "grey");
                }
              } else {
                $('#' + description[key].id).val(value);
                if (isEdit === false)
                  $('#' + description[key].id).attr('disabled', 'true')
              }
              return ("")
            }
          } else {
            return ('')
          }
        }
        return ("");

      });
    }
  }

  stampaPagina() {
    window.print();
  }

  adjustColumns(table){
    const $ = window.$;
    window.setTimeout(function () {
      if ($('#' + table).is(":visible"))
        $('#' + table).DataTable()?.columns?.adjust();
    }, 200);
  }

  addTemporayFile(input) {
    const $ = window.$;
    if(input === 'L'){
      var file = $("#file_comment")[0].files[0].name;
      var fileSize = $("#file_comment")[0].files[0].size;
    }else{
      var file = $("#file_comment2")[0].files[0].name;
      var fileSize = $("#file_comment2")[0].files[0].size;      
    }
    if (fileSize > 209715200){
      bootbox.alert(common.getTrad("Attenzione!<br/>Il file che stai cercando di caricare supera la dimensione massima consentita di 200 MB.<br/>Riduci la dimensione e caricalo nuovamente."));
      return false
    }
    if(input === 'L'){
      this.setState({ file_info_upload: file })
    }else{
      this.setState({ file_info_upload2: file })
    }
  }

  deleteTemporaryFile(input) {
    const $ = window.$;
    $("#file_comment").val('');
    if (input === 'L') {
      this.setState({ file_info_upload:'' })
    } else {
      this.setState({ file_info_upload2:'' })
    }
  }


  causaleChiusura = () => {
    const causali_chiusura =
      this.state.tipologie_ticket_attive[this.state.tipoTicket]['causali_chiusura'];

    if (!causali_chiusura || causali_chiusura.length === 0) {
      return;
    }

    this.setState({
      showModal: true,
      causaliChiusura: causali_chiusura,
      selectedCausale: ""
    });
  };

  renderModalChiusura() {
    if (!this.state.showModal) return null;

    const causali_chiusura = this.state.causaliChiusura;

    return (
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.4)" }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {common.getTrad("Seleziona una causale di chiusura")}
              </h5>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <select
                  value={this.state.selectedCausale}
                  className="form-control select2"
                  id="causale_chiusura"
                  autoComplete="off"
                >
                  <option value=""></option>
                  {causali_chiusura !== undefined
                    ? Object.keys(causali_chiusura).map((index, key) => {
                      let value = causali_chiusura[index];
                      return (
                        <option key={key} value={value.id}>
                          {value.titolo}
                        </option>
                      );
                    })
                    : ""}
                </select>
                {this.state.error !== null ? 
                  <small style={{ color: "red" }}>{this.state.error}</small>
                  :
                  <></>
                
                }
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  if (!this.state.selectedCausale) {
                    this.setState({ error: common.getTrad("Seleziona una causale per procedere")});
                    return;
                  }
                  this.setState({ showModal: false, error: null });
                  var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + "causale_chiusura/"
                  var data = {
                    'causale_chiusura' : this.state.selectedCausale
                  }
                  common.apiCall(apiUrl, "PATCH", data, true, false, "json").then(data => {
                    const $ = window.$
                    if (data.error === false) {
                      var pageContent = this.state.pageContent;
                      pageContent.CCCAU = data.causale_chiusura;
                      this.setState({pageContent : pageContent})
                    } else {
                      $("body #app .loadingDiv").fadeOut();
                      $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.")
                        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                        + '<span aria-hidden="true">&times;</span>'
                        + '</button>'
                        + '</div>');
                    }
                  })
                }}
              >
                {common.getTrad("Conferma")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  openMySwanModal = (thread = null) => {
    const $ = window.$;
    this.setState({ mySwanSelectedUrls: [], mySwanImages: [], mySwanLoading: true, mySwanThread: thread }, () => {
      $('#div_upload_my_swan').modal('show');
      this.loadMySwanImages();
    });
  }

  loadMySwanImages = async () => {
    const $ = window.$;
    try {
      await new Promise((resolve, reject) => {
        $.ajax({
          url: env.SWAN + "my_swan/content_urls/",
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            client_id: "844adf904f1605c3",
            client_secret: "a597e581c7865c7a2a07babb5137051d",
          }),
          success: (response) => {
            if (response.status === 'success') {
              // Salva gli item completi, non solo gli url
              this.setState({
                mySwanImages: response.items || [],
                mySwanLoading: false,
                mySwanFilter: '',
                mySwanDeleteAfterSave: false,
              });
              resolve();
            } else {
              reject(new Error(response.status_description || "Errore MySwan"));
            }
          },
          error: (xhr) => {
            reject(new Error(xhr.responseJSON?.status_description || "Errore chiamata MySwan"));
          }
        });
      });
    } catch (error) {
      console.error("Errore caricamento immagini MySwan:", error);
      this.setState({ mySwanImages: [], mySwanLoading: false });
    }
  }

  toggleMySwanImage = (url) => {
    const { mySwanSelectedUrls, mySwanThread } = this.state;

    if (mySwanThread) {
      if (mySwanSelectedUrls.includes(url)) {
        this.setState({ mySwanSelectedUrls: [] });
      } else {
        this.setState({ mySwanSelectedUrls: [url] });
      }
    } else {
      if (mySwanSelectedUrls.includes(url)) {
        this.setState({ mySwanSelectedUrls: mySwanSelectedUrls.filter(u => u !== url) });
      } else {
        this.setState({ mySwanSelectedUrls: [...mySwanSelectedUrls, url] });
      }
    }

    // Popola DFOTO con i metadati degli item selezionati
    const newSelected = mySwanThread
      ? (mySwanSelectedUrls.includes(url) ? [] : [url])
      : (mySwanSelectedUrls.includes(url)
        ? mySwanSelectedUrls.filter(u => u !== url)
        : [...mySwanSelectedUrls, url]);

    const dfotoEl = document.querySelector('#div_upload_my_swan #DFOTO');
    if (dfotoEl) {
      dfotoEl.value = newSelected.map(selectedUrl => {
        const item = this.state.mySwanImages.find(i => i.url === selectedUrl);
        if (!item) return '';
        return [item.description, item.frame_number, item.plate_number]
          .filter(Boolean).join(' | ');
      }).filter(Boolean).join(' | ');
    }
  }

  saveMySwanFiles = async () => {
    const $ = window.$;
    const { mySwanSelectedUrls, mySwanDeleteAfterSave, mySwanImages } = this.state;
    if (mySwanSelectedUrls.length === 0) return;

    this.setState({ mySwanSaving: true });
    $("#div_upload_my_swan").attr("disabled", "true");

    try {
      const fileList = await Promise.all(
        mySwanSelectedUrls.map(async (url, index) => {
          const proxyUrl = env.SWAN + "my_swan/proxy-myswan-image/?url=" + encodeURIComponent(url);
          const response = await fetch(proxyUrl);
          if (!response.ok) throw new Error(`Download fallito: ${url}`);
          const blob = await response.blob();
          const fileName = url.split('/').pop().split('?')[0] || `myswan_${index + 1}.jpg`;
          const file = new File([blob], fileName, { type: blob.type });
          return { id: URL.createObjectURL(file), file: file };
        })
      );
      window.convertedFiles = window.convertedFiles || [];

      fileList.forEach(item => {
        if (item.file.size > 209715200) {
          bootbox.alert(common.getTrad(
            "Attenzione!<br/>Il file che stai cercando di caricare supera la dimensione massima consentita di 200 MB.<br/>Riduci la dimensione e caricalo nuovamente."
          ));
          return;
        }
        window.convertedFiles = [...window.convertedFiles, item];
      });

      $("#data-pre").html('');
      $("#data-pre").addClass('d-flex flex-wrap fileConverted no-gutters');

      window.convertedFiles.forEach((i, index) => {
        const key = index + 1;
        $("#data-pre").append(
          '<div class="col-6 p-2" data-key="' + i.id + '">'
          + '<div id="file_' + key + '" class="col-12 p-2 divInfoFileLoaded" data-key="' + i.id + '">'
          + '<span><i class="' + this.getImageFromExt(i.file.name) + ' p-1 ml-1 mr-1" style="font-size: 1.8em; color:slategrey"></i></span>'
          + '<span class="filedata"><small class="textBaloon p-0 m-0 text-muted">' + common.getTrad('File') + ': ' + common.truncateFileName(i.file.name.toLowerCase(), 24) + '<br/>' + common.getTrad('Dimensione') + ': ' + common.humanFileSize(i.file.size) + '</small></span>'
          + '<span class="far fa-trash-alt removeFileConverted ml-1 mr-1" onClick="console.log(19);" data-key="' + i.id + '"></span>'
          + '</div>'
          + '</div>'
        );
      });
      $(".removeFileConverted").unbind('click');
      $(".removeFileConverted").on('click', (e) => {
        this.handleClickRemoveFileConverted(e);
      });
      $("label[for='file_multiple'] .span_label_file").html(
        common.getTrad("File selezionati ({{numero}})", { numero: window.convertedFiles.length })
      );

      // Elimina da MySwan se flag attivo
      if (mySwanDeleteAfterSave) {
        const selectedIds = mySwanSelectedUrls.map(url => {
          const item = mySwanImages.find(i => i.url === url);
          return item ? item.id : null;
        }).filter(Boolean);

        if (selectedIds.length > 0) {
          try {
            await fetch(env.SWAN + "my_swan/delete-contents/", {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': common.getCookie('csrftoken'),
              },
              body: JSON.stringify({ ids: selectedIds }),
            });
          } catch (err) {
            console.error("Errore eliminazione MySwan:", err);
          }
        }
      }

    } catch (error) {
      console.error("Errore MySwan save:", error);
      bootbox.alert(common.getTrad("Si è verificato un errore durante il caricamento dei file."));
    } finally {
      this.setState({ mySwanSaving: false });
      $("#div_upload_my_swan").removeAttr("disabled");
      $("#div_upload_my_swan").modal("hide");
    }
  }


  saveMySwanFilesFromComment = async () => {
    const $ = window.$;
    const { mySwanSelectedUrls, mySwanThread, mySwanDeleteAfterSave, mySwanImages } = this.state;
    if (mySwanSelectedUrls.length === 0) return;

    this.setState({ mySwanSaving: true });
    $(".close-upload-modal").attr("disabled", "true");

    try {
      const url = mySwanSelectedUrls[0];
      const proxyUrl = env.SWAN + "my_swan/proxy-myswan-image/?url=" + encodeURIComponent(url);

      const response = await fetch(proxyUrl);
      if (!response.ok) throw new Error(`Download fallito: ${url}`);
      const blob = await response.blob();
      const fileName = url.split('/').pop().split('?')[0] || `myswan_1.jpg`;
      const file = new File([blob], fileName, { type: blob.type });

      if (file.size > 209715200) {
        bootbox.alert(common.getTrad(
          "Attenzione!<br/>Il file che stai cercando di caricare supera la dimensione massima consentita di 200 MB.<br/>Riduci la dimensione e caricalo nuovamente."
        ));
        return;
      }

      const inputId = mySwanThread === 'I' ? 'file_comment2' : 'file_comment';
      const input = document.getElementById(inputId);
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      input.files = dataTransfer.files;

      this.addTemporayFile(mySwanThread === 'I' ? 'R' : 'L');

      // Elimina da MySwan se flag attivo
      if (mySwanDeleteAfterSave) {
        const selectedIds = mySwanSelectedUrls.map(selectedUrl => {
          const item = mySwanImages.find(i => i.url === selectedUrl);
          return item ? item.id : null;
        }).filter(Boolean);

        if (selectedIds.length > 0) {
          try {
            await fetch(env.SWAN + "my_swan/delete-contents/", {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': common.getCookie('csrftoken'),
              },
              body: JSON.stringify({ ids: selectedIds }),
            });
          } catch (err) {
            console.error("Errore eliminazione MySwan:", err);
          }
        }
      }

      $("#div_upload_my_swan").modal("hide");

    } catch (error) {
      console.error("Errore MySwan save dal commento:", error);
      bootbox.alert(common.getTrad("Si è verificato un errore durante il caricamento dei file."));
    } finally {
      this.setState({ mySwanSaving: false });
      $(".close-upload-modal").removeAttr("disabled");
    }
  }

  getMySwanFileType = (item) => {
    if (item.type === 'video') return 'video';
    if (item.type === 'photo') return 'image';
    const ext = item.url.split('?')[0].split('.').pop().toLowerCase();
    const types = {
      image: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'tiff', 'ico'],
      video: ['mp4', 'avi', 'mov', 'mkv', 'webm', 'flv', 'wmv', 'm4v', 'ogv'],
      pdf: ['pdf'],
      word: ['doc', 'docx', 'odt', 'rtf'],
      excel: ['xls', 'xlsx', 'ods', 'csv'],
      archive: ['zip', 'rar', '7z', 'tar', 'gz'],
      audio: ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a'],
    };
    for (const [type, exts] of Object.entries(types)) {
      if (exts.includes(ext)) return type;
    }
    return 'generic';
  }

  getMySwanFileIcon = (type) => {
    const map = {
      video: { icon: 'fas fa-file-video', color: '#e74c3c' },
      pdf: { icon: 'fas fa-file-pdf', color: '#c0392b' },
      word: { icon: 'fas fa-file-word', color: '#2b579a' },
      excel: { icon: 'fas fa-file-excel', color: '#217346' },
      archive: { icon: 'fas fa-file-archive', color: '#f39c12' },
      audio: { icon: 'fas fa-file-audio', color: '#9b59b6' },
      generic: { icon: 'fas fa-file-alt', color: '#7f8c8d' },
    };
    return map[type] ?? map.generic;
  }

  async changeReviewState(newState, text='') {
    const $ = window.$
    $("#state i").removeClass("fas fa-caret-down")
    $("#state i").addClass("fa fa-spinner fa-spin")
    var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + "change_state/"
    var isAdmin = this.state.userInfo?.is_admin_ticket
    var zadmi = null
    if (isAdmin === true) {
      zadmi = this.state.userInfo.userInfo.ZUSER
    }
    var data = {
      'ticket_id': this.state.pageContent?.ID,
      'CAVTI': newState,
      'isAdmin': isAdmin,
      'ZADMI': zadmi,
      'ruser': this.state.pageContent?.RUSER,
      'path': this.props.pageContent?.path,
      'dcapo': this.state.pageContent?.DCAPO,
      'ddocu': this.state.pageContent?.DDOCU,
      'cfold': this.state.pageContent?.CFOLD,
      'ccaus': this.state.pageContent?.CCAUS,
      'textComment' : text

    }
    var response = await common.apiCall(apiUrl, "PATCH", data, true, false, "json");
    if (response.error === false) {
      var pageContent = this.state.pageContent;
      pageContent.CAVTI = response.newState;
      pageContent.ULUPD = response.now;
      pageContent.RADMI = response.RADMI;
      pageContent.CCOLO = response.CCOLO;
      pageContent.UFSPC = response.UFSPC;
      pageContent.URICH = response.URICH;
      
      this.setState({ pageContent: pageContent });
      common.clear_cache_after_save('swticket');
    } else {
      console.error("error" + response.error);
    }
    $("#state i").removeClass("fa fa-spinner fa-spin")
    $("#state i").addClass("fas fa-caret-down")
    if(newState === '90'){
      this.causaleChiusura();
    }
  }

  async buttonReadState(newstateRead) {
    var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + "change_read_state/"
    var CAVTL = ''
    if ((newstateRead === '00' && this.state.pageContent?.CAVTI === '05') || (newstateRead === '10' && this.state.pageContent?.CAVTI === '05')) {
      CAVTL = '20'
    } else {
      CAVTL = '00'
    }
    var data = {
      'ticket_id': this.state.pageContent?.ID,
      'CAVTI2': this.state.pageContent?.CAVTI,
      'CAVTL': CAVTL,
      'ZADMI': this.state.userInfo.userInfo.ZUSER,
      'UFSPC': this.state.pageContent?.UFSPC,
    }
    var response = await common.apiCall(apiUrl, "PATCH", data, true, false, "json");
    if (response.error === false) {
      var pageContent = this.state.pageContent;
      pageContent.CAVTL = response.newStateRead;
      pageContent.CCOLO = response.CCOLO;
      pageContent.UFSPC = response.UFSPC;
      pageContent.CSOAM = response.CSOAM;
      this.setState({ pageContent: pageContent });
      common.clear_cache_after_save('swticket');
    } else {
      console.error("error" + response.error);
    }
  }


  async changeReviewStateRead(newStateRead, changeType = false) {
    let userinfoPromise = new Promise((resolve, reject) => {
      common.getUserInfo().then(data => {
        if (data.error === false) {
          resolve(data)
        }
        else {
          reject(console.error("error" + data.error))
        }
      })
    })
    let chnageStatePromise = new Promise((resolve, reject) => {
      userinfoPromise.then(data => {
        var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + "change_read_state/"
        var CAVTL = ''
        if (newStateRead === '20' && data.is_admin_ticket === true) {
          CAVTL = '00'
        } else if (newStateRead === '10' && data.is_admin_ticket === false) {
          CAVTL = '00'
        } else if (newStateRead === '20' && data.is_admin_ticket === false) {
          return
        } else if (newStateRead === '10' && data.is_admin_ticket === true) {
          return
        } else if (newStateRead === '00') {
          return
        }else if (newStateRead === null && changeType === true){
          CAVTL = '20'
        } else if (newStateRead === null && changeType === false){
          CAVTL = '00'
        }
        var dataPatch = {
          'ticket_id': this.state.pageContent?.ID,
          'CAVTL': CAVTL,
          'CAVTI2': this.state.pageContent?.CAVTI,
          'ZADMI': data.userInfo.ZUSER,
        }

        common.apiCall(apiUrl, "PATCH", dataPatch, true, false, "json").then((response) => {
          if (response.error === false) {
            this.state.pageContent.CCOLO = response.CCOLO;
            this.state.pageContent.RADMI = response.RADMI;
            this.state.pageContent.UFSPC = response.UFSPC;
            this.state.pageContent.CSOAM = response.CSOAM;
            resolve(response)
          } else {
            reject(console.error("error" + response.error));
          }
        })
      })
    })
    Promise.allSettled([userinfoPromise, chnageStatePromise]).then((results) => {
      let statusList = []
      for (let i = 0; i < results.length; i++) {
        statusList.push(results[i].status)
      }
      if (statusList.every((val, i, arr) => val === arr[0])) {
        var newState = results[1].value
        //newState = JSON.parse(JSON.stringify(newState))
        var pageContent = this.state.pageContent;
        pageContent['CAVTL'] = newState.newStateRead;
        common.clear_cache_after_save('swticket');
        this.setState({ pageContent: pageContent })
      }
    })
  }

  generateSelect2() {
    const $ = window.$
    function format(state) {
      if (!state.id) return state.text; // optgroup
      return '<span>' + common.getTrad(state.text) + '</span>';
    }

    $(".select2_ticket_option").select2({
      templateResult: format,
      templateSelection: format,
      width: '100%',
      escapeMarkup: function (m) { return m; },
      allowClear: true,
      language: common.getLanguage(),
      placeholder: common.getTrad("Seleziona un' opzione"),
    });
  }


  modifyTicket = () => {
    const $ = window.$
    this.setState({ editTicket: true})
    $(".select_ticket").trigger("change");
    $(".select_ticket").attr("disabled", true);
    $(document).on("keydown", "form", function (event) {
      return event.key != "Enter";
    });
    var description = this.state.pageContent?.BDOCU
    var campiTicket
    campiTicket = this.state.tipologie_ticket_attive[this.state.pageContent?.CCAUS];
    const idsDescription = new Set(description.map(d => d.id));
    var campi = campiTicket.campi.filter(c => idsDescription.has(c.id));
    campi.map((index, key) => {
      this.generateSelect2()
      $('#' + description[key]?.id).removeAttr('disabled')

    });
  }

  declareSelectTipologie = () => {
    const $ = window.$;
    if ($('.select_ticket').data('select2'))
      $(".select_ticket").select2("destroy");

    $(".select_ticket").select2({
      placeholder: this.props.marche_attive.length <= 1 ? common.getTrad("Seleziona un tipo") : common.getTrad("Seleziona prima una marca"),
      allowClear: true,
      language: common.getLanguage(),
      minimumResultsForSearch: -1,
      width: '100%',
      dropdownAutoWidth: true,
      //dropdownParent: $('#select_ticket_container')
    });

    $('.select_ticket').on('select2:select', (e) => {
      $(".select_ticket").val(e.target.value).trigger("change");
      if (this.state.tipologie_ticket_attive[e.target.value]?.tipo === 'TV'){
        this.setState({ isTicketVehicle: true, checkVinVehicle: true, autoCompleteForm: true, tipoTicket: e.target.value })
      }else{
        this.setState({ isTicketVehicle: false, checkVinVehicle: false, autoCompleteForm: false, tipoTicket: e.target.value });
      }
    });

    $('.select_ticket').on('select2:unselect', (e) => {
      $(".select_ticket").val(e.target.value).trigger("change");
      this.setState({ isTicketVehicle: false, checkVinVehicle: false, autoCompleteForm: true, tipoTicket: e.target.value })
    });

  }

  declareSelectProdotto = () => {
    const $ = window.$;
    const ticket_type = this.state.tipoTicket;
    const sub_types = this.state?.tipologie_ticket_attive[ticket_type]?.['sotto_tipo'];

    if ($('#tipo_prodotto_new').hasClass("select2-hidden-accessible")) {
      $("#tipo_prodotto_new").select2("destroy");
    }

    if (sub_types) {
      $('#tipo_prodotto_new').empty();

      $('#tipo_prodotto_new').append($('<option>', { value: '', text: '' }));

      Object.keys(sub_types).forEach((key) => {
        let value = sub_types[key];
        $('#tipo_prodotto_new').append($('<option>', {
          value: value['id'],
          text: value['titolo']
        }));
      });
    }

    $("#tipo_prodotto_new").select2({
      allowClear: true,
      language: common.getLanguage(),
      minimumResultsForSearch: -1,
      width: '100%',
      dropdownAutoWidth: true,
    });

    if (this.state.subType) {
      $('#tipo_prodotto_new').val(this.state.subType).trigger('change');
    }

    $('#tipo_prodotto_new').off('select2:select select2:unselect');

    $('#tipo_prodotto_new').on('select2:select', (e) => {
      this.setState({ subType: e.params.data.id });
    });

    $('#tipo_prodotto_new').on('select2:unselect', () => {
      this.setState({ subType: '' });
    });
  };


  handleClickRemoveFileConverted = (e) => {
    const $ = window.$;
    var numFile = 0;
    if (window.convertedFiles !== undefined && window.convertedFiles.length > 0) {
      numFile = common.object_value_in_array(window.convertedFiles, 'id', $(e.target).attr("data-key"));
      if (numFile > -1) {
        window.convertedFiles.splice(numFile, 1);
        window.uploadedFiles.splice(numFile, 1);
        $(".col-6[data-key='" + $(e.target).attr("data-key") + "']").remove();
        $("label[for='file_multiple'] .span_label_file").html(common.getTrad("File selezionati ({{numero}})", { numero: window.convertedFiles.length }))
      }
    }
  }

  missingFieldsMsg(){
    var arrFields = this.state.pageContent.missingData 
    if (Array.isArray(arrFields)) {
      return arrFields.map((index, key) => {
        index = JSON.parse(index);
        var error_type = index['errorType'];
        if(error_type === 'missing_field'){
          var msg = common.getTrad("Campo mancante");
          var field = index['field'];
          var trad
          var actualType = this.state.tipologie_ticket_attive[this.state.tipoTicket];
          actualType['campi'].map((index, key)=> {
            if(index['id'] === field){
              trad = actualType['campi'][key]['titolo'];
            }
          })
        }
        else if(error_type === 'missing_title'){
          var msg = common.getTrad("Campo mancante");
          var trad = common.getTrad('Titolo');
        }
        else if(error_type === 'missing_attachment'){
          var msg = common.getTrad("Allegati inseriti: ") +  index['field'] + common.getTrad("   Allegati richiesti: " );
          var actualType = this.state.tipologie_ticket_attive[this.state.tipoTicket];
          actualType['campi'].map((index, key) => {
            if (index['id'] === 'file_multiple') {
              var nAtt = actualType['campi'][key]['nAttachment'];
              msg = msg + nAtt
            }
          })
          var trad = common.getTrad('Allegati');
        }
        return(
          <tr>
            <td><small>{trad}</small></td>
            <td><small>{msg}</small></td>
          </tr>
        )
      })
    }
  }

  handleRichiestaCOC(){
    const $ = window.$;
    $('#selezione_COC').on('change', function () {
      const $infoText = $('.form-text.info-text-coc');
      const $infoText2 = $('.form-text.info2-text-coc');
      const $file = $('#file_multiple');
      const $label = $('label[for="file_multiple"]').first();
      if ($(this).val() === 'anticipo') {
        $infoText.removeAttr('hidden');
        $infoText2.attr('hidden', '');
        if ($label.find('span.danger').length === 0) {
          $label.append('<span class="danger">*</span>');
        }
        $file.prop('required', true);
      } else if ($(this).val() === 'moto_demo') {
        $infoText.attr('hidden', '');
        $label.find('span.danger').remove();
        $file.prop('required', false);
      } else {
        $infoText.attr('hidden', '');
        $infoText2.attr('hidden', '');
        $label.find('span.danger').remove();
        $file.prop('required', false);
      }
    });
  }

  getImageFromExt(fileName){
    var extList = fileName.split('.')
    const ext = extList[extList.length -1]
    if(ext === 'png' || ext === 'jpg' || ext === 'jpeg' || ext === 'webp'){
      return "far fa-file-image"
    }else if(ext === 'pdf'){
      return "far fa-file-pdf"
    }else if(ext === 'txt' || ext === 'docx'){
      return "far fa-file-word"
    }else if(ext === 'xlsx' || ext === 'xls'){
      return "far fa-file-excel"
    }else if(ext === 'zip' || ext === 'rar' || ext === "7z" || ext === "tar"){
      return "far fa-file-archive"
    }else if(ext === 'mov' || ext === 'mkv' || ext === 'mp4'){
      return "far fa-file-video"
    }else{
      return "far fa-file-alt"
    }
  }

  getResponse(response) {
    this.setState({ tagliando: response });
  }
  
  componentDidUpdate(prevProps, prevState) {
    const $ = window.$;

    if (this.state.showModal && !prevState.showModal) {
      $(window).on("beforeunload", function (e) {
        e.preventDefault();
        e.returnValue = "";
      });
      $("body").css("overflow", "hidden");
    }

    if (!this.state.showModal && prevState.showModal) {
      $(window).off("beforeunload");
      $("body").css("overflow", "");
    }

    if (this.state.tipoTicket === 'richiestaCOC' || this.state.tipoTicket === 'richiestaCOCdepo'){
      this.handleRichiestaCOC()
    }

    $(document).ready(function () {
      $("#con-left, #con-right").each(function () {
        $(this).animate(
          { scrollTop: $(this).prop('scrollHeight') },
          1000
        );
      });
    });

    $("body #app .loadingDiv").show();
    var pagina = this.state.pagina;
    var paginaAttuale = parseInt(pagina.pagina_attuale), pagineTotali = '';
    if (this.state.ticketsByVinVehicle !== undefined && this.state.ticketsByVinVehicle.items !== undefined) {
      pagineTotali = parseInt(this.state.ticketsByVinVehicle.items_total / env.TABLE_PAGE_LENGTH);
      if ((this.state.ticketsByVinVehicle.items_total % env.TABLE_PAGE_LENGTH) > 0) {
        pagineTotali++;
      }

      var buttons = [];
      $('#paginazione_custom').html("");

      if (pagineTotali > 1) {
        var paginazione_custom_content = "";
        const NUM_PAGINE_VISIBILI = 3;
        const SALTO_PAGINE = 5;
        var start = paginaAttuale - parseInt(NUM_PAGINE_VISIBILI / 2) - SALTO_PAGINE;
        var end = paginaAttuale + parseInt(NUM_PAGINE_VISIBILI / 2) + SALTO_PAGINE;
        var allPreviousMax = (SALTO_PAGINE - parseInt(NUM_PAGINE_VISIBILI / 2));
        var allNextMax = pagineTotali - allPreviousMax;
        var startCiclo = (start <= 0 ? 1 : start);
        var endCiclo = (end > pagineTotali ? pagineTotali : end);

        for (var i = startCiclo; i <= endCiclo; i++) {
          var print = false;
          var ellipsis = false;

          if ((paginaAttuale <= allPreviousMax && i < paginaAttuale) || (paginaAttuale > allNextMax && i > paginaAttuale))
            print = true;
          if (i >= (paginaAttuale - parseInt(NUM_PAGINE_VISIBILI / 2) - 1) && i <= (paginaAttuale + parseInt(NUM_PAGINE_VISIBILI / 2) + 1))
            print = true;
          if (i === startCiclo || i === endCiclo || i === paginaAttuale)
            print = true;
          if (i !== paginaAttuale && ((i === (paginaAttuale - parseInt(NUM_PAGINE_VISIBILI / 2) - 1) && paginaAttuale >= allPreviousMax) || (i === (paginaAttuale + parseInt(NUM_PAGINE_VISIBILI / 2) + 1) && paginaAttuale <= allNextMax)))
            ellipsis = true;

          if (print)
            buttons.push('<li class="paginate_button page-item ' + (paginaAttuale === i ? "active" : "") + '"><p id="page_num_' + i + '" class="page-link">' + (ellipsis ? "&hellip;" : i) + '</p></li>');
        }

        for (var b = 0; b < buttons.length; b++) {
          if (buttons[b] !== undefined && buttons[b] !== null) {
            $('#paginazione_custom').html(paginazione_custom_content + buttons[b]);
            paginazione_custom_content = $('#paginazione_custom').html();
          }
        }
      }

      if (this.state.userInfo.is_admin_ticket !== undefined && !this.state.userInfo.is_admin_ticket) {
        $("body").append('<style>.ticket_creator{display:none}</style>');
      }

      $("#tickets_vehicle_table").DataTable().clear();
      $("#tickets_vehicle_table").DataTable().rows.add(this.state.ticketsByVinVehicle.items);
      $("#tickets_vehicle_table").DataTable().draw();
      $("#tickets_vehicle_table").DataTable().responsive.recalc();
      $("#tickets_vehicle_table").DataTable().resize();
      $("table>tbody>tr").attr("role", "row");
    }

    var isEdit = this.state.editTicket;
    if (isEdit === true) {
      $("#toolbar").hide();
      $("#stampa").hide();
    }
    $('#file_multiple').unbind('change keyup');
    $("form input[data-alert]").on("change keyup", (e) => {
      let id = $(e.target)[0].id;
      if ($(e.target).data('alert') === 'alert_KM_inf') {
        // Rimuove solo dall'interno della label associata a questo input
        $("label[for='" + id + "'] .alert_KM_inf").remove();
        let km_index = common.object_value_in_array(this.state.pageContent?.BDOCU, "id", "n_km")
        let km_val = parseInt(this.state.pageContent?.BDOCU[km_index].value)
        if (parseInt(e.target.value) < km_val) {
          $("label[for='" + id + "']").append(
            "<p class='alert_KM_inf'>" +
            "<i class='fas fa-exclamation-triangle text-warning'></i> " +
            common.getTrad("Attenzione: percorrenza inferiore rispetto agli interventi precedenti") +
            "</p>"
          );
        }
      }
    });

    this.declareSelectTipologie();
    $("#causale_chiusura").select2({
      placeholder: common.getTrad("Seleziona una causale"),
      allowClear: true,
      language: common.getLanguage(),
      minimumResultsForSearch: -1,
      width: '100%',
      dropdownAutoWidth: true
    });

    $('#causale_chiusura').on("select2:select", (e) => {
      this.setState({ selectedCausale: e.params.data.id, error: null})
    });
    $('#causale_chiusura').on('select2:unselect', (e) => {
      this.setState({ selectedCausale: null })
    })

    $(() => {
      $('[data-toggle="tooltip"]').tooltip();

      $("label[for='file_multiple'] .span_label_file").html("");
      if (window.convertedFiles !== undefined && window.convertedFiles.length > 0) {
        this.state.fine = false;
        $("label[for='file_multiple'] .span_label_file").html(common.getTrad("File selezionati ({{numero}})", { numero: window.convertedFiles.length }))
      } else {
        this.state.fine = true;
      }
    });

    $(".Trad_scegli_file").html("<i class='fas fa-file-upload'></i> " + common.getTrad("Scegli..."));
    $(".Trad_dimensione_massima_200MB").html(common.getTrad("Dimensione massima di caricamento 200 MB") + "<br/> " + common.getTrad("Puoi raggruppare più foto in un unico file archivio (zip, rar, etc.)"));
    $("#file").on("change", (e) => {
      var inputId = $("#" + e.target.id);
      if (inputId.length > 0) {
        var file = inputId[0].files[0];
        if (file !== undefined && file.size > 209715200) {
          bootbox.alert(common.getTrad("Attenzione!<br/>Il file che stai cercando di caricare supera la dimensione massima consentita di 200 MB.<br/>Riduci la dimensione e caricalo nuovamente."));
          inputId.val(null);
          $(".span_label_" + e.target.id).html('');
        }
      }
    });

    if (this.state.newTicket && this.state.tipoTicket) {
      this.declareSelectProdotto()
    } else if (!this.state.newTicket && this.state.tipoTicket && Object.keys(this.state.tipologie_ticket_attive).length > 0){
      this.declareSelectProdotto()
      //$('#tipo_prodotto_new').val(this.state.subType).trigger("change");
    }
  
    
    $.widget("custom.customAutocomplete", $.ui.autocomplete, {
      _renderItem: function (ul, item) {
        return $("<li>")
          .append(`
        <div>
          <div style="font-family:'Montserrat',sans-serif;">${item.label}</div>
          <div style="font-size:0.8em; font-family:'Montserrat',sans-serif; color:#ec7205;padding-top:2px;">${item.sublabel}</div>
        </div>
      `)
          .appendTo(ul);
      }
    });

    $("#numero_di_serie_claim").customAutocomplete({
      minLength: 3,
      source: (request, response) => {
        const MAX_RESULTS = 10;
        const $input = $("#numero_di_serie_claim");

        this.getTicketsAutocomplete().then(ticket_ids => {
          const filtered = ticket_ids.filter(ticket =>
            ticket.ID.toString().includes(request.term)
          );
          const risultati = filtered.map(ticket => ({
            label: ticket.ID,
            value: ticket.ID,
            sublabel: ticket.DDOCU
          }));

          const risultatiLimitati = risultati.slice(0, MAX_RESULTS);
          response(risultatiLimitati);
          if (risultatiLimitati.length === 1) {
            const unico = risultatiLimitati[0];
            $input.val(unico.label);
            $("#hiddenTicketId").val(unico.value);
            $input.customAutocomplete("close");
            $input.css("border-color", "");
            $input.data("autoSelected", true);
          } else {
            $input.removeData("autoSelected");
          }
        });
      },
      select: (event, ui) => {
        const $input = $("#numero_di_serie_claim");
        $input.val(ui.item.label);
        $("#hiddenTicketId").val(ui.item.value);
        $input.css("border-color", "");
        $input.data("autoSelected", true)
        return false;
      },
      change: (event, ui) => {
        const $input = $("#numero_di_serie_claim");
        const wasAutoSelected = $input.data("autoSelected");

        if (wasAutoSelected) {
          $input.removeData("autoSelected");
          return;
        }

        if (!ui.item) {
          $input.val("");
          $("#hiddenTicketId").val("");
          $input.css("border-color", "red");
        }
      }
    });

    var oggi = new Date();
    $("input.date_input").datepicker({
      endDate: oggi.toDateString(),
      weekStart: 1,
      todayBtn: "linked",
      language: common.getLanguageDatePicker(),
      autoclose: true,
      todayHighlight: true
    });

    $('#file_multiple').unbind('change keyup');
    $("#file_multiple").on('change', (e) => {
      const files = e.target.files;
      var filesName = [] 
      Object.keys(files).forEach(k => {
        if (files[k] !== undefined && files[k].size > 209715200) {
          bootbox.alert(common.getTrad("Attenzione!<br/>Il file che stai cercando di caricare supera la dimensione massima consentita di 200 MB.<br/>Riduci la dimensione e caricalo nuovamente."));
          return false;
        } 
        else {
          window.convertedFiles = [
            ...window.convertedFiles,
            { id: URL.createObjectURL(files[k]), file: files[k] }
          ];
        }
      });

      $("#data-pre").html('');
      $("#data-pre").addClass('d-flex flex-wrap fileConverted no-gutters');
      window.convertedFiles.map((i, key) => {
        key++

        $("#data-pre").append('<div class="col-6 p-2" data-key="' + i.id + '">'
          + '<div id="file_' + key + '" class="col-12 p-2 divInfoFileLoaded" data-key="' + i.id + '">'
          + '<span><i class="' + this.getImageFromExt(i.file.name) + ' p-1 ml-1 mr-1" style="font-size: 1.8em; color:slategrey"></i></span>'
          + '<span class="filedata"><small class="textBaloon p-0 m-0 text-muted">' + common.getTrad('File') + ': ' + common.truncateFileName(i.file.name.toLowerCase(), 24) + '<br/>' + common.getTrad('Dimensione') + ': ' + common.humanFileSize(i.file.size) + '</small></span>'
          + '<span class="	far fa-trash-alt removeFileConverted ml-1 mr-1" onClick="console.log(19);" data-key="' + i.id + '"></span>'
          + '</div>'
          + '</div>'
          + '</div>');
          // + '<div class="flex-grow-1 mb-1">'
          // + '<div class="progress pr_' + key + '" style="height: 7px">'
          // + '<div class="progress-bar progress-bar_' + key + ' progress-bar-striped progress-bar-animated" role="progressbar" style="' + progressCSS + '">' + progressHTML + '</div>'
          // + '</div>'
          // + '</div>'
          // }
      });
      $(".removeFileConverted").unbind('click');
      $(".removeFileConverted").on('click', (e) => {
        this.handleClickRemoveFileConverted(e);
      });
      $("label[for='file_multiple'] .span_label_file").html(common.getTrad("File selezionati ({{numero}})", { numero: window.convertedFiles.length }))

    });
    
    $('#annulla2').off('click').on('click', (e) => {
      const history = createBrowserHistory();
      if (window.confirm(common.getTrad("La pagina contiene modifiche non salvate. Si è sicuri di voler abbandonare senza salvare?"))) {
        common.goBack(history);
        return true;
      }
    });

    if (this.state.pageContent !== undefined && !this.state.newTicket && Object.keys(this.state.tipologie_ticket_attive).length > 0) {
      this.populateForm()
      if(this.state.adminLoaded === false){
        this.renderToolTipClaim()
      }
      $("body #app .loadingDiv").hide();
    } else if (this.state.newTicket) {
      $("body #app .loadingDiv").hide();
    }
    this.declareSelectTipologie();
    if (this.state.newTicket && this.state.tipoTicket) {
      this.declareSelectProdotto()
    } else if (!this.state.newTicket && this.state.tipoTicket && Object.keys(this.state.tipologie_ticket_attive).length > 0) {
      this.declareSelectProdotto()
      
    }
    this.generateSelect2()

    if (!this.state.checkVinVehicle && this.state.isTicketVehicle && this.state.autoCompleteForm)
      this.updateDataForm(this.state.tagliando.veicolo);

    if (this.state.checkVinVehicle && this.state.dataSave)
      $("#EDTNTELA").val(this.state.dataSave.vin_vehicle);


    if ($('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita').val() !== '') {
      $('#richiesto_contatto_telefonico').prop('checked', true);
      $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita').attr('required', 'required');
      $(".select2_disponibilita").select2();
    } else {
      $('#richiesto_contatto_telefonico').prop('checked', false);
      $(".select2_disponibilita").select2().next().hide();
      $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita, .disclaimer_disponibilita, .disclaimer_contatto, label[for="persona_contatto"], label[for="numero_telefono_contatto"], label[for="fascia_oraria_disponibilita"]').val('').hide();
    }

    if (this.state.isChanged === false){
      var tipologie_keys = Object.keys(this.props.tipologie_ticket_attive && (this.props.marche_attive !== undefined && this.props.marche_attive.length === 1))
      if (tipologie_keys.length === 1 && this.state.newTicket) {
        $("#select_ticket").val($("#select_ticket > option:not([value='']):first").val()).trigger("select2:select")
        $("#select_ticket_container").hide()
        this.setState({isChanged : true})
      }
    }
  }

  componentWillUnmount() {
    const $ = window.$;
    $(window).off("beforeunload");
  }
 

  dataFromModal(val) {
    val["comments"] = this.state.pageContent.comments
    this.setState({ newTypeData: val, changeType: true })
  }

  updateDataForm(veicolo) {
    const $ = window.$;
    var campiTicket = this.state.tipologie_ticket_attive[this.state.tipoTicket];
    var dataSave = {};
    window.convertedFiles = [];
    if (multibrand.is_multibrand_portal())
      campiTicket = this.state.tipologie_ticket_attive[this.state.tipoTicket];
    for (let c = 0; c < campiTicket.campi.length; c++) {
      var valoreCampo = $("#" + campiTicket.campi[c].id)[0] !== undefined ? $("#" + campiTicket.campi[c].id)[0].defaultValue : "";
      if (valoreCampo !== undefined && valoreCampo !== null && valoreCampo !== "") {
        $("#" + campiTicket.campi[c].id).attr("value", veicolo[valoreCampo]);
        $("#" + campiTicket.campi[c].id).attr("data-min", veicolo[valoreCampo]);
        if ($("#" + campiTicket.campi[c].id).attr('data-save'))
          dataSave[$("#" + campiTicket.campi[c].id).attr('data-save')] = veicolo[valoreCampo];
      }
    }

    this.setState({ autoCompleteForm: false, dataSave: dataSave })
  }


  deleteContent() {
    const $ = window.$;
    $("#deleteTicket").prop("disabled", true);
    $("#deleteTicket i").removeClass("far fa-trash-alt")
    $("#deleteTicket i").addClass("fa fa-spinner fa-spin")
    var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path);
    var data = {
      'CAVTI': this.state.pageContent?.CAVTI
    }
    common.apiCall(apiUrl, "DELETE", data, true, false, "text").then(result => {
      result = JSON.parse(result)
      if (result['result'] === true) {
        var nowUrl = String(window.location.href);
        if (this.state.pageContent.CFOLD === 'deliveryClaims'){
          var redirectUrl = nowUrl.replace(/(reclami-consegna\/)\d+(\/?)/, '$1');    
        }else{
          var redirectUrl = nowUrl.replace(/(ticket\/)\d+(\/?)/, '$1');
        }
        window.location.replace(redirectUrl);
      } else {
        bootbox.alert(common.getTrad("Errore. Si prega di riprovare"));
        console.error("error" + result.error);
        $("#deleteTicket").prop("disabled", false);
        $("#deleteTicket i").addClass("far fa-trash-alt")
        $("#deleteTicket i").removeClass("fa fa-spinner fa-spin")
      }
    })
  }

  confirmLeave = (e) => {
    const $ = window.$;
    if (this.state.editTicket) {
      bootbox.confirm(
        {
          message: common.getTrad("La pagina contiene modifiche non salvate. Si è sicuri di voler abbandonare senza salvare?"),
          buttons: {
            confirm: {
              label: common.getTrad('Si'),
              className: 'btn-danger'
            },
            cancel: {
              label: common.getTrad('No'),
              className: 'btn-light'
            }
          },
          callback: (result) => {
            if (result) {
              this.setState({ editTicket: false, changeType: false, newTypeData: null, subType: this.state.pageContent["CSCAU"] })
              $("#toolbar").show();
              $("#stampa").show();
              $(document).off("keydown", "form");
              $(window).resize(function () {
                $('.select2').css('width', "100%");
              });
            }
          }
        }
      )
    }
  }

  async download_file_from_bucket(e, pFILENAME, pURL) {
    e.stopPropagation()
    var directory = pFILENAME.split("/")
    var filename = directory.slice(-1);
    fetch(pURL)
      .then(resp => resp.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => console.error('Download error: ' + filename));
  }

  handleClickRemoveFile(typeToRemove) {
    bootbox.confirm({
      message: common.getTrad("L'azione cancellerà in modo definitivo il contenuto selezionato.<br><b>Si è sicuri di voler eliminare il contenuto?</b>"),
      buttons: {
        confirm: {
          label: common.getTrad('Si'),
          className: 'btn-danger'
        },
        cancel: {
          label: common.getTrad('No'),
          className: 'btn-light'
        }
      },
      callback: (result) => {
        if (result)
          this.removeFile(typeToRemove);
      }
    });
  }

  checkNumberTypes(){
    const $ = window.$;
    if (Object.keys(this.state.tipologie_ticket_attive).length === 1) {
      var tipologie = Object.keys(this.state.tipologie_ticket_attive)
      $("#select_ticket").val(tipologie[0]).change();
      this.state.tipoTicket = tipologie[0]
      $("#select_ticket_container").hide();
    }
  }

  countAttachmentsLoaded() {
    let nAttachmentLoaded = 0
    var description = this.state.pageContent.description;
    var fileOldTicket = common.object_value_in_array(this.state.pageContent.description, 'id', 'file');
    if (fileOldTicket > 0) {
      nAttachmentLoaded = -1;
    } else {
      for (let i = 0; i < description.length; i++) {
        if (description[i].id === 'comments') {
          for (let a = 0; a < description[i].value.length; a++) {
            if (description[i].value[a].attachment) {
              nAttachmentLoaded++;
            }
          }
        }
      };
    }

    return nAttachmentLoaded;
  }

  statoTicket() {
    switch (this.state.pageContent?.CAVTI) {
      case '90':
        return ('<span class="p-1" style="background: #dc3545;color:#fff;"><i class="fas fa-envelope"></i> ' + common.getTrad("Chiuso") + '</span>')
      case '00':
        return ('<button title=\'' + common.getTrad('Mostra dati mancanti') + '\'class="btn-group btn-group-sm mr-3" data-toggle="modal" data-target="#modalErrors" style="background: #ffc107; color:#000; padding: 4px; border: yellow;"><i class="far fa-envelope-open"></i> ' + common.getTrad("Bozza"))
      case '75':
        return ('<span class="p-1" style="background: #6c757d;color:#fff;"><i class="far fa-envelope-open"></i> ' + common.getTrad("Lavorazione interna") + '</span>')
      case '11':
        return ('<span class="p-1" style="background: #ffc107;color:#000;"><i class="fas fa-envelope-open"></i> ' + common.getTrad("Incompleto") + '</span>')
      case '70':
        return ('<span class="p-1" style="background: #007bff;color:#fff;"><i class="far fa-envelope-open"></i> ' + common.getTrad("In lavorazione") + '</span>')
      case '80':
        return ('<span class="p-1" style="background: #17a2b8;color:#fff;"><i class="far fa-envelope"></i> ' + common.getTrad("Lavorazione terminata") + '</span>')
      default:
        return ('<span class="p-1" style="background: #28a745;color:#fff;"><i class="fas fa-envelope-open-text"></i> ' + common.getTrad("Aperto") + '</span>')
    }
  }

  bannerChiusura(){
    if(this.state.pageContent?.CCCAU && this.state.pageContent.CAVTI === '90' && this.state.tipologie_ticket_attive){
      var titolo = null
      if (this.state.pageContent.CCCAU === 'approved_logistic'){
        titolo = "Approved - Logistic error"
      } else if (this.state.pageContent.CCCAU === 'approved_identification'){
        titolo = "Approved - Identification team error"
      } else if (this.state.pageContent.CCCAU === 'approved_other'){
        titolo = "Approved - Other reason"
      } else if (this.state.pageContent.CCCAU === 'not_approved_no_data'){
        titolo = "Not approved - Incomplete data"
      } else if (this.state.pageContent.CCCAU === 'not_approved'){
        titolo = "Not approved"
      }
      return ('<span id="filtri_alert" class="alert alert-warning p-1 ml-3" role="alert"><b>'
        + titolo +
        '</b></span>')
      }
    else{
      return ''
    }
  }

  handleContactChecked = (e) => {
    const $ = window.$;
    // Inizializzo la select per la fascia oraria
    $(".select2_disponibilita").select2({
      placeholder: common.getTrad("Seleziona una fascia oraria"),
      language: common.getLanguage(),
      allowClear: true,
      width: '100%'
    });
    // Verifico se è spuntato il checkbox per il contatto telefonico
    if (e.target.checked === true) {
      // Mostro i campi richiesti
      $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita, .disclaimer_disponibilita, .disclaimer_contatto, label[for="persona_contatto"], label[for="numero_telefono_contatto"], label[for="fascia_oraria_disponibilita"]').show().css("display", "block");
      // Testo small
      $('.disclaimer_disponibilita').html(common.getTrad("I nostri operatori ti contatteranno durante i giorni feriali, dal lunedì al venerdì"));
      $('.disclaimer_contatto').html(common.getTrad("Invitiamo a richiedere il ricontatto telefonico solo in caso di situazioni complesse o già gestite tramite ticket precedenti."));
      // Aggiungo attributo required
      $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita').attr('required', 'required');
      // Aggiungo * alla label
      $('label[for="persona_contatto"], label[for="numero_telefono_contatto"], label[for="fascia_oraria_disponibilita"]').html(function (i, html) { return html + '<span style="color: red;">*</span>'; });
    } else {
      // Nascodo i campi richiesti
      $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita, .disclaimer_disponibilita, .disclaimer_contatto, label[for="persona_contatto"], label[for="numero_telefono_contatto"], label[for="fascia_oraria_disponibilita"]').val('').hide();
      // Rimuovo attributo required
      $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita').removeAttr('required');
      $("#fascia_oraria_disponibilita").select2('destroy').val('').hide();
      // Rimuovo asterisco dalla label
      $('label[for="persona_contatto"], label[for="numero_telefono_contatto"], label[for="fascia_oraria_disponibilita"]').text(function (i, text) { return text.replace('*', ''); });

    }
  }

  openExternal = (e, fileName, fileUrl) => {
    e.stopPropagation();
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    } else {
      console.warn(`File URL for ${fileName} is missing`);
    }
  }

  renderFormTicket(is_modal = false) {
    const $ = window.$;
    let fieldPrefix = "";
    if (is_modal)
      fieldPrefix = "modal_old_";
    let classNameColTicket = '';
    if (this.state.newTicket) {
      var campiTicket = this.state.tipologie_ticket_attive[this.state.tipoTicket];
      return campiTicket.campi.map((index, key) => {
        if (index.id !== 'comments') {
          if (index.id === 'richiesto_contatto_telefonico') {
            return (
              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center">
                <div className="checkbox-wrapper-3 pt-2">
                  <input
                    id="richiesto_contatto_telefonico"
                    name="richiesto_contatto_telefonico"
                    className="checkbox-wrapper"
                    type="checkbox"
                    onChange={this.handleContactChecked}
                  />
                  <label htmlFor="richiesto_contatto_telefonico" className="toggle">
                    <span></span>
                  </label>
                </div>
                <span className="pl-2">{common.getTrad("Richiesto contatto telefonico")}</span>
                <small className="ml-2 disclaimer_contatto" style={{fontWeight: "bold",fontSize: "small"}}>{common.getTrad("Invitiamo a richiedere il ricontatto telefonico solo in caso di situazioni complesse o già gestite tramite ticket precedenti.")}</small>
              </div>
            )
          }
          if (index.id === 'persona_contatto' || index.id === 'numero_telefono_contatto' || index.id === 'fascia_oraria_disponibilita') {
            if ($('#' + index.id + ', .disclaimer_disponibilita, label[for="' + index.id + '"]').css('display') !== 'block')
              $('#' + index.id + ', .disclaimer_disponibilita, label[for="' + index.id + '"]').hide();
          }
          if (index.id === 'file')
            this.state.googleCloudBucketPath = false
          if (index.id === 'file_multiple')
            if (index.titolo != undefined)
              this.state.indexTitle = true;
          if (index.id === 'mandatory_attachments' || index.id === 'mandatory_attachments_2') {
            classNameColTicket = 'col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12'
          } else {
            classNameColTicket = 'col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12'
          }
          return (
            <div key={key} className={classNameColTicket}>
              <div className="form-group">
                <label htmlFor={index.id}>
                  {this.state.marcaDefault !== undefined || (this.props.marche_attive !== undefined && this.props.marche_attive.length === 1) ? common.getTrad(index.titolo) : common.getTrad(index.titolo)}
                  &nbsp;{index.html.search("required") > -1 ? <span className="danger">*</span> : ""}
                  {index.tip !== undefined && index.tip !== null && index.tip !== '' ?
                    <>&nbsp;<i className="fas fa-info-circle" data-original-title={index.tip} data-toggle="tooltip" data-placement="top"></i></>
                    :
                    ""
                  }
                  {index.id === 'file_multiple' && this.state.userInfo?.userInfo?.auth && common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "MS") > -1 ?
                    <button
                      type="button"
                      className="btn btn-sm btn-light ml-2"
                      onClick={this.openMySwanModal}
                    >
                      <i className="fas fa-cloud mr-1"></i>
                      {common.getTrad("Aggiungi da MySwan")}
                    </button>
                    :
                    ""
                  }
                </label>
                <div dangerouslySetInnerHTML={{ __html: index.html }} />
              </div>
            </div>
          )
        } else {
          return ""
        }
      });
    } else {
      var isEdit = this.state.editTicket;
      //let nAttachmentLoaded = this.countAttachmentsLoaded()
      if (this.state.changeType && !is_modal) {
        var campiTicket = this.state.tipologie_ticket_attive[this.state.newTypeData.tipo];
        var description = this.state.newTypeData.description;
        var comments = this.state.newTypeData.comments;
        const idsDescription = new Set(description.map(d => d.id));
        var campi = campiTicket.campi.filter(c => idsDescription.has(c.id));
      } else {
        var campiTicket = this.state.tipologie_ticket_attive[this.state.pageContent?.CCAUS];
        var description = this.state.pageContent?.BDOCU;
        var comments = this.state.pageContent.comments;
        const idsDescription = new Set(description.map(d => d.id));
        var campi = campiTicket.campi.filter(c => idsDescription.has(c.id));
      }
      this.keyComments = common.object_value_in_array(description, 'id', 'comments');
      if (this.keyComments === -1) {
        this.keyComments = comments.length
      }
      return campi.map((index, key) => {
        if (index.id !== 'comments') {
          if (index.id === 'file')
            this.state.googleCloudBucketPath = false;
          if (index.id === 'file_multiple')
            return ('')
          if (index.id === 'richiesto_contatto_telefonico' && isEdit) {
            return (
              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center">
                <div className="checkbox-wrapper-3 pt-2">
                  <input
                    id="richiesto_contatto_telefonico"
                    name="richiesto_contatto_telefonico"
                    className="checkbox-wrapper"
                    type="checkbox"
                    onChange={this.handleContactChecked}
                  />
                  <label htmlFor="richiesto_contatto_telefonico" className="toggle">
                    <span></span>
                  </label>
                </div>
                <span className="pl-2">{common.getTrad("Richiesto contatto telefonico")}</span>
              </div>
            )
          } else if (index.id === 'richiesto_contatto_telefonico' && isEdit === false){
            return('')
          }
          if (index.id === 'persona_contatto' || index.id === 'numero_telefono_contatto' || index.id === 'fascia_oraria_disponibilita') {
            let fieldValue = description[key] ? description[key].value : ''; // Verifica se description[key] esiste
            if (fieldValue !== '') {
              $('#richiesto_contatto_telefonico').prop('checked', true);
              $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita, .select2-disponibilita, label[for="persona_contatto"], label[for="numero_telefono_contatto"], label[for="fascia_oraria_disponibilita"]').show();
            } else {
              $('#richiesto_contatto_telefonico').prop('checked', false);
              $('#persona_contatto, #numero_telefono_contatto, #fascia_oraria_disponibilita, .select2-disponibilita, label[for="persona_contatto"], label[for="numero_telefono_contatto"], label[for="fascia_oraria_disponibilita"]').hide();
            }
          }
          // if (index.nAttachment <= nAttachmentLoaded || nAttachmentLoaded === -1)
          //   $("#file_multiple").attr("required", false);
          $("label[for='file_multiple'] .danger").hide();
          if (index.titolo != undefined);
          this.state.indexTitle = true;
          if (index.id === 'mandatory_attachments' || index.id === 'mandatory_attachments_2') {
            if (index.id === 'mandatory_attachments' || index.id === 'mandatory_attachments_2' && isEdit === false) {
              return ('')
            } else if (index.id === 'mandatory_attachments' || index.id === 'mandatory_attachments_2' && is_modal === true) {
              return ('')
            } else {
              classNameColTicket = 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12'
            }
          } else {
            if (index.id === 'mandatory_attachments' || index.id === 'mandatory_attachments_2' && isEdit === false) {
              return ('')
            }
            else if (index.id === 'mandatory_attachments' || index.id === 'mandatory_attachments_2' && is_modal === true) {
              return ('')
            } else {
              classNameColTicket = 'col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12'
            }
          }
          if (is_modal === true) {
            classNameColTicket = ''
          }
          if (this.state.pageContent?.CAVTI === '00') {
            let ticketErrors = {}, pos = -1;
            pos = common.object_value_in_array(this.state.pageContent?.BDOCU, "id", "messageErrors");
            if (pos > -1)
              ticketErrors = this.state.pageContent?.BDOCU[pos]?.value;

            if (ticketErrors[index.id] !== undefined && ticketErrors[index.id] === 'REQUIRED') {
              window.$(".labelError_" + index.id).html(common.getTrad("Campo obbligatorio")).show();
            }
          }
          

          let elemHTML = index.html;
          if (is_modal === true) {
            let appoElem = $.parseHTML(index.html);
            $(appoElem).attr("id", fieldPrefix + index.id);
            elemHTML = appoElem[0].outerHTML;
          }

          return (
            <div key={key} className={classNameColTicket}>
              <div className="form-group">
                <label htmlFor={index.id}>
                  {this.state.marcaDefault !== undefined || (this.props.marche_attive !== undefined && this.props.marche_attive.length === 1) ? common.getTrad(index.titolo) : index.titolo}
                  &nbsp;{index.html.search("required") > -1 && isEdit === true ? <span className="danger">*</span> : ""}
                  {index.tip !== undefined && index.tip !== null && index.tip !== '' ?
                    <>&nbsp;<i className="fas fa-info-circle" data-original-title={index.tip} data-toggle="tooltip" data-placement="top"></i>
                    </>
                    :
                    ""
                  }
                </label>
                <div dangerouslySetInnerHTML={{ __html: elemHTML }} />
                <p className={"invalid-feedback labelError_" + index.id}></p>
                {index.id === 'file' ?
                  !this.state.newTicket && is_modal === false ?
                    <>
                      <input type="hidden" name="removeFile" id="removeFile" />
                      {this.state.pageContent.file ?
                        <p>
                          {common.getTrad("File caricato")}:&nbsp;
                          <b style={{ wordBreak: 'break-word' }}>{this.state.pageContent.file.filename}</b>
                          ({common.humanFileSize(this.props.pageContent.file.size)})&nbsp;
                          <button type="button" className="btn bottone_default buttonRemoveImage" onClick={() => this.handleClickRemoveFile("file")}>
                            <i title={common.getTrad("Elimina")} className="fas fa-times "></i>
                          </button>
                        </p>
                        :
                        <></>
                      }
                    </>
                    :
                    <></>
                  :
                  <></>

                }
              </div>
            </div>
          )
        } else {
          return ""
        }
      });
    }
  }

  stateAndComment(){
    return (
      <>
      {this.state.userInfo.userInfo?.GTSFINI?.TICKET_THREAD_INTERNO === 'S' ?
          <>
            {this.state.userInfo.is_admin_ticket && this.state.editTicket === false && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' ?
              <span class="btn-group dropup">
                <button id="changeS" style={{ borderRadius: "0px 8px 8px 0px" }} class="btn btn-secondary dropdown-toggle dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title={common.getTrad("Salva e cambia stato")}>
                  <span class="sr-only"></span>
                </button>
                <span class="dropdown-menu dropdown-menu-right">
                  {this.state.pageContent?.CAVTI.indexOf('90') > -1 ?
                    <button id="saveComment2" className="dropdown-item" type="submit" value="05" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Aperto")}</button>
                    :
                    this.state.pageContent?.CAVTI.indexOf('11') > -1 ?
                      <>
                        <button id="saveComment2" className="dropdown-item" type="submit" value="05" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Aperto")}</button>
                        <button id="saveComment2" className="dropdown-item" type="submit" value="90" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Chiuso")}</button>
                      </>
                      :
                      this.state.pageContent?.CAVTI.indexOf('70') > -1 ?
                        <>
                          <button id="saveComment2" className="dropdown-item" type="submit" value="11" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Incompleto")}</button>
                          <button id="saveComment2" className="dropdown-item" type="submit" value="75" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Lavorazione interna")}</button>
                          <button id="saveComment2" className="dropdown-item" type="submit" value="90" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Chiuso")}</button>
                        </>
                        :
                        this.state.pageContent?.CAVTI.indexOf('05') > -1 ?
                          <>
                            <button id="saveComment2" className="dropdown-item" type="submit" value="70" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("In lavorazione")}</button>
                            <button id="saveComment2" className="dropdown-item" type="submit" value="11" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Incompleto")}</button>
                            <button id="saveComment2" className="dropdown-item" type="submit" value="75" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Lavorazione interna")}</button>
                            <button id="saveComment2" className="dropdown-item" type="submit" value="90" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Chiuso")}</button>
                          </>
                          :
                          this.state.pageContent?.CAVTI.indexOf('75') > -1 ?
                            <>
                              <button id="saveComment2" className="dropdown-item" type="submit" value="80" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Lavorazione terminata")}</button>
                            </>
                            :
                            this.state.pageContent?.CAVTI.indexOf('80') > -1 ?
                              <>
                                <button id="saveComment2" className="dropdown-item" type="submit" value="70" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("In lavorazione")}</button>
                                <button id="saveComment2" className="dropdown-item" type="submit" value="11" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Incompleto")}</button>
                                <button id="saveComment2" className="dropdown-item" type="submit" value="75" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Lavorazione interna")}</button>
                                <button id="saveComment2" className="dropdown-item" type="submit" value="90" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Chiuso")}</button>
                              </>
                              :
                              <></>
                  }
                </span>
              </span>
              :
              this.state.userInfo.is_admin_ticket && this.state.editTicket === false && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO === 'S' && this.state.pageContent?.CAVTI.indexOf('75') > -1 ?
                <span class="btn-group dropup">
                  <button id="changeS" style={{ borderRadius: "0px 8px 8px 0px" }} class="btn btn-secondary dropdown-toggle dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title={common.getTrad("Salva e cambia stato")}>
                    <span class="sr-only"></span>
                  </button>
                  <span class="dropdown-menu dropdown-menu-right">
                    {this.state.pageContent?.CAVTI.indexOf('75') > -1 ?
                      <>
                        <button id="saveComment2" className="dropdown-item" type="submit" value="80" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Lavorazione terminata")}</button>
                      </>
                      :
                      <></>
                    }
                  </span>
                </span>
                :
                <></>
            }
          </>
          :
          <>
            {this.state.userInfo.is_admin_ticket && this.state.editTicket === false ?
              <span class="btn-group dropup">
                <button id="changeS" style={{ borderRadius: "0px 8px 8px 0px" }} class="btn btn-secondary dropdown-toggle dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title={common.getTrad("Salva e cambia stato")}>
                  <span class="sr-only"></span>
                </button>
                <span class="dropdown-menu dropdown-menu-right">
                  {this.state.pageContent?.CAVTI.indexOf('90') > -1 ?
                    <button id="saveComment2" className="dropdown-item" type="submit" value="05" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Aperto")}</button>
                    :
                    this.state.pageContent?.CAVTI.indexOf('11') > -1 ?
                      <>
                        <button id="saveComment2" className="dropdown-item" type="submit" value="05" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Aperto")}</button>
                        <button id="saveComment2" className="dropdown-item" type="submit" value="90" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Chiuso")}</button>
                      </>
                      :
                      this.state.pageContent?.CAVTI.indexOf('70') > -1 ?
                        <>
                          <button id="saveComment2" className="dropdown-item" type="submit" value="11" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Incompleto")}</button>
                          <button id="saveComment2" className="dropdown-item" type="submit" value="90" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Chiuso")}</button>
                        </>
                        :
                        this.state.pageContent?.CAVTI.indexOf('05') > -1 ?
                          <>
                            <button id="saveComment2" className="dropdown-item" type="submit" value="70" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("In lavorazione")}</button>
                            <button id="saveComment2" className="dropdown-item" type="submit" value="11" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Incompleto")}</button>
                            <button id="saveComment2" className="dropdown-item" type="submit" value="90" onSubmit={this.handleSubmit}><small className="datatableSmall">{common.getTrad("Invia e imposta")}</small>{common.getTrad("Chiuso")}</button>
                          </>
                          :
                          <></>
                  }
                </span>
              </span>
              :
              <></>
            }
          </>
      }
    </>
    )
  }


  renderToolBar() {
    return (
      <div id="actions_page " className="mb-3 col" >
        {!this.state.editTicket ?
          <div className="btn-group btn-group-sm mr-3" role="group" aria-label={common.getTrad("Torna indietro")}>
            <button type="button" className="btn btn-light" onClick={() => { const history = createBrowserHistory(); common.goBack(history);}}>
              <i className="fas fa-chevron-left"></i> {common.getTrad("Torna indietro")}
            </button>
          </div>
          :
          <></>
        }
        <div className="btn-group btn-group-sm mr-3" id="toolbar" role="group" aria-label="Basic example" >
          {this.state.pageContent?.CAVTI.indexOf('90') > -1 && this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' ?
            <button type="button" id="state" className="btn btn-danger" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{common.getTrad("Chiuso")} <i className="fas fa-caret-down"></i></button>
            :
            this.state.pageContent?.CAVTI.indexOf('75') > -1 && this.state.userInfo.is_admin_ticket ?
              <button type="button" id="state" className="btn btn-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{common.getTrad("Lavorazione interna")} <i className="fas fa-caret-down"></i></button>
              :
              this.state.pageContent?.CAVTI.indexOf('70') > -1 && this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' ?
              <button type="button" id="state" className="btn btn-primary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{common.getTrad("In lavorazione")} <i className="fas fa-caret-down"></i></button>
              :
                (this.state.pageContent?.CAVTI.indexOf('11') > -1 || this.state.pageContent?.CAVTI.indexOf('00') > -1) && this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' ?
                <button type="button" id="state" className="btn btn-warning" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{common.getTrad("Incompleto")} <i className="fas fa-caret-down"></i></button>
                :
                  this.state.pageContent?.CAVTI.indexOf('80') > -1 && this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' ?
                  <button type="button" id="state" className="btn btn-info" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{common.getTrad("Lavorazione terminata")} <i className="fas fa-caret-down"></i></button>
                  :
                    this.state.pageContent?.CAVTI.indexOf('05') > -1 && this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' ?
                  <button type="button" id="state" className="btn btn-success" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{common.getTrad("Aperto")} <i className="fas fa-caret-down"></i></button>
                  :
                  <></>
          }
          {this.state.userInfo.userInfo.GTSFINI?.TICKET_THREAD_INTERNO === 'S' ?
            <div className="dropdown-menu">
              {this.state.pageContent?.CAVTI.indexOf('90') > -1 ?
                <>
                  <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('05') }}>{common.getTrad("Aperto")}</span>
                </>
                :
                this.state.pageContent?.CAVTI.indexOf('11') > -1 ?
                  <>
                    <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('05') }}>{common.getTrad("Aperto")}</span>
                    <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('90') }}>{common.getTrad("Chiuso")}</span>
                  </>
                  :
                  this.state.pageContent?.CAVTI.indexOf('70') > -1 ?
                    <>
                      <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('11') }}>{common.getTrad("Incompleto")}</span>
                      <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('75') }}>{common.getTrad("Lavorazione interna")}</span>
                      <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('90') }}>{common.getTrad("Chiuso")}</span>
                    </>
                    :
                    this.state.pageContent?.CAVTI.indexOf('05') > -1 ?
                      <>
                        <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('70') }}>{common.getTrad("In lavorazione")}</span>
                        <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('11') }}>{common.getTrad("Incompleto")}</span>
                        <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('75') }}>{common.getTrad("Lavorazione interna")}</span>
                        <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('90') }}>{common.getTrad("Chiuso")}</span>
                      </>
                      :
                      this.state.pageContent?.CAVTI.indexOf('80') > -1 ?
                        <>
                          <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('70') }}>{common.getTrad("In lavorazione")}</span>
                          <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('11') }}>{common.getTrad("Incompleto")}</span>
                          <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('75') }}>{common.getTrad("Lavorazione interna")}</span>
                          <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('90') }}>{common.getTrad("Chiuso")}</span>
                        </>
                        :
                        this.state.pageContent?.CAVTI.indexOf('75') > -1 ?
                          <>
                            <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('80') }}>{common.getTrad("Lavorazione terminata")}</span>
                          </>
                          :
                      <></>
                }
            </div>
          :
            <div className="dropdown-menu">
              {this.state.pageContent?.CAVTI.indexOf('90') > -1 ?
                <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('05') }}>{common.getTrad("Aperto")}</span>
                :
                this.state.pageContent?.CAVTI.indexOf('11') > -1 ?
                  <>
                    <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('05') }}>{common.getTrad("Aperto")}</span>
                    <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('90') }}>{common.getTrad("Chiuso")}</span>
                  </>
                  :
                  this.state.pageContent?.CAVTI.indexOf('70') > -1 ?
                    <>
                      <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('11') }}>{common.getTrad("Incompleto")}</span>
                      <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('90') }}>{common.getTrad("Chiuso")}</span>
                    </>
                    :
                    this.state.pageContent?.CAVTI.indexOf('05') > -1 ?
                      <>
                        <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('70') }}>{common.getTrad("In lavorazione")}</span>
                        <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('11') }}>{common.getTrad("Incompleto")}</span>
                        <span type="button" className="dropdown-item" onClick={() => { this.changeReviewState('90') }}>{common.getTrad("Chiuso")}</span>
                      </>
                      :
                      <></>
                }
            </div>
          }
          {this.state.userInfo.is_admin_ticket && this.state.pageContent?.CAVTI.indexOf("05") > -1 && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S'  ?
            <button id='readButton' className="btn btn-light" title={common.getTrad("Click per cambiare stato in Letto o da Leggere")} onClick={(e) => this.buttonReadState(this.state.pageContent?.CAVTL)}>
              {this.state.pageContent?.CAVTL === '00' || this.state.pageContent?.CAVTL === '10' ?
                <><i className="fas fa-check"></i> {common.getTrad("Segna come da leggere")}</>
                :
                <><i className="fas fa-check-double"></i> {common.getTrad("Segna come letta")}</>
              }
            </button>
            :
            <></>
          }

          {(Object.keys(this.state.tipologie_ticket_attive).length !== 0 && this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S') || (this.state.pageContent?.CAVTI === '11' && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S') || (this.state.pageContent?.CAVTI === '00' && !this.state.userInfo.is_admin_ticket) ?

            <button type="button" className="btn btn-light" onClick={this.modifyTicket}>
              <i className="far fa-edit"></i> {common.getTrad("Modifica")}
            </button>
            :
            <></>
          }
          {this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI.TICKET_MODIFICA_TIPOLOGIA == "S" &&
            Object.keys(this.state.tipologie_ticket_attive).length > 1 && this.state.pageContent?.CAVTI == "05" && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' ?
            <span>
              <button type="button" className="btn btn-light" data-toggle="modal" data-target="#modalTicket" onClick={this.modifyTicket}
              >
                <i className="fas fa-pencil-alt"></i> {common.getTrad("Modifica Tipologia")}
              </button>
            </span>
            :
            <></>
          }
          {((Object.keys(this.state.tipologie_ticket_attive).length !== 0 && this.state.userInfo.is_admin_ticket === true && this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO !== 'S' && this.state.userInfo.userInfo.GTSFINI?.HIDE_DELETE_TICKET !== 'S') || (this.state.userInfo.is_admin_ticket === false && this.state.pageContent.CAVTI === '00' && this.state.userInfo.userInfo.GTSFINI?.HIDE_DELETE_TICKET !== 'S')) ?
            <button
              type="button"
              id="deleteTicket"
              className="btn btn-danger"
              onClick={() => {
                bootbox.confirm(
                  {
                    message: common.getTrad("L'azione cancellerà in modo definitivo il contenuto selezionato.<br><b>Si è sicuri di voler eliminare il contenuto?</b>"),
                    buttons: {
                      confirm: {
                        label: common.getTrad('Si'),
                        className: 'btn-danger'
                      },
                      cancel: {
                        label: common.getTrad('No'),
                        className: 'btn-light'
                      }
                    },
                    callback: (result) => {
                      if (result)
                        this.deleteContent();
                    }
                  }
                )
              }
              }>
              <i className="far fa-trash-alt"></i> {common.getTrad("Elimina")}
            </button>
            :
            <></>
          }
        </div>
        {this.state.userInfo.is_admin_ticket && this.state.pageContent.RADMI ?
        <span className='btn-group px-3 pt-1'>
            <span  className="float-center circleAdmin" style={{ width: "33px", height: "33px", background: this.state.pageContent.CCOLO}} alt={this.state.pageContent.RADMI} title={this.state.pageContent.RADMI}>{common.createInitial(this.state.pageContent.RADMI)}</span>
        </span>
            :
            ""
          }
        <button type="button" id='stampa' onClick={this.stampaPagina} className="float-right btn btn-light">
          <i className="fas fa-print"></i> {common.getTrad("Stampa pagina")}
        </button>
      </div>
    )
  }

  renderChatComments(thread) {
    if (this.state?.pageContent.comments !== undefined) {
      const comments = this.state?.pageContent?.comments;
      const filteredComments = comments.filter(comment => comment.TTREACTK === thread);
      if (Array.isArray(this.state.pageContent?.comments)) {
        return filteredComments.map((index, key) => {
          const supportedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'pdf', 'mp4', 'webm'];
          if (index.BFILEFTK !== undefined && index.BFILEFTK !== null){
            var extension = index.DFILEFTK.split('.').pop().toLowerCase();
          }else{
            var extension = null
          }
          var classDefault = this.state.userInfo.is_admin_ticket ? index.ZUSERCTK === this.state.userInfo.userInfo.ZUSER ? "sent message" : "received message" : index.ZUSERCTK !== this.state.pageContent.ZUSER ? "received message" : "sent message";
          if (index.BFILEFTK !== undefined && index.BFILEFTK !== null)
            classDefault = classDefault + " has_attachment";
          if (index.BCOMMCTK === null) {
            index.BCOMMCTK = ""
          }
          if (index.FADMICTK === "S" && classDefault.includes('received message') && this.state.userInfo.is_admin_ticket) {
            classDefault = classDefault + " received_admin_comment";
          }

          let oldCausale, newCausale = '';
          if (index.CMESSCTK !== null && index.CMESSCTK !== undefined && index.CMESSCTK != '' &&
            index.BCOMMCTK != null && index.BCOMMCTK !== undefined && index.BCOMMCTK !== '') {
            try {
              var tipologieTicket = this.props.tipologie_ticket_attive;
              const data = JSON.parse(index.BCOMMCTK);
              oldCausale = tipologieTicket[data.old_data.causale]['titolo'];
              newCausale = tipologieTicket[data.new_data.causale]['titolo'];
            } catch (error) {
              console.error('Error parsing BCOMMCTK:', error);
              oldCausale = '';
              newCausale = '';
            }
          }
          return (
            index.BCOMMCTK !== undefined ?
              <div key={key} className={index.CMESSCTK ? 'system-message' : classDefault}>
                {
                  !index.CMESSCTK && classDefault.includes('received message') ? (
                    <div className="metadata-up">
                      <span className="user">
                        {index.FADMICTK === "S" ?
                          <>
                            <br /><span style={{ "color": "#3f3f8f", "paddingRight" : "50px" }}>{index.RUSERCTK}</span>
                          </>
                          :
                          <>
                            <br /><span>{index.RUSERCTK}</span>
                          </>
                        }
                      </span>
                      {index.FADMICTK === "S" ?
                        <>
                          <span className="fas fa-award fa-lg admin_sign"></span>
                        </>
                        :
                        <>
                        </>
                      }
                    </div>
                  ) : ""
                }
                {index.BFILEFTK !== undefined && index.BFILEFTK !== null ?
                  <div>
                    {supportedExtensions.includes(extension) ?
                      <div
                        className="d-flex justify-content-between align-items-center flex-wrap file_container py-2 px-2"
                        data-fancybox="gallery"
                        href={index.BFILEFTK}
                        data-caption={index.DFILEFTK}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex align-items-center flex-grow-1 me-2">
                          <span
                            className={this.getImageFromExt(index.DFILEFTK) + " me-2 pr-1 mb-1 mt-1"}
                            alt={index.DFILEFTK}
                            title={index.DFILEFTK}
                            style={{ fontSize: '1.5em', color: 'slategrey' }}
                          />
                          <small>
                            <span className="hide-on-small"style={{ fontSize: '1em'}}> &nbsp;&nbsp;{common.truncateFileName(index.DFILEFTK, 18)}&nbsp;</span>
                            &nbsp;
                            <span
                              className="fas fa-external-link-alt fa-2xs external-comment-btn align-items-right"
                              onClick={(e) => { this.openExternal(e, index.DFILEFTK, index.BFILEFTK) }}
                              style={{ color: 'grey', fontSize: '1em', cursor: 'pointer' }}
                            ></span>
                            {index.NBYTEFTK !== undefined && (
                              <>&nbsp; <small>{common.humanFileSize(index.NBYTEFTK)}</small></>
                            )}
                          </small>
                        </div>
                        <span className="ms-auto">
                          <i
                            className="fa fa-download"
                            style={{ color: 'grey', fontSize: '1em', cursor: 'pointer' }}
                            onClick={(e) => { this.download_file_from_bucket(e, index.DFILEFTK, index.BFILEFTK) }}
                          />
                        </span>
                      </div>
                    :
                      <div
                        className="d-flex justify-content-between align-items-center flex-wrap file_container py-2 px-2"
                        style={{ cursor: 'pointer' }}
                      >
                        <div className="d-flex align-items-center flex-grow-1 me-2" onClick={(e) => { this.download_file_from_bucket(e, index.DFILEFTK, index.BFILEFTK) }}>
                          <span
                            className={this.getImageFromExt(index.DFILEFTK) + " me-2 pr-1 mb-1 mt-1"}
                            alt={index.DFILEFTK}
                            title={index.DFILEFTK}
                            style={{ fontSize: '1.5em', color: 'slategrey' }}
                          />
                          <small>
                            <span className="hide-on-small" style={{ fontSize: '1em' }}>&nbsp;&nbsp;{common.truncateFileName(index.DFILEFTK, 18)}&nbsp;</span>
                            &nbsp;
                            <span
                              className="fas fa-external-link-alt fa-2xs external-comment-btn"
                              onClick={(e) => { this.openExternal(e, index.DFILEFTK, index.BFILEFTK) }}
                              style={{ color: 'grey', fontSize: '1em', cursor: 'pointer' }}
                            ></span>
                            {index.NBYTEFTK !== undefined && (
                              <>&nbsp; <small>{common.humanFileSize(index.NBYTEFTK)}</small></>
                            )}
                          </small>
                        </div>
                        <div className="ms-auto">
                          <i
                            className="fa fa-download"
                            style={{ color: 'grey', fontSize: '1em', cursor: 'pointer' }}
                            onClick={(e) => { this.download_file_from_bucket(e, index.DFILEFTK, index.BFILEFTK) }}
                          />
                        </div>
                      </div> 
                  }
                  </div>
                  :
                  ""
                }
                {
                  !index.CMESSCTK ? (
                    index.BCOMMCTK.includes("\n") ? (
                      <div dangerouslySetInnerHTML={{ __html: index.BCOMMCTK.replace(/\r?\n/g, '<br/>') }} />
                    ) : (
                      <div className="text-comment">
                        {index.BCOMMCTK}
                      </div>
                    )
                  ) :
                    ""
                }
                <span className={index.CMESSCTK ? 'system-message-metadata' : 'metadata'}>

                  {index.CMESSCTK ?
                    (<div>
                      <>
                        {index.CMESSCTK == 'CTK_TICKET_CHANGE_STATE' ?
                          <div>{common.getTrad('CTK_TICKET_CHANGE_STATE')}<br /><small>{oldCausale}&nbsp;&nbsp;<i class="fas fa-long-arrow-alt-right"></i>&nbsp;&nbsp;{newCausale}</small></div> //Cambio tipologia
                          :
                          index.CMESSCTK
                        }
                      </>
                    </div>)
                    :
                    ("")
                  }
                  <span className="time">
                    {moment(index.UINSRCTK).format('LLL')}

                    {
                      (index.FHIUSCTK !== 1 || (index.FHIUSCTK === 1 && this.state.userInfo.is_admin_ticket)) ?
                        <>
                          {index.CMESSCTK ?
                            <>
                              <span>&nbsp;-&nbsp;</span>{index.RUSERCTK}
                            </>
                            :
                            <>
                            </>
                          }
                        </> :
                        null
                    }
                  </span>
                </span>
              </div>
              :
              <></>
          )
        });
      }
    }
  }

  renderToolTipClaim(){
    var $ = window.$
    if (this.state.userInfo?.is_admin_ticket
      && window.cc.csoft === 850034
      && this.state.tipoTicket === 'ticketClaim'
      && this.state.adminLoaded === false
    ) {
      var id_ticket_identification = $("#numero_di_serie_claim").val();
      const base = (common.getTicketBackendUrl(this.props.pageContent.path)).slice(0, -15);
      var apiUrl = `${base}/${id_ticket_identification}/`;
      apiUrl = apiUrl.replace('reclami-consegna', 'ticket')
      var params = { id_ticket: id_ticket_identification };
      common.apiCall(apiUrl, "GET", params, true, false, "json").then(data => {
        let adminClosed = data['RADMI'];
        let id_confirmed = data['ID'];
        const $label = $('label[for="numero_di_serie_claim"]');

        if (adminClosed) {
          $label.after(
            '&nbsp;<i class="fas fa-info-circle" data-original-title="Admin: ' + adminClosed + '" data-toggle="tooltip" data-placement="top"></i>'
          );
          // inizializza tooltip
          $('[data-toggle="tooltip"]').tooltip();
        }

        if (id_confirmed) {
          let red = common.getFirebirdUrl(String(id_confirmed), true);
          red = red.replace('reclami-consegna', 'ticket');
          red = red.replace('//', '')
          red = red.replace('//', '/')
          var $link = $('<a>', {
            href: env.FRONTEND + red,
            target: '_blank',
            css: { marginLeft: '5px', cursor: 'pointer' },
            title: common.getTrad('Vai al ticket')
          });
          var $icon = $('<i>', { class: 'fas fa-external-link-alt' });
          $link.append($icon);
          $label.after($link);
        }

      });
      this.setState({ adminLoaded: true });
    }
  }

  afterUpload = (statusList, timestamp = null) => {
    var $ = window.$
    if (this.state.newTicket === false) {
      if (statusList.every((val, i, arr) => val === arr[0])) {
        var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + '/'
        var params = {
          'id_ticket': this.state.pageContent?.ID,
        }
        this.setState({ file_info_upload: '', file_info_upload2: '' })
        common.clear_cache_after_save("swticket");
        common.apiCall(apiUrl, "GET", params, true, false, "json").then(newData => {
          newData['BDOCU'] = JSON.parse(newData['BDOCU'])
          this.setState({ pageContent: newData });
          $('#notifica_messaggio').html('<div class="sw-alert alert alert-success animated delay-2s fadeOutRight">' + (this.stateSetBySubmit ? common.getTrad("Commento e stato salvati correttamente.") : common.getTrad("Commento salvato correttamente.")) + '</div>');
          if ($("#conversation")[0]){
            $("#conversation")[0].reset();
          }
          if ($("#conversation2")[0]) {
            $("#conversation2")[0].reset();
          }
          $("#new_comment").prop("disabled", false);
          $("#changeS").attr("disabled", false);
          $(".send.btn").prop("disabled", false);
          $(".send.btn i").removeClass("fa-spinner fa-spin");
          if (this.state.pageContent?.CAVTI === "11" && !this.state.userInfo.is_admin_ticket && !this.stateSetBySubmit) {
            this.changeReviewState("05")
          }
        })
      } else {
        this.setState({ file_info_upload: '', file_info_upload2: '' })
        $('#notifica_messaggio').html('<div class="alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.") + " <b>"
          + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
          + '<span aria-hidden="true">&times;</span>'
          + '</button>'
          + '</div>');
      }

    } else {
      if (statusList.every((val, i, arr) => val === arr[0])) {
        var ticketUrl = window.location.href
        if((window.cc.csoft >= 850100) && (window.cc.csoft <= 850199)){
          ticketUrl = ticketUrl.replace('@@newTicket', '');
        }else{
          ticketUrl = ticketUrl.replace('@@newTicket', String(timestamp));
        }
        window.location.replace(ticketUrl);
        if (this.state.pageContent?.CAVTI === "11" && !this.state.userInfo.is_admin_ticket) {
          this.changeReviewState("05")
        }
      } else {
        $('#notifica_messaggio').html('<div class="alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.") + " <b>"
          + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
          + '<span aria-hidden="true">&times;</span>'
          + '</button>'
          + '</div>');
      }
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    var $ = window.$;

    var form = e.target; 
    var formId = form.id
    var text = form.querySelector("textarea[name='new_comment']").value;
    var fileInput = form.querySelector("input[name='file_comment']").id;

    var stateValue = e.nativeEvent.submitter.value;
    if(stateValue !== "" && stateValue !== undefined && stateValue !== null){
      var withState = true
    }
    
    var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + '/'
    
    $("#new_comment").attr("disabled", true);
    $("#changeS").attr("disabled", true);
    if(formId === 'conversation'){
      $(".send.btn.one").attr("disabled", true);
      $(".send.btn.one i").addClass("fa fa-spinner fa-spin");
      var thread = 'D'
    }else{
      $(".send.btn.two").attr("disabled", true);
      $(".send.btn.two i").addClass("fa fa-spinner fa-spin");
      var thread = 'I'
    }

    var params = {
      'id_ticket': this.state.pageContent?.ID,
      'text_comm': text,
      'isNewComment': true,
      'ttrea': thread,
      'ruser': this.state.pageContent?.RUSER,
      'path' : this.props.pageContent?.path,
      'dcapo': this.state.pageContent?.DCAPO,
      'title': this.state.pageContent?.DDOCU,
      'cfold': this.state.pageContent?.CFOLD,
      'ccaus': this.state.pageContent?.CCAUS,
      'zadmi': this.state.pageContent?.ZADMI,
      'ufspc': this.state.pageContent?.UFSPC ? this.state.pageContent.UFSPC : null,
    }
    
    if(withState){
      var isAdmin = this.state.userInfo?.is_admin_ticket
      apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + "comment_and_state/"
      params['CAVTI'] = stateValue
      params['isAdmin'] = isAdmin
      params['ZADMI'] = isAdmin === true ? this.state.userInfo.userInfo.ZUSER : null
      params['textComment'] = text
    }

    let commentPromise = new Promise((resolve, reject) => {
      // Funzione di fallback riutilizzabile
      const executeFallback = () => {
        console.warn("Errore generico ricevuto con la nuova API. Tento il fallback...");
        
        // 1. Eseguo il cambio di stato della vecchia versione
        this.changeReviewState(stateValue, text);
        
        // 2. Ripristino l'URL originale
        let oldApiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + '/';
        
        // 3. Eseguo la vecchia chiamata POST
        common.apiCall(oldApiUrl, "POST", params, true, false, "json").then(fallbackData => {
          if (fallbackData.error === false) {
            resolve(fallbackData);
          } else {
            // Se anche il fallback fallisce, mostra l'errore generico
            reject();
            $("body #app .loadingDiv").fadeOut();
            $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.")
              + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
              + '<span aria-hidden="true">&times;</span>'
              + '</button>'
              + '</div>');
          }
        }).catch(() => {
            reject();
            $("body #app .loadingDiv").fadeOut();
            $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.")
              + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
              + '<span aria-hidden="true">&times;</span>'
              + '</button>'
              + '</div>');
        });
      };

      // Tentativo con la nuova logica
      common.apiCall(apiUrl, withState ? "PATCH" : "POST", params, true, false, "json").then(data => {
        if (data.error === false) {
          this.stateSetBySubmit = withState === true;
          if(withState && data.newState === '90'){
            this.causaleChiusura();
          }
          resolve(data);
        } else {
          if(data.error === 'UNAUTHORIZED'){
            reject();
            $("body #app .loadingDiv").fadeOut();
            $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Il Ticket è stato chiuso. Ricaricare la pagina. ")
              + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
              + '<span aria-hidden="true">&times;</span>'
              + '</button>'
              + '</div>');
            $(".send.btn.one").attr("disabled", false);
            $(".send.btn.one i").removeClass("fa fa-spinner fa-spin");
            $(".send.btn.two").attr("disabled", false);
            $(".send.btn.two i").removeClass("fa fa-spinner fa-spin");
          } else {
            // ERRORE GENERICO - VERIFICA FALLBACK
            if (withState) {
              executeFallback();
            } else {
              reject();
              $("body #app .loadingDiv").fadeOut();
              $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.")
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                + '<span aria-hidden="true">&times;</span>'
                + '</button>'
                + '</div>');
            }
          }
        }
      }).catch(() => {
        // Gestione di sicurezza se apiCall rigetta in caso di 404/500 invece di risolvere con errore
        if (withState) {
          executeFallback();
        } else {
          reject();
          $("body #app .loadingDiv").fadeOut();
          $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.")
            + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
            + '<span aria-hidden="true">&times;</span>'
            + '</button>'
            + '</div>');
        }
      });
    });
    
    let filesPromise = new Promise((resolve, reject) => {
      commentPromise.then(data => {
        if ($('#' + fileInput)[0].files[0] !== undefined) {
          var apiCommentUrl = common.getTicketBackendUrl(this.props.pageContent.path) + '/' + String(data['newCommentId']) + '/'
          var fileList = [$('#' + fileInput)[0].files[0]];
          this.uploadAll(fileList, apiCommentUrl + "files/").then((values) => {
            resolve(values)
          })
        } else {
          resolve()
        }
      })
    });
    
    Promise.allSettled([commentPromise, filesPromise]).then((results) => {
      let statusList = []
      for (let i = 0; i < results.length; i++) {
        statusList.push(results[i].status)
      }
      this.afterUpload(statusList)
    })
  }
  
  passToDjango = (e) => {
    e.preventDefault();
    const $ = window.$;
    var campiTicket;
    if (this?.state?.marcaDefault !== undefined) {
      campiTicket = !this.state.newTicket ? this.state.tipologie_ticket_attive[this.state.pageContent?.CCAUS] : this.state.tipologie_ticket_attive[this.state.tipoTicket]
    }
    
    if (!this.state.newTicket) {
      $("#sendToDjango").prop("disabled", true);
      $("#sendToDjango i").addClass("fa fa-spinner fa-spin");
      if ((window.cc.csoft === 850038 && this.state.tipoTicket === 'richiestaCOC') || (window.cc.csoft === 850038 && this.state.tipoTicket === 'richiestaCOCdepo')) {
        var title = this.state.tipologie_ticket_attive[this.state.tipoTicket].titolo + ' - ' + $('#telaio_modello').val() + ' - ' + $('#n_fattura').val()
      } else {
        var title = $("#title").val();
      }
      var chilometri = null;
      if (this.state.changeType) {
        var campiTicket = this.state.tipologie_ticket_attive[this.state.newTypeData.tipo];
        var newDescription = this.state.newTypeData.description
        var description = this.state.pageContent?.BDOCU;
      } else {
        var campiTicket = this.state.tipologie_ticket_attive[this.state.pageContent?.CCAUS];
        var description = this.state.pageContent?.BDOCU;
      }
      
      var campi = campiTicket.campi
      if (this.state.tipologie_ticket_attive[this.state.tipoTicket]['sotto_tipo'] && this.state.subType) {
        var sotto_tipi = this.state.tipologie_ticket_attive[this.state.tipoTicket]['sotto_tipo']
        var mySubtype = this.state.subType
        var pos = common.object_value_in_array(sotto_tipi, 'id', mySubtype)
        subType = sotto_tipi[pos].id
      }

      campi.map((index, key) => {
        if (index.id !== undefined) {
          if (index.id === "km_percorsi" || index.id === "n_km") {
            chilometri = $('#' + index.id).val();
          }
          var valore = $('#' + index.id).val();
          if (index.html.indexOf("date_input") > -1){
            let dateArray = valore.split("/");
            valore = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
          }
          if (valore !== undefined && !this.state.changeType) {
            description[key].value = valore;
          } else if (this.state.changeType) {
            if (valore !== undefined) {
              newDescription[key].value = valore;
            }
          }
        }
      });
      var causale = this.state.changeType ? this.state.newTypeData.tipo : this.state.pageContent?.CCAUS

      if (this.state.userInfo.is_admin_ticket) {
        var zadmi = this.state.userInfo.userInfo.ZUSER
      }else{
        var zadmi = this.state.pageContent?.ZADMI
      }
      var data = {
        changeType: this.state.changeType ? true : false,
        newTitle: title,
        newData: this.state.changeType ? newDescription : description,
        ticket_id: this.state.pageContent?.ID,
        state: this.state.pageContent?.CAVTI,
        utente_admin: zadmi,
        causale: causale,
        cfold: this.state.pageContent?.CFOLD,
        path: this.props.pageContent.path,
        km: chilometri,
        subType: subType
      }

      var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path);
      common.apiCall(apiUrl, "PATCH", data, true, false, "json")
        .then((newTestata) => {
          if (newTestata.error === false) {
            if (this.state.pageContent?.CAVTI === "11" && !this.state.userInfo.is_admin_ticket) {
              this.changeReviewState("05")
            }
            let testata = newTestata['testata'][0];
            testata['BDOCU'] = JSON.parse(testata['BDOCU']);         
            //this.changeReviewStateRead(null, this.state.changeType);
            this.setState({ pageContent: testata, editTicket: false, changeType: false });
            //this.renderToolBar()
            $("#toolbar").show();
            $("#stampa").show();
            $(window).resize(function () {
              $('.select2').css('width', "100%");
              });
              $('#notifica_messaggio').html('<div class="sw-alert alert alert-success animated delay-2s fadeOutRight">' + common.getTrad("Ticket modificato correttamente.") + '</div>')
            this.renderTestataDocumento();
            $(document).off("keydown", "form");
          } else {
            $("body #app .loadingDiv").fadeOut();
            $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.")
              + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
              + '<span aria-hidden="true">&times;</span>'
              + '</button>'
              + '</div>');
            $("#sendToDjango").prop("disabled", false);
            $("#sendToDjango i").removeClass("fa fa-spinner fa-spin");
          }
        });
    } else {
      $("#creaTicket").prop("disabled", true);
      $("#creaTicket i").addClass("fa fa-spinner fa-spin");
      if ((window.cc.csoft === 850038 && this.state.tipoTicket === 'richiestaCOC') || (window.cc.csoft === 850038 && this.state.tipoTicket === 'richiestaCOCdepo')) {
        var title = this.state.tipologie_ticket_attive[this.state.tipoTicket].titolo + ' - ' + $('#telaio_modello').val() + ' - ' + $('#n_fattura').val()
      } else {
        var title = $("#title").val();
      }
      var description = [];
      var chilometri = null
      campiTicket.campi.map((index, key) => {  
        let campo = {};
        let id = index.id;
        if (id === "comments") {
          return ('');
        } else {
          if(id === "km_percorsi" || id === "n_km"){
            chilometri = $('#' + id).val();
          }
          let valore = $('#' + index.id).val();
          if (index.html.indexOf("date_input") > -1) {
            let dateArray = valore.split("/");
            valore = `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`;
          }
          if (valore !== undefined) {
            campo["id"] = id;
            campo["value"] = valore;
          }
          if (valore != undefined) {
            description.push(campo);
          };
        };
      });

      var timestamp = new Date().getTime();
      var ID = { id: "ticketID", value: timestamp };

      if (this.state.isTicketVehicle === false) {
        var type = "TN";
        var veicolo = null
      } else {
        var type = "TV";
        var veicolo = { id: "veicolo",
            value: {
                propretario: {
                  "RACQU": this.state.tagliando.veicolo["RACQU"],
                  "RAGG1": this.state.tagliando.veicolo["RAGG1"],
                  "DLOAQ": this.state.tagliando.veicolo["DLOAQ"],
                  "NTEL1": this.state.tagliando.veicolo["NTEL1"],
                  "NTEL3": this.state.tagliando.veicolo["NTEL3"],
                  "DINAQ": this.state.tagliando.veicolo["DINAQ"],
                  "DCAPO": this.state.tagliando.veicolo["DCAPO"],
                  "CNAZI": this.state.tagliando.veicolo["CNAZI"],
                },
                "NTELA": this.state.tagliando.veicolo["NTELA"],
                "CMODE": this.state.tagliando.veicolo["CMODE"],
                "CMODG": this.state.tagliando.veicolo["CMODG"],
                "CVEIC": this.state.tagliando.veicolo["CVEIC"],
                "NCILI": this.state.tagliando.veicolo["NCILI"],
                "DVEIC": this.state.tagliando.veicolo["DVEIC"],
                "DCOLO": this.state.tagliando.veicolo["DCOLO"],
                "UGARA": this.state.tagliando.veicolo["UGARA"],
                "UGARE": this.state.tagliando.veicolo["UGARE"],
                "UIMMA": this.state.tagliando.veicolo["UIMMA"],
                "FSTAT": this.state.tagliando.veicolo["FSTAT"],
                "NKMPE_PREC": this.state.tagliando.veicolo["NKMPE_PREC"],
                "NTARG": this.state.tagliando.veicolo["NTARG"],
              }
            }
      }
      

      var telaio = this.state.isTicketVehicle ? this.state.dataSave.vin_vehicle : null //AGGIUNGERE LOGICA PER TELAIO QUANDO SI UTILIZZERANNO PORTALI TICKET_VEHICLE
      var subType = null
      
      if (this.state.tipologie_ticket_attive[this.state.tipoTicket]['sotto_tipo']){
        var sotto_tipi = this.state.tipologie_ticket_attive[this.state.tipoTicket]['sotto_tipo']
        var mySubtype = this.state.subType
        var pos = common.object_value_in_array(sotto_tipi, 'id', mySubtype)
        subType = sotto_tipi[pos].id
      }


      description.push(ID)
      if(this.state.isTicketVehicle){
        description.push(veicolo)
      }

      if ($('#file_multiple').val() !== undefined) {
        var indexTipologia
        var nAttachmentsLoaded
        var nAttachment
        nAttachmentsLoaded = $('#data-pre')[0].childElementCount

        if (this.state.newTicket) {
          var campiTicket = this.state.tipologie_ticket_attive[this.state.tipoTicket];
          if (this.state.marcaDefault !== undefined)
            campiTicket = this.state.tipologie_ticket_attive[this.state.tipoTicket];
        }

        indexTipologia = common.object_value_in_array(campiTicket.campi, 'id', 'file_multiple');
        nAttachment = campiTicket.campi[indexTipologia].nAttachment;

        if (nAttachmentsLoaded > 0 && nAttachmentsLoaded < nAttachment) {
          bootbox.alert(common.getTrad("Attenzione!<br/>È necessario caricare almeno {{nAttachment}} file!", { nAttachment: nAttachment }));
          $("#creaTicket").prop("disabled", false);
          $("#creaTicket i").removeClass("fa fa-spinner fa-spin");
          return false;
        }

        var data = {
          ticket_id: timestamp,
          title: title,
          bdocu: description,
          type: type,
          marca: this.state.marcaDefault,
          causale: this.state.tipoTicket,
          telaio: telaio,
          km: chilometri,
          path: this.state.pathname,
          subType: subType,
          marca_veicolo: this.state.isTicketVehicle ? this.state.tagliando.veicolo["ZMAVE"] : this.state.marcaDefault

        }

        var ticketUrl = window.location.href
        ticketUrl = ticketUrl.replace('@@newTicket', String(timestamp))
        var fileList = []

        var apiUrl = common.getTicketBackendUrl(this.state.pathname) + '/' + String(timestamp) + '/';

        let ticketPromise = new Promise((resolve, reject) => {
          common.apiCall(apiUrl, "POST", data, true, false, "json").then(data => {
            if (data.error === false) {
              resolve(data)
            } else {
              if (data.error === "Unauthorized"){
                reject()
                $("body #app .loadingDiv").fadeOut();
                $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Brand Error.")
                  + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                  + '<span aria-hidden="true">&times;</span>'
                  + '</button>'
                  + '</div>');
                $("#sendToDjango").prop("disabled", false);
                $("#sendToDjango i").removeClass("fa fa-spinner fa-spin");
                $("#creaTicket").prop("disabled", false);
                $("#creaTicket i").removeClass("fa fa-spinner fa-spin");
              }else{
                reject()
                $("body #app .loadingDiv").fadeOut();
                $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.")
                  + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                  + '<span aria-hidden="true">&times;</span>'
                  + '</button>'
                  + '</div>');
                $("#creaTicket").prop("disabled", false);
                $("#creaTicket i").removeClass("fa fa-spinner fa-spin");
              }
            }
          })
        });
        let uploadPromise = new Promise((resolve, reject) => {
          ticketPromise.then(data => {
            if (data.error === false) {
              //$("body #app .loadingDiv").show();
              for (let i = 0; i < window.convertedFiles.length; i++) {
                fileList.push(window.convertedFiles[i]);
              }
              this.uploadAll(fileList, apiUrl + "files/", timestamp).then((values) => {
                resolve(values)
              })
            }
            else {
              reject()
            }
          });
        })
        Promise.allSettled([ticketPromise, uploadPromise]).then((results) => {
          let statusList = []
          for (let i = 0; i < results.length; i++) {
            statusList.push(results[i].status)
          }
          this.afterUpload(statusList, timestamp)
        })
      }
    }
  }

  uploadAll = (fileList, path, timeStamp) => {
    let uploadStatusList = [];
    for (let i = 0; i < fileList.length; i++) {
      uploadStatusList.push(this.uploadFile(fileList[i], path, i, timeStamp));
    }

    return new Promise((resolve, reject) => {
      Promise.all(uploadStatusList).then((values) => {
        resolve(values);
      });
    });
  }

  uploadFile = (fileElement, path, key, timestamp = null) => {
    let file = fileElement.file ? fileElement.file : fileElement
    const $ = window.$;
    var uploadAttempts = 0 ;
    let out = new Promise((resolve, reject) => {
      //const release = await mutexUp.acquireQueued();
      this.uploadPercentages[file] = 0;
      var uploadFile = new tus.Upload(file, {
        endpoint: path + "/",
        retryDelays: [0, 3000],
        withCredentials: true,
        overridePatchMethod: false,
        headers: {
          'Accept': 'application/json',
          "authorization": "Bearer " + common.getLocalLoginToken()
        },
        metadata: {
          filename: file.name,
          "content-type": file.type,
        },
        onError: (err) => {
          if(!this.state.newTicket){
            console.log("Errore caricamento file -> " + err.toString())
            $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.") + " <b>"
            + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
            + '<span aria-hidden="true">&times;</span>'
            + '</button>'
            +'</div>');
            var apiUrl = common.getTicketBackendUrl(this.props.pageContent.path) + '/'
            var params = {
              'id_ticket': this.state.pageContent?.ID,
            }
            this.setState({ file_info_upload: '', file_info_upload2: '' })
            common.clear_cache_after_save("swticket");
            common.apiCall(apiUrl, "GET", params, true, false, "json").then(newData => {
              newData['BDOCU'] = JSON.parse(newData['BDOCU'])
              this.setState({ pageContent: newData });
              if ($("#conversation")[0]) {
                $("#conversation")[0].reset();
              }
              $("#new_comment").prop("disabled", false);
              $(".send.btn").prop("disabled", false);
              $(".send.btn i").removeClass("fa-spinner fa-spin");
            })
          }else{
            $('#notifica_messaggio').html('<div class="sw-alert alert alert-danger animated">' + common.getTrad("Errore qualcosa è andato storto.") + " <b>"
              + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
              + '<span aria-hidden="true">&times;</span>'
              + '</button>'
              + '</div>');
            var ticketUrl = window.location.href
            ticketUrl = ticketUrl.replace('@@newTicket', String(timestamp));
            window.location.replace(ticketUrl);
            if (this.state.pageContent?.CAVTI === "11" && !this.state.userInfo.is_admin_ticket) {
              this.changeReviewState("05")
            }
          }
        },
        onProgress: (bytesUploaded, bytesTotal) => {
          if (bytesUploaded === 0) {
            uploadAttempts += 1;
          } else {
            uploadAttempts = 0; // reset the counter if bytesUploaded is not 0
          }
          this.setState({ uploadAttempts });
          if (uploadAttempts >= 2) {
            uploadAttempts = 0;
            reject(console.error('Upload failed to progress after multiple attempts.'))
          }
          var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2)
          this.uploadPercentages[file] = percentage;
          const progressElement = $(".divInfoFileLoaded[data-key='" + fileElement.id + "']");
          if (progressElement.length) {
            progressElement.css('background-position', `${100 - percentage}% 0`);
          }
          // $('.progress-bar_' + String(key + 1)).css('width', percentage + '%').html('&nbsp;');
          // $("#divCaricamento_file").html(
          //   '<div class="progress">' +
          //   '<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="' + percentage + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + percentage + '%">' + percentage + '%</div>' +
          //   '</div>'
          // );
        },
        onSuccess: () => {
          resolve([uploadFile.file.name, uploadFile.url]);
          //release();
        }
      });
      
      uploadFile.start();
    })
    return out
  }

  clickBrands(tipoFunzione, params) {
    this.setState({ marcaDefault: params[tipoFunzione], tipoTicket: '' })
  }

  getTipologieTicketAbilitate = () => {
    let ret = [];
    let allowedTypes = null;

    if (this.state.marcaDefault === undefined || this.state.marcaDefault === null ||
      this.state.tipologie_ticket_attive === undefined || this.state.tipologie_ticket_attive === null || this.state.tipologie_ticket_attive.length <= 0)
      return ret;

    if (this.state.pageContent.description.allowed_types !== undefined &&
      this.state.pageContent.description.allowed_types !== null &&
      this.state.pageContent.description.allowed_types.length > 0
    ) {
      allowedTypes = this.state.pageContent.description.allowed_types;
    }

    let tipologieMarca = this.state.tipologie_ticket_attive[this.state.marcaDefault];
    for (let key in tipologieMarca) {
      let elem = tipologieMarca[key];

      if (elem?.no_insert === true)
        continue;
      if (allowedTypes !== null && allowedTypes.indexOf(key) <= -1)
        continue;

      ret[key] = elem;
    }

    return ret;
  }

  static getDerivedStateFromProps(props, state) {
    let newState = state;
    if (props.tipologie_ticket_attive !== state.tipologie_ticket_attive)
      newState.tipologie_ticket_attive = props.tipologie_ticket_attive;

    if (newState === state)
      return null;
    else
      return newState;
  }

  render(props) {

    // if (this.state.userInfo.id !== undefined && this.state.Lock.creator !== undefined) {
    //   if (this.state.userInfo.id !== this.state.Lock.creator) {
    //     return (<Navigate from={this.state.pathname} to={common.getUrlPath(this.state.pageContent['@id'])} />)
    //   }
    // }
    Fancybox.bind('[data-fancybox="gallery"]', {
      'Thumbs': false,
      'Fullscreen': false,
      'defaultDisplay': true,
      'Toolbar': true,
      'Hash': false
    });
    var is_disabled = false;
    const $ = window.$
    if (this.props.marche_attive !== undefined && this.props.marche_attive.length > 1) {
      if (multibrand.is_multibrand_portal()) {
        if ($('.select_marche').val() === "tutti_modelli"){
          is_disabled = true;
          $(".select_ticket").val("").trigger("change")
        }
      }
    }

    let filterVM = (
      <FilterVM
        customClass="col-xl-6 col-lg-6"
        marche_attive={this.props.marche_attive}
        tableType='ticket'
        onClick={(tipoFunzione, params) => this.clickBrands(tipoFunzione, params)}>
      </FilterVM>
    )

    if (!multibrand.is_multibrand_portal() && this.state.marcaDefault !== undefined) {
      filterVM = (
        <input type="hidden"
          name="select_vm"
          id="select_vm"
          value={this.state.marcaDefault}
        />
      )
    }
    if (this.state.newTicket) {
      var tipologieTicket = this.props.tipologie_ticket_attive;
      var marcheAttive = this.props.marche_attive;
    }
    // let messageErrors = {}, pos = -1;
    // pos = common.object_value_in_array(this.state.pageContent.description, "id", "messageErrors");
    // if (pos > -1)
    //   messageErrors = this.state.pageContent.description[pos]?.value;

    var vehicleLoaded = false;
    if (this.state.tagliando !== undefined && this.state.tagliando.veicolo !== undefined)
      vehicleLoaded = true;

    var pos = common.object_value_in_array(this.state.pageContent?.BDOCU, "id", "veicolo");
    var veicolo = this.state.pageContent.BDOCU[pos]?.value

    return (
      <>
        {!this.state.newTicket ?
          <>
            {this.state.pathname !== "" ?
              <>
                {Object.keys(this.state.tipologie_ticket_attive).length === 0 ?
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 content_testo">
                  </div>
                  :
                  <>
                    {!this.state.newTicket ?
                      <div className="tab active col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 tab-content">
                        {!this.state.newTicket && this.state.editTicket ?
                          <h4>{common.getTrad("Modifica Ticket")}</h4>
                          :
                          <></>
                        }
                        {this.state.editTicket ?
                          <hr />
                          :
                          <></>
                        }


                        {this.renderToolBar()}
                        {this.renderModalChiusura()}
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 content_testo">
                          {this.state.editTicket === false ?
                            <h1>
                              {this.state.pageContent?.DDOCU}
                            </h1>
                            :
                            <></>
                          }
                        </div>
                        <br />
                        {this.renderTestataDocumento()}
                        {this.state.editTicket === false ?
                          <>
                            <div className="col">
                              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item">
                                  <a className="nav-link active" id="pills-richiesta-tab" data-toggle="pill" href="#pills-richiesta" role="tab" aria-controls="pills-richiesta" aria-selected="true">{common.getTrad("Richiesta")}</a>
                                </li>
                                <>
                                  {this.state.userInfo.is_admin_ticket ?
                                    <li className="nav-item">
                                      <a className="nav-link" id="pills-dealer-tab" data-toggle="pill" href="#pills-dealer" role="tab" aria-controls="pills-dealer" aria-selected="false">{common.getTrad("Dealer")}</a>
                                    </li>
                                    :
                                    <></>
                                  }
                                  {this.state.userInfo.is_admin_ticket && (window.cc.csoft === 850036 || window.cc.csoft === 850038) ? 
                                    <li className="nav-item">
                                      <a
                                        className="nav-link"
                                        id="pills-dispositivi-texa-tab"
                                        data-toggle="pill"
                                        href="#pills-dispositivi-texa"
                                        role="tab"
                                        aria-controls="pills-dispositivi-texa"
                                        aria-selected="false"
                                        onClick={() => this.getTableDiagnosiTexa()}
                                      >
                                        {common.getTrad("Dispositivi Texa")}
                                        <span id="counterDispositiviTexa" className="badge badge-secondary ml-1"></span>
                                      </a>
                                    </li>
                                    :
                                    <></>
                                  }
                                  {veicolo !== undefined &&  veicolo !== null ?
                                    <li className="nav-item">
                                      <a className="nav-link" id="pills-veicolo-tab" data-toggle="pill" href="#pills-veicolo" role="tab" aria-controls="pills-veicolo" aria-selected="false">{common.getTrad("Veicolo")}</a>
                                    </li>
                                    :
                                    <></>
                                  }
                                </>
                                {this.state.userInfo.is_admin_ticket && this.state.pageContent.NTELA ?
                                  <>
                                    {common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "CG") > -1 || common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "GG") > -1 ?
                                      <li className="nav-item">
                                        <a className="nav-link" id="pills-garanzie-tab" data-toggle="pill" onClick={() => this.getTableWarranty()} href="#pills-garanzie" role="tab" aria-controls="pills-garanzie" aria-selected="false">{common.getTrad("Garanzie")}</a>
                                      </li>
                                      :
                                      <></>
                                    }
                                    {common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "CT") > -1 || common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "GT") > -1 ?
                                      <li className="nav-item">
                                        <a className="nav-link" id="pills-tagliandi-tab" data-toggle="pill" onClick={() => this.getTableService()} href="#pills-tagliandi" role="tab" aria-controls="pills-tagliandi" aria-selected="false">{common.getTrad("Tagliandi")}</a>
                                      </li>
                                      :
                                      <></>
                                    }
                                    {common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "CA") > -1 || common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "GA") > -1 ?
                                      <li className="nav-item">
                                        <a className="nav-link" id="pills-attivazioni-tab" data-toggle="pill" onClick={() => this.getTableActivation()} href="#pills-attivazioni" role="tab" aria-controls="pills-attivazioni" aria-selected="false">{common.getTrad("Attivazioni")}</a>
                                      </li>
                                      :
                                      <></>
                                    }
                                    {common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "CM") > -1 || common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "GM") > -1 ?
                                      <li className="nav-item">
                                        <a className="nav-link" id="pills-rimappature-tab" data-toggle="pill" onClick={() => this.getTableRimappature()} href="#pills-rimappature" role="tab" aria-controls="pills-rimapppature" aria-selected="false">{common.getTrad("Rimappature")}</a>
                                      </li>
                                      :
                                      <></>
                                    }
                                    <li className="nav-item">
                                      <a className="nav-link" id="pills-ticket-tab" data-toggle="pill" onClick={() => this.adjustColumns('tickets_firebird_table')}  href="#pills-ticket" role="tab" aria-controls="pills-veicolo" aria-selected="false">{common.getTrad("Ticket")}</a>
                                    </li>
                                    <li className="nav-item">
                                      <a className="nav-link cursor" id="pills-parts-finder" onClick={() => this.getLinkPartsFinder()}>{common.getTrad('Epc')}
                                        <figure style={{ float: "left", width: "40px", marginLeft:"-10px"}} src={env.MENU_ICONS_PATH + (window.cc.usePersonalIcons ? window.cc.csoft : "900000") + "/menu-epc.svg"} className="svg">
                                        </figure>
                                      </a>
                                    </li>
                                  </>
                                  :
                                  <></>
                                }
                              </ul>
                            </div>
                            <div className="tab-content" id="pills-tabContent">
                              <div className="tab-pane fade show active" id="pills-richiesta" role="tabpanel" aria-labelledby="pills-richiesta-tab">
                                <div className="row">{
                                  this.state.pageContent !== undefined ?
                                    this.renderFormTicket()
                                    :
                                    <></>
                                }
                                </div>
                              </div>
                              {this.state.userInfo ?
                                <div className="tab-pane fade" id="pills-dealer" role="tabpanel" aria-labelledby="pills-dealer-tab">
                                  <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                      <div className="form-group">
                                        <b>{common.getTrad("Codice Dealer")}:</b>&nbsp;{this.state.pageContent?.CCORR}
                                      </div>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                      <div className="form-group">
                                        <b>{common.getTrad("Nome Dealer")}:</b>&nbsp;{this.state.pageContent?.RUSER}
                                      </div>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                      <div className="form-group">
                                        <b>{common.getTrad("Nazione")}:</b>&nbsp;{this.state.pageContent?.DNAZI}
                                      </div>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                      <div className="form-group">
                                        <b>{common.getTrad("Indirizzo")}:</b>&nbsp;{this.state.pageContent?.DINDI}
                                      </div>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                      <div className="form-group">
                                        <b>{common.getTrad("Località")}:</b>&nbsp;{this.state.pageContent?.DLOCA}
                                      </div>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                      <div className="form-group">
                                        <b>{common.getTrad("Email")}:</b>&nbsp;{this.state.pageContent?.DCAPO}
                                      </div>
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                      <div className="form-group">
                                        <b>{common.getTrad("Telefono")}:</b>&nbsp;{this.state.pageContent?.NTEL1}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                :
                                <></>
                              }
                              {veicolo !== undefined && veicolo !== null ?
                                <>
                                  <div className="tab-pane fade" id="pills-veicolo" role="tabpanel" aria-labelledby="pills-veicolo-tab">
                                    <div className="row">
                                      <div className="col-xs-12 col-md-6">
                                        <div className="form-group">
                                          <b>{common.getTrad("Telaio")}:</b>&nbsp;{this.state.pageContent.NTELA}
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-6">
                                        <div className="form-group">
                                          <b>{common.getTrad("Cod. Modello")}:</b>&nbsp;
                                          {
                                            veicolo.CMODE
                                          }
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-6">
                                        <div className="form-group">
                                          <b>{common.getTrad("Desc. Veicolo")}:</b>&nbsp;
                                          {veicolo.DCOLO !== undefined && veicolo.DCOLO !== null ?
                                            veicolo.DVEIC + " " + veicolo.DCOLO
                                            :
                                            veicolo.DVEIC
                                          }
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-6">
                                        <div className="form-group">
                                          <b>{common.getTrad("Cilindrata")}:</b>&nbsp;
                                          {
                                            veicolo.NCILI
                                          }
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-6">
                                        <div className="form-group">
                                          <b>{common.getTrad("Stato Veicolo")}:</b>&nbsp;
                                          {veicolo.FSTAT !== undefined && veicolo.FSTAT !== null ?
                                            veicolo.FSTAT === "N" ?
                                              common.getTrad("Nuovo")
                                              :
                                              veicolo.FSTAT === "V" ?
                                                common.getTrad("Venduto")
                                                :
                                                veicolo.FSTAT === "S" ?
                                                  common.getTrad("Garanzia Scaduta")
                                                  :
                                                  <></>
                                            :
                                            <></>
                                          }
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-6">
                                        <div className="form-group">
                                          <b>{common.getTrad("KM/Miglia/Ore Percorsi")}:</b>&nbsp;{veicolo.NKMPE_PREC}
                                        </div>
                                      </div>
                                      <div className="col-xs-12 col-md-6">
                                        <div className="form-group">
                                          <b>{common.getTrad("Targa")}:</b>&nbsp;{veicolo.NTARG}
                                        </div>
                                      </div>
                                      {moment(veicolo.UIMMA).isValid() ?
                                        <div className="col-xs-12 col-md-6">
                                          <div className="form-group">
                                            <b>{common.getTrad("Data Immatr.")}:</b>&nbsp;{moment(veicolo.UIMMA).format('LL')}
                                          </div>
                                        </div>
                                        :
                                        <></>
                                      }
                                      {moment(veicolo.UGARA).isValid() ?
                                        <div className="col-xs-12 col-md-6">
                                          <div className="form-group">
                                            <b>{common.getTrad("Data Scadenza Garanzia Contrattuale")}:</b>&nbsp;{moment(veicolo.UGARA).format('LL')}
                                          </div>
                                        </div>
                                        :
                                        <></>
                                      }
                                    </div>
                                    {veicolo.propretario !== undefined && veicolo.propretario !== null ?
                                      <>
                                        {(veicolo.propretario.RACQU !== null && veicolo.propretario.RAGG1 !== null) ?
                                          <>
                                            <div className="row mt-3">
                                              <h4 className="col">{common.getTrad("Proprietario Veicolo")}</h4>
                                            </div>
                                            <div className="row">
                                              <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                  <b>{common.getTrad("Nominativo")}:</b>&nbsp;
                                                  {veicolo.propretario.RCLIE !== undefined ?
                                                    veicolo.propretario.RCLIE
                                                    :
                                                    veicolo.propretario.RACQU + " " + veicolo.propretario.RAGG1
                                                  }
                                                </div>
                                              </div>
                                              <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                  <b>{common.getTrad("Nazione")}:</b>&nbsp;
                                                  {common.object_value_in_array(window.cc.nazioni, 'CISO3TNA', veicolo.propretario.CNAZI) > -1 ?
                                                    window.cc.nazioni[common.object_value_in_array(window.cc.nazioni, 'CISO3TNA', veicolo.propretario.CNAZI)]['DLINGTNA']
                                                    :
                                                    veicolo.propretario.CNAZI
                                                  }
                                                </div>
                                              </div>
                                              <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                  <b>{common.getTrad("Località")}:</b>&nbsp;{veicolo.propretario.DLOAQ}
                                                </div>
                                              </div>
                                              <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                  <b>{common.getTrad("Indirizzo")}:</b>&nbsp;{veicolo.propretario.DINAQ}
                                                </div>
                                              </div>
                                              <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                  <b>{common.getTrad("Telefono")}:</b>&nbsp;{veicolo.propretario.NTEL1}
                                                </div>
                                              </div>
                                              <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                  <b>{common.getTrad("Cellulare")}:</b>&nbsp;{veicolo.propretario.NTEL2}
                                                </div>
                                              </div>
                                              <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                  <b>{common.getTrad("Email")}:</b>&nbsp;{veicolo.propretario.DCAPO}
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                          :
                                          <></>
                                        }
                                      </>
                                      :
                                      <></>
                                    }
                                  </div>
                                </>
                                :
                                <></>
                              }
                              {window.cc.csoft === 850036 || window.cc.csoft === 850038 ? 
                                <div
                                  className="tab-pane fade"
                                  id="pills-dispositivi-texa"
                                  role="tabpanel"
                                  aria-labelledby="pills-dispositivi-texa-tab"
                                >
                                  <table
                                    id="table_diagnosi_texa"
                                    className="table table-striped table-bordered"
                                    width="100%"
                                  ></table>
                                </div>
                                :
                                <></>
                              }
                              <div className="tab-pane fade" id="pills-garanzie" role="tabpanel" aria-labelledby="pills-garanzie-tab">
                                <table id="table_warranty" className="table table-striped table-bordered" width='100%'></table>
                              </div>
                              <div className="tab-pane fade" id="pills-tagliandi" role="tabpanel" aria-labelledby="pills-tagliandi-tab">
                                <table id="table_service" className="table table-striped table-bordered" width='100%'></table>
                              </div>
                              <div className="tab-pane fade" id="pills-attivazioni" role="tabpanel" aria-labelledby="pills-attivazioni-tab">
                                <table id="table_activation" className="table table-striped table-bordered" width='100%'></table>
                              </div>
                              <div className="tab-pane fade" id="pills-rimappature" role="tabpanel" aria-labelledby="pills-rimappature-tab">
                                <table id="RMtable" className="table table-striped table-bordered" width='100%'></table>
                              </div>
                              <div className="tab-pane fade innerTable" id="pills-ticket" role="tabpanel" aria-labelledby="pills-ticket-tab">
                                  <TicketTableFirebird
                                    innerTable={true}
                                    folder={this.state.pageContent.CFOLD}
                                    marche_attive={this.props.marche_attive}
                                    tipologieTicket={this.state.tipologie_ticket_attive}
                                    pageTitle={this.props.pageTitle}
                                    paginaDati={this.state.pagina}
                                    onClick={(tipoFunzione, params) => this.onClickPaging(tipoFunzione, params)}
                                    pathname={common.getTicketBackendUrl('/it/dealer/support-tools/ticket')}
                                    ticketType={"ticket_vehicle"}
                                    selectedStates={this.state.selectedStates}
                                    NTELA={this.state.pageContent.NTELA}
                                  >
                                  </TicketTableFirebird>
                              </div>
                              <div className="col">
                                {this.state.get_veicolo && moment(this.state.pageContent.update_data).isValid() ?
                                  <small>{common.getTrad("Dati aggiornati al {{update_data}}", { update_data: moment(this.state.pageContent.update_data).format('LLL') })}</small>
                                  :
                                  <></>
                                }
                              </div>
                            </div>
                          </>
                          :
                          <></>
                        }
                      </div>
                      :
                      <></>
                    }
                    <div className="tab active">
                      <form autoComplete="off" className="add_element" action="#" method="post" encType="multipart/form-data" onSubmit={this.passToDjango}>
                        <div className="row">

                          {this.state.editTicket === true ?
                            <div className="col-xl-12" style={{ display: "flex", justifyContent: "space-between" }}>
                              <h1>
                                {
                                  this.state.changeType ?
                                    common.getTrad(this.state.tipologie_ticket_attive[this.state.newTypeData.tipo].titolo)
                                    :
                                    common.getTrad(this.state.tipologie_ticket_attive[this.state.pageContent?.CCAUS].titolo)
                                }
                              </h1>
                              {this.state.userInfo.is_admin_ticket && this.state.userInfo.userInfo.GTSFINI.TICKET_MODIFICA_TIPOLOGIA == "S" && 
                                Object.keys(this.state.tipologie_ticket_attive).length > 1 && this.state.pageContent?.CAVTI == "05" ?
                                <span>
                                  <button type="button" className="btn btn-light" data-toggle="modal" data-target="#modalTicket"
                                  >
                                    <i className="fas fa-pencil-alt"></i> {common.getTrad("Modifica Tipologia")}
                                  </button>
                                  <ChangeTicketType
                                    pageContent={this.state.pageContent}
                                    marcaDefault={this.state.marcaDefault}
                                    tipologie_ticket_attive={this.state.tipologie_ticket_attive}
                                    marche_attive={this.state.marche_attive}
                                    renderFormTicket={this.renderModal}
                                    populateModal={this.populateModal}
                                    subType ={this.state.subType}
                                    tipoTicket={this.state.tipoTicket}
                                    sendData={this.dataFromModal}
                                  ></ChangeTicketType>
                                </span>
                                :
                                <></>
                              }
                            </div>
                            :
                            <></>
                          }
                          <div className="row" id="formContainer" style={{zIndex: '10'}}>
                            {this.state.editTicket === true ?
                              <>
                                <div className="col-xl-12">
                                  {this.state.tipoTicket === 'richiestaCOC' ?
                                  <></>
                                    :
                                    <div className="form-group">
                                      <label htmlFor="title"><b>{common.getTrad("Titolo")}</b> <span className="danger">*</span></label>
                                      <input autoFocus autoComplete="off" type="text" required className="form-control" id="title" maxlength="150" name="title" defaultValue={this.state.pageContent?.DDOCU} placeholder={common.getTrad("Inserisci il titolo")} />
                                    </div>
                                  }
                                </div>
                                {this.renderFormTicket()}
                              </>
                              :
                              <></>
                            }
                            {this.state.editTicket === true ?
                              <div className="col-xl-12 col-lg-12 col-xs-12">
                                <div className="form-row">
                                  <div className="form-group col bottoni_invio">
                                    <button id="sendToDjango" type="submit" className="btn btn-primary float-right">
                                      <div className="circle">
                                        {common.getTrad("Salva")}&nbsp;<i className="text"></i>
                                      </div>
                                    </button>
                                    <button id="annulla" type="button" onClick={this.confirmLeave} className="btn btn-light float-right mr-2">{common.getTrad("Annulla")}</button>
                                  </div>
                                </div>
                              </div>
                              :
                              <></>
                            }
                          </div>
                        </div>
                      </form>
                      {this.keyComments !== -1 ?
                        <div className="row mt-1">
                          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 tab-content">
                            <div className="content_ticket_form">
                              <h4>{common.getTrad("Storico Commenti")}</h4>
                              <hr />
                              <div className="page">
                                <div className="marvel-device nexus5">
                                  <div className="top-bar"></div>
                                  <div className="screen">
                                    <div className="screen-container">
                                      <div className="chat">
                                        <div className="chat-container">
                                          <div className="conversation-wrapper" style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: "20px"
                                          }}>
                                            <div className="conversation left" style={{
                                              flex: this.state.userInfo.userInfo.GTSFINI?.TICKET_THREAD_INTERNO === 'S' && this.state.userInfo.is_admin_ticket ? 1 : "0 0 50%",
                                              border: "1px solid #ddd",
                                              borderRadius: "8px",
                                              padding: "10px",
                                              backgroundColor: "#f2f2f2ba",
                                              boxShadow: "1px 1px 2px 1px #ddd"
                                              }}>
                                              <h5>{common.getTrad("Dealer Thread")}</h5>
                                              <div
                                                className="conversation conversation-messages"
                                                id="con-left"
                                                style={{
                                                  maxHeight: '560px', // altezza massima scrollabile
                                                  overflowY: 'auto',
                                                  paddingRight: '10px', // evita overlay della scrollbar
                                                  paddingLeft: '5px',
                                                }}
                                              >
                                                {this.state.pageContent.CAVTI === '00' ?
                                                  <div className="received message has_attachment" style={{paddingBottom: '30px'}}>
                                                    <h6>{common.getTrad('Errori da correggere')}</h6>
                                                      <div style={{ padding: '10px', background: 'white', borderRadius: '5px' }}>
                                                      <table className='errorTable'>
                                                        <tr>
                                                          <th>{common.getTrad('Nome campo')}</th>
                                                          <th>{common.getTrad('Tipo errore')} </th>
                                                        </tr>
                                                        {this.missingFieldsMsg()}
                                                        </table>
                                                      </div>
                                                  </div>
                                                  :
                                                  <>
                                                  </>
                                                }
                                                <div style={{ minHeight: '468px', position: 'relative', pointerEvents: 'none' }}>
                                                  <div style={{ pointerEvents: 'auto' }}>
                                                    {this.renderChatComments("D")}
                                                  </div>
                                                </div>
                                                {((this.state.editTicket === false && this.state.userInfo.is_admin_ticket) || (!this.state.userInfo.is_admin_ticket && this.state.editTicket === false && this.state.pageContent.CAVTI !== '90')) ?
                                                  <>
                                                    <div className="conversation-compose" style={{
                                                      overflow: 'unset',
                                                      position: 'sticky',
                                                      bottom: '0',
                                                      backgroundColor: '#f2f2f2ba',
                                                      zIndex: '10',
                                                      display: this.state.userInfo.userInfo.GTSFINI?.SOLO_THREAD_INTERNO === 'S' ? 'none' : 'blocked'
                                                      }}>
                                                      <form id="conversation" className="conversation-compose" type="post" style={{ overflow: 'unset', backgroundColor: '#f2f2f2ba' }} onSubmit={this.handleSubmit} encType="multipart/form-data">
                                                        <textarea required id="new_comment" style={{ backgroundColor: '#fff', borderRadius: "8px 0px 0px 8px" }} className="input-msg form-control" name="new_comment" placeholder={common.getTrad("Scrivi un commento")}></textarea>
                                                        {this.state.googleCloudBucketPath ?
                                                          <div className="photo" style={{ backgroundColor: '#f2f2f2ba' }}>
                                                            {this.state.userInfo?.userInfo?.auth && common.object_value_in_array(this.state.userInfo.userInfo.auth, "TDATI", "MS") > -1 ?
                                                              // Con permessi MySwan → dropdown
                                                              <div className="btn-group dropup" style={{ cursor: 'pointer', backgroundColor: '#f2f2f2ba'}}>
                                                                <span
                                                                  data-toggle="dropdown"
                                                                  aria-haspopup="true"
                                                                  aria-expanded="false"
                                                                  style={{ cursor: 'pointer'}}
                                                                >
                                                                  <i className="fas fa-paperclip ml-1 pt-3" title={common.getTrad("Carica un file")}></i>
                                                                </span>
                                                                <span className="dropdown-menu dropdown-menu-right" style={{ fontSize: '14px', minWidth: '200px' }}>
                                                                  <label htmlFor="file_comment" className="dropdown-item mb-0" style={{ cursor: 'pointer', fontWeight: 'normal' }}>
                                                                    {common.getTrad("Carica da dispositivo")}
                                                                  </label>
                                                                  <button type="button" className="dropdown-item" onClick={this.openMySwanModal}>
                                                                    {common.getTrad("Aggiungi da MySwan")}
                                                                  </button>
                                                                </span>
                                                              </div>
                                                              :
                                                              // Senza permessi → label standard originale
                                                              <label htmlFor="file_comment">
                                                                <i className="fas fa-paperclip ml-1" title={common.getTrad("Carica un file")}></i>
                                                              </label>
                                                            }
                                                            <input type="file" name="file_comment" id="file_comment" onChange={() => this.addTemporayFile('L')} />
                                                          </div>
                                                          :
                                                          <></>
                                                        }
                                                        <button id="saveComment" style={{ backgroundColor: '#fff'}} title={common.getTrad("Salva")} value="" className="send btn one" name="comment" type="submit">
                                                        <div className="circle">
                                                            <i className="fas fa-paper-plane"></i>
                                                        </div>
                                                      </button>
                                                      {this.stateAndComment()}
                                                    </form>
                                                    </div>
                                                    {this.state.file_info_upload !== undefined && this.state.file_info_upload !== null && this.state.file_info_upload !== '' ?
                                                      <div className="sw-alert alert alert-info mt-4">
                                                        <i className="fas fa-exclamation-circle"></i>&nbsp;
                                                        {common.getTrad("File selezionato")}: {this.state.file_info_upload}
                                                        &nbsp;&nbsp;<button type="button" class="close" title={common.getTrad("Elimina")} data-dismiss="alert" aria-label="Close" style={{ top: '-1px', position: 'relative'}} onClick={() => this.deleteTemporaryFile('L')} >
                                                          <span aria-hidden="true">&times;</span>
                                                        </button>
                                                      </div>
                                                      :
                                                      <></>
                                                    }
                                                  </>
                                                  :
                                                  ""
                                                }
                                              </div>
                                            </div>
                                            {this.state.userInfo.userInfo.GTSFINI?.TICKET_THREAD_INTERNO === 'S' && this.state.userInfo.is_admin_ticket ?
                                              <div className="conversation right" style={{
                                                flex: 1,
                                                border: "1px solid #ddd",
                                                borderRadius: "8px",
                                                padding: "10px",
                                                boxShadow: "1px 1px 2px 1px #ddd"
                                                }}>
                                                <h5>{common.getTrad("Internal Thread")}</h5>
                                                <div
                                                  className="conversation conversation-messages"
                                                  id="con-right"
                                                  style={{
                                                    maxHeight: '560px',
                                                    overflowY: 'auto',
                                                    paddingRight: '10px',
                                                    paddingLeft: '5px',
                                                  }}
                                                >
                                                  <div style={{ minHeight: '468px', position: 'relative', pointerEvents: 'none' }}>
                                                    <div style={{ pointerEvents: 'auto' }}>
                                                      {this.renderChatComments("I")}
                                                    </div>
                                                  </div>
                                                {((this.state.editTicket === false && this.state.userInfo.is_admin_ticket) || (!this.state.userInfo.is_admin_ticket && this.state.editTicket === false && this.state.pageContent.CAVTI !== '90')) ?
                                                  <>
                                                      <div className="conversation-compose" style={{
                                                        overflow: 'unset',
                                                        position: 'sticky',
                                                        bottom: '0',
                                                        backgroundColor: '#fff',
                                                        zIndex: '10' }}>
                                                      <form id="conversation2" className="conversation-compose" type="post" style={{ overflow: 'unset' }} onSubmit={this.handleSubmit} encType="multipart/form-data">
                                                          <textarea required id="new_comment2" style={{ backgroundColor: '#f2f2f2ba', borderRadius: "8px 0px 0px 8px" }} className="input-msg form-control" name="new_comment" placeholder={common.getTrad("Scrivi un commento")}></textarea>
                                                        {this.state.googleCloudBucketPath ?
                                                          <div className="photo">
                                                            <label htmlFor="file_comment2" >
                                                              <i className="fas fa-paperclip ml-1" title={common.getTrad("Carica un file")}></i>
                                                            </label>
                                                            <input type="file" name="file_comment" id="file_comment2" style={{display: "none"}} onChange={() => this.addTemporayFile('R')} />
                                                          </div>
                                                          :
                                                          <></>
                                                        }
                                                          <button id="saveComment2" style={{ backgroundColor: '#fff' }} title={common.getTrad("Salva")} value="" className="send btn two" name="comment" type="submit">
                                                          <div className="circle">
                                                            <i className="fas fa-paper-plane"></i>
                                                          </div>
                                                        </button>
                                                        {this.stateAndComment()}
                                                      </form>
                                                    </div>
                                                    {this.state.file_info_upload2 !== undefined && this.state.file_info_upload2 !== null && this.state.file_info_upload2 !== '' ?
                                                      <div className="sw-alert alert alert-info mt-4">
                                                        <i className="fas fa-exclamation-circle"></i>&nbsp;
                                                        {common.getTrad("File selezionato")}: {this.state.file_info_upload2}
                                                        &nbsp;&nbsp;<button type="button" class="close" title={common.getTrad("Elimina")} data-dismiss="alert" aria-label="Close" style={{ top: '-1px', position: 'relative' }} onClick={() => this.deleteTemporaryFile('R')} >
                                                          <span aria-hidden="true">&times;</span>
                                                        </button>
                                                      </div>
                                                      :
                                                      <></>
                                                    }
                                                  </>
                                                  :
                                                  ""
                                                }
                                              </div>
                                            </div>
                                            :
                                            <></>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        :
                        <></>
                      }
                    </div>
                  </>
                }
              </>
              :
              <></>
            }
          </>
          :
          this.state.newTicket ?
            <div className="col-xl-10 col-lg-9 col-md-8 col-sm-8 col-xs-8 linea_sfumata" id="content_page">
              <div id="notifica_messaggio"></div>
              <div className="row">
                <div class="col-12 mt-3 mb-2">
                  <h1>
                    {this.state.pageTitle}
                    <div class="content_titolo_int"></div>
                  </h1>
                </div>
              </div>
              {this.props.tipologie_ticket_attive === 'ERRORE' ?
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 content_testo">
                    <div className="content_filtro tab active col-xl-12">
                      <div className="content_testo">
                        <div className="clear sw-alert alert alert-danger mt-3">
                          <span dangerouslySetInnerHTML={{ __html: common.getTrad("I Ticket non stanno funzionando correttamente. Contatta il <b>supporto tecnico</b> se il problema persiste.") }} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                :
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="content_filtro tab active col-xl-12">
                    <h4>{common.getTrad("Apertura Ticket")}</h4>
                    <hr />
                  </div>
                  <div id="select_ticket_container" className="row content_filtro">
                    {this.props.marche_attive.length !== 1 ?
                      <FilterVM
                        folder={this.state.pageContent.CFOLD}
                        customClass="col-xl-6 col-lg-6"
                        marche_attive={this.props.marche_attive}
                        tableType='ticket_vehicle'
                        newTicket={this.state.newTicket}
                        onClick={(tipoFunzione, params) => this.clickBrands(tipoFunzione, params)}>
                      </FilterVM>
                      :
                      <></>
                    }
                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 row-eq-height">
                      <div className="col-12 p-0">
                        <p>{common.getTrad("Seleziona un tipo")}</p>
                        <div className="form-group">
                          <select disabled={is_disabled} className="form-control select2 select_ticket" autoComplete="off" id="select_ticket">
                            <option value=""></option>
                            {
                              Object.keys(tipologieTicket).map((key, i) => {
                                let value = tipologieTicket[key];
                                if(!value.no_insert)
                                  return (
                                    <option key={key} value={key}>{value.titolo}</option>
                                  )
                              })
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              {this.state.tipoTicket ?
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 tab-content">
                  {this.state.checkVinVehicle ?
                    <div id="filtri_files" className="col-12">
                      <div className="row content_filtro">
                        <FilterChassis
                          customClass={this.props.marche_attive !== undefined && this.props.marche_attive.length > 1 ? "col-xl-4 col-lg-4" : ""}
                          marche_attive={this.props.marche_attive}
                          request_url={this.generateVinVehicleUrl()}
                          marcaDefault={this.state.marcaDefault}
                          onClick={(response) => this.getResponse(response)}
                          newTicket={this.state.newTicket}
                          char_vin={this.state.userInfo.userInfo.GTSFINI?.CHAR_VIN_VALIDITY ? this.state.userInfo.userInfo.GTSFINI?.CHAR_VIN_VALIDITY : 0}
                        ></FilterChassis>
                      </div>
                      <div className="tab active">
                        <div className="col">
                          <div className="d-none d-md-block">
                            <h4>{common.getTrad("Dati del veicolo")}</h4>
                            <table id="dati_veicolo" className="table table-striped table-bordered dt-responsive nowrap mb-5" style={{ width: '100%' }}>
                              <tbody>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Marca")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.ZMAVE : ""}</td>
                                  <td className="voce_dati"><b>{common.getTrad("Stato")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded && this.state.tagliando.veicolo.FSTAT !== undefined && this.state.tagliando.veicolo.FSTAT !== null ?
                                      this.state.tagliando.veicolo.FSTAT === "N" ?
                                        common.getTrad("Nuovo")
                                        :
                                        this.state.tagliando.veicolo.FSTAT === "V" ?
                                          common.getTrad("Venduto")
                                          :
                                          this.state.tagliando.veicolo.FSTAT === "S" ?
                                            common.getTrad("Garanzia Scaduta")
                                            :
                                            <></>
                                      :
                                      <></>
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Ultima percorrenza registrata")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? (this.state.tagliando.veicolo.NKMPE_PREC + " KM") : ""}</td>
                                  <td className="voce_dati"><b>{common.getTrad("Cilindrata")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NCILI : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Descrizione")}</b></td>
                                  <td className="valore_dati">
                                    {
                                      vehicleLoaded ?
                                        this.state.tagliando.veicolo.DCOLO !== null && this.state.tagliando.veicolo.DCOLO !== undefined ?
                                          this.state.tagliando.veicolo.DVEIC + " " + this.state.tagliando.veicolo.DCOLO
                                          :
                                          this.state.tagliando.veicolo.DVEIC
                                        :
                                        ""
                                    }
                                  </td>
                                  <td className="voce_dati"><b>{common.getTrad("Matr. Motore")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NMOTO : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Cod. Modello")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.CMODE : ""}</td>
                                  <td className="voce_dati"><b>{common.getTrad("Data Immatr.")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.UIMMA ? moment(this.state.tagliando.veicolo.UIMMA).format('L') : "" : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Data Scadenza Garanzia Contrattuale")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.UGARA ? moment(this.state.tagliando.veicolo.UGARA).format('L') : "" : ""}</td>
                                  <td className="voce_dati"><b>{common.getTrad("Data Scadenza Garanzia Estesa")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.UGARE ? moment(this.state.tagliando.veicolo.UGARE).format('L') : "" : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Targa")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NTARG : ""}</td>
                                </tr>
                              </tbody>
                            </table>

                            <h4>{common.getTrad("Dati del propretario")}</h4>
                            <table id="dati_veicolo" className="table table-striped table-bordered dt-responsive nowrap mb-5" style={{ width: '100%' }}>
                              <tbody>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Nome")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded ?
                                      this.state.tagliando.veicolo.RACQU !== undefined && this.state.tagliando.veicolo.RACQU !== null ?
                                        this.state.tagliando.veicolo.RACQU
                                        :
                                        ""
                                      :
                                      ""
                                    }
                                  </td>
                                  <td className="voce_dati"><b>{common.getTrad("Cognome")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded ?
                                      this.state.tagliando.veicolo.RAGG1 !== undefined && this.state.tagliando.veicolo.RAGG1 !== null ?
                                        this.state.tagliando.veicolo.RAGG1
                                        :
                                        ""
                                      :
                                      ""
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Nazione")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded && this.state.tagliando.veicolo.CNAZI ?
                                      common.object_value_in_array(window.cc.nazioni, 'CISO3TNA', this.state.tagliando.veicolo.CNAZI) > -1 ?
                                        window.cc.nazioni[common.object_value_in_array(window.cc.nazioni, 'CISO3TNA', this.state.tagliando.veicolo.CNAZI)].DNAZITNA
                                        :
                                        this.state.tagliando.veicolo.CNAZI
                                      :
                                      ""
                                    }
                                  </td>
                                  <td className="voce_dati"><b>{common.getTrad("Località")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.DLOAQ : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Indirizzo")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.DINAQ : ""}</td>
                                  <td className="voce_dati"><b>{common.getTrad("Telefono")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NTEL1 : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Cellulare")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NTEL3 : ""}</td>
                                  <td className="voce_dati"><b>{common.getTrad("Email")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.DCAPO : ""}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="d-md-none">
                            <h4>{common.getTrad("Dati del veicolo")}</h4>
                            <table id="dati_veicolo" className="table table-striped table-bordered dt-responsive nowrap mb-5" style={{ width: '100%' }}>
                              <tbody>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Marca")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.ZMAVE : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Stato")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded && this.state.tagliando.veicolo.FSTAT !== undefined && this.state.tagliando.veicolo.FSTAT !== null ?
                                      this.state.tagliando.veicolo.FSTAT === "N" ?
                                        common.getTrad("Nuovo")
                                        :
                                        this.state.tagliando.veicolo.FSTAT === "V" ?
                                          common.getTrad("Venduto")
                                          :
                                          this.state.tagliando.veicolo.FSTAT === "S" ?
                                            common.getTrad("Garanzia Scaduta")
                                            :
                                            <></>
                                      :
                                      <></>
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Ultima percorrenza registrata")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? (this.state.tagliando.veicolo.NKMPE_PREC + " KM") : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Cilindrata")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NCILI : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Descrizione")}</b></td>
                                  <td className="valore_dati">
                                    {
                                      vehicleLoaded ?
                                        this.state.tagliando.veicolo.DCOLO !== null && this.state.tagliando.veicolo.DCOLO !== undefined ?
                                          this.state.tagliando.veicolo.DVEIC + " " + this.state.tagliando.veicolo.DCOLO
                                          :
                                          this.state.tagliando.veicolo.DVEIC
                                        :
                                        ""
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Cilindrata")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NCILI : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Cod. Modello")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.CMODE : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Matr. Motore")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NMOTO : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Targa")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NTARG : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Data Immatr.")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.UIMMA ? moment(this.state.tagliando.veicolo.UIMMA).format('L') : "" : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Data Scadenza Garanzia Contrattuale")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.UGARA ? moment(this.state.tagliando.veicolo.UGARA).format('L') : "" : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Data Scadenza Garanzia Estesa")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.UGARE ? moment(this.state.tagliando.veicolo.UGARE).format('L') : "" : ""}</td>
                                </tr>
                              </tbody>
                            </table>

                            <h4>{common.getTrad("Dati del propretario")}</h4>
                            <table id="dati_veicolo" className="table table-striped table-bordered dt-responsive nowrap mb-5" style={{ width: '100%' }}>
                              <tbody>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Nome")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded ?
                                      this.state.tagliando.veicolo.RACQU !== undefined && this.state.tagliando.veicolo.RACQU !== null ?
                                        this.state.tagliando.veicolo.RACQU
                                        :
                                        ""
                                      :
                                      ""
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Cognome")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded ?
                                      this.state.tagliando.veicolo.RAGG1 !== undefined && this.state.tagliando.veicolo.RAGG1 !== null ?
                                        this.state.tagliando.veicolo.RAGG1
                                        :
                                        ""
                                      :
                                      ""
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Nazione")}</b></td>
                                  <td className="valore_dati">
                                    {vehicleLoaded && this.state.tagliando.veicolo.CNAZI ?
                                      common.object_value_in_array(window.cc.nazioni, 'CISO3TNA', this.state.tagliando.veicolo.CNAZI) > -1 ?
                                        window.cc.nazioni[common.object_value_in_array(window.cc.nazioni, 'CISO3TNA', this.state.tagliando.veicolo.CNAZI)].DNAZITNA
                                        :
                                        this.state.tagliando.veicolo.CNAZI
                                      :
                                      ""
                                    }
                                  </td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Località")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.DLOAQ : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Indirizzo")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.DINAQ : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Telefono")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NTEL1 : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Cellulare")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.NTEL3 : ""}</td>
                                </tr>
                                <tr>
                                  <td className="voce_dati"><b>{common.getTrad("Email")}</b></td>
                                  <td className="valore_dati">{vehicleLoaded ? this.state.tagliando.veicolo.DCAPO : ""}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xl-12 col-lg-12 col-xs-12">
                          <div className="form-row">
                            <div className="form-group col bottoni_invio">
                              <button disabled={!vehicleLoaded} type="button" className="btn btn-primary float-right" onClick={() => { this.setState({ checkVinVehicle: false }); this.hideFilterMultibrand(); }}>{common.getTrad("Prosegui")}</button>
                              <button id="annulla2" type="button" className="btn btn-light float-right mr-2">{common.getTrad("Annulla")}</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    :
                  <div className="tab active ">
                    <form autoComplete="off" className="add_element" action="#" method="post" encType="multipart/form-data" onSubmit={this.passToDjango}>
                      <div className="row">
                        <div className="col-xl-12">
                          <h1>
                            {this.state.marcaDefault !== undefined ?
                              common.getTrad(this.state.tipologie_ticket_attive[this.state.tipoTicket].titolo)
                              :
                              this.state.tipologie_ticket_attive[this.state.tipoTicket].titolo
                            }</h1>
                        </div>
                        <div className="col-xl-12">
                            {window.cc.csoft === 850038 && this.state.tipoTicket === 'richiestaCOC' ?
                              <p className="text-danger"><b>{common.getTrad("Attenzione: con questo ticket possono essere richiesti solo COC di veicoli piena potenza. Per richieste di depotenziamento utilizzare il ticket dedicato.")}</b></p>
                            :
                            <></>
                            }
                            {(window.cc.csoft === 850038 && this.state.tipoTicket === 'richiestaCOC') || (window.cc.csoft === 850038 && this.state.tipoTicket === 'richiestaCOCdepo') ?
                            <></>
                            :
                          <div className="form-group">
                              <label htmlFor="title"><b>{common.getTrad("Titolo")}</b> <span className="danger">*</span></label>
                              <input autoFocus autoComplete="off" type="text" required className="form-control" id="title" maxlength="150" name="title" placeholder={common.getTrad("Inserisci il titolo")} />
                          </div>
                            }
                        </div>
                        {this.renderFormTicket()}
                        {this.state.googleCloudBucketPath && this.state.indexTitle === false ?
                          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                              <label htmlFor="file_multiple">{common.getTrad("File allegato")}</label>
                              <div>
                                <p className="text-muted">
                                  <span className="Trad_dimensione_massima_200MB"></span>
                                </p>
                                <input type="file" name="file_multiple" id="file_multiple" className="inputfile inputfile-6" multiple />
                                <label htmlFor="file_multiple">
                                  <span className="span_label_file"></span>
                                  <strong className="Trad_scegli_file"></strong>
                                </label>
                                <div id="data-pre" className="d-flex flex-wrap"></div>
                              </div>
                            </div>
                          </div>
                          :
                          <></>
                        }
                      </div>
                      <div className="row">
                        <div className="col-xl-12 col-lg-12 col-xs-12">
                          <div className="form-row">
                            <div className="form-group col bottoni_invio">
                              <button id="creaTicket" type="submit" className="btn btn-primary float-right">
                              <div className="circle">                            
                                {common.getTrad("Salva")}&nbsp;<i className="text"></i>
                              </div>
                              </button>
                              {this.state.isTicketVehicle ?
                                <button type="button" className="btn btn-light float-right mr-2" onClick={() => this.setState({ checkVinVehicle: true, autoCompleteForm: true })}>{common.getTrad("Torna indietro")}</button>
                                :
                              <button id="annulla2" type="button" className="btn btn-light float-right mr-2">{common.getTrad("Annulla")}</button>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  }
                </div>
                :
                <></>
              }
            </div>
            :
            <></>
        }
        <div className="modal fade" id="div_upload_my_swan" role="dialog" aria-hidden="true">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{common.getTrad('Aggiungi allegato da MySwan')}</h5>
                <button className="close close-upload-modal" type="button" data-dismiss="modal">×</button>
              </div>
              <div className="modal-body">
                <div className="container-fluid">
                  <div className="form-group" style={{ marginBottom: '10px' }}>
                    <div className="input-group input-group-sm">
                      <span className="input-group-addon" style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 10px',
                        lineHeight: 1
                      }}>
                        <i className="fa fa-search"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={common.getTrad("Filtra per descrizione, telaio o targa")}
                        value={this.state.mySwanFilter || ''}
                        onChange={(e) => this.setState({ mySwanFilter: e.target.value })}
                      />
                    </div>
                  </div>

                  <div id="myswan-image-grid" className="myswan-grid">
                    {this.state.mySwanLoading ?
                      <div className="text-center" style={{ width: '100%', padding: '30px' }}>
                        <i className="fa fa-spinner fa-spin fa-2x"></i>
                      </div>
                      :
                      (() => {
                        const q = (this.state.mySwanFilter || '').trim().toLowerCase();
                        const filtered = (this.state.mySwanImages || []).filter(item => {
                          if (!q) return true;
                          return [item.description, item.frame_number, item.plate_number]
                            .filter(Boolean).join(' ').toLowerCase().includes(q);
                        });

                        if (filtered.length === 0) {
                          return (
                            <div className="myswan-empty text-center">
                              <i className="fa fa-image" style={{ fontSize: '2rem', display: 'block', marginBottom: '10px', color: '#ccc' }}></i>
                              <p>{common.getTrad("Nessuna immagine da mostrare")}</p>
                            </div>
                          );
                        }

                        return filtered.map((item, index) => {
                          const fileType = this.getMySwanFileType(item);
                          const isSelected = this.state.mySwanSelectedUrls.includes(item.url);

                          return (
                            <div
                              key={item.id || index}
                              className={'myswan-item' + (isSelected ? ' selected' : '')}
                              onClick={() => this.toggleMySwanImage(item.url)}
                            >
                              <div className="myswan-preview">
                                {fileType === 'image' ?
                                  <img src={item.url} alt={`Anteprima ${index + 1}`} />
                                  :
                                  (() => {
                                    const { icon, color } = this.getMySwanFileIcon(fileType);
                                    const filename = item.original_name || item.url.split('?')[0].split('/').pop();
                                    return (
                                      <div className="myswan-file-icon">
                                        <i className={icon} style={{ color }}></i>
                                        <span className="myswan-filename" title={filename}>{filename}</span>
                                      </div>
                                    );
                                  })()
                                }
                              </div>

                              {/* Metadati sempre presenti */}
                              <div className="myswan-meta">
                                {[
                                  { label: common.getTrad("Descrizione"), value: item.description },
                                  { label: common.getTrad("Telaio"), value: item.frame_number },
                                  { label: common.getTrad("Targa"), value: item.plate_number },
                                ].map(({ label, value }) => (
                                  <p key={label}>
                                    <strong>{label}:</strong> {value ?? ''}
                                  </p>
                                ))}
                              </div>
                            </div>
                          );
                        });
                      })()
                    }
                  </div>
                  <div className="form-group row" style={{ marginTop: '16px' }} hidden>
                    <div className="col-sm-2">
                      <label className="control-label styled-label" htmlFor="DFOTO">{common.getTrad("Note")}</label>
                    </div>
                    <div className="col-sm-10">
                      <input name="DFOTO" id="DFOTO" defaultValue="" className="form-control input-sm" type="text" maxLength="150" />
                    </div>
                  </div>

                </div>
              </div>
              <div className="modal-footer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div className="checkbox" style={{ margin: 0 }}>
                    <label style={{ fontWeight: 'normal', marginBottom: 0 }}>
                      <input
                        type="checkbox"
                        checked={this.state.mySwanDeleteAfterSave}
                        onChange={(e) => this.setState({ mySwanDeleteAfterSave: e.target.checked })}
                      />
                      {' '}{common.getTrad("Elimina da MySwan i contenuti importati")}
                    </label>
                  </div>
                </div>
                <div>
                  <button className="btn btn-default close-upload-modal" data-dismiss="modal">
                    {common.getTrad("Chiudi")}
                  </button>
                  {' '}
                  <button
                    id="myswan-save"
                    className="btn btn-primary"
                    disabled={this.state.mySwanSelectedUrls.length === 0 || this.state.mySwanSaving}
                    onClick={this.state.newTicket ? this.saveMySwanFiles : this.saveMySwanFilesFromComment}
                  >
                    {this.state.mySwanSaving ?
                      <><i className="fa fa-spinner fa-spin mr-1"></i>{common.getTrad("Caricamento...")}</>
                      :
                      common.getTrad("Aggiungi")
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

}

class ContentCreators extends React.Component {
  render() {
    const custom_creators = common.customCreators(this.props.creators)
    return <span data-toggle="tooltip" data-placement="top" title={common.getTrad("Pubblicato da")}><i className="fas fa-user"></i>&nbsp;{custom_creators}</span>
  }
}

class ContentBrand extends React.Component {
  render() {
    var brand = this.props.content.subjects.find(a => a.includes("sw-brand"));
    if (brand !== undefined && brand.length > 0) {
      brand = brand.split('sw-brand-')[1];
    }
    var indexBrand = common.object_value_in_array(window.cc.marche_portale, 'ZFORN', brand);
    if (window.cc.marche_portale !== undefined && window.cc.marche_portale[indexBrand] !== undefined)
      return <span data-toggle="tooltip" data-placement="top" title={common.getTrad("Pubblicato da")}><i className="fas fa-tag"></i>&nbsp;
        {window.cc.marche_portale[indexBrand].DFORN}
      </span>;
    else
      return ""
  }
}

export default PageTicketFirebird;
export { ContentCreators };
export { ContentBrand };